<template>
  <div class="content-body">
    <el-drawer :visible="drawer" direction="ttb" :show-close="false" size="100%" :withHeader="false"
      :destroy-on-close="true" :before-close="handleClose">
      <!--      挂单      -->
      <template v-if="type === 1">
        <div class="pendingOrder" @keyup="monitorInput">
          <!--      关闭       -->
          <div class="close">
            <div class="singInfo">
              <span>挂单 <i>{{ orderDataHasBeenPosted.length }}</i> 张</span>
              <div class="singleNumberInput"><input type="number" placeholder="手牌号" ref="singleNumberInputRef"
                  v-model="odd" @blur="handCheckList(odd)" /> <span class="iconfont icon-guanbi"
                  @click="handCheckList((odd = ''))"></span></div>
            </div>
            <div class="timeBox">
              <el-date-picker v-model="checkOrdersByDate"
                @change="$emit('getTheListOfOrderingData', { dataTime: checkOrdersByDate, key: odd })"
                range-separator="至" type="daterange" :append-to-body="true" size="mini" :editable="false"
                value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <i style="color: #7a7a7a">合单时以首选单为主单！</i>
            <div class="operation">
              <div :class="combinedSingularStat ? 'active' : ''" @click="consolidateOrders"><span
                  class="iconfont icon-hebing"></span> <span>合并</span></div>
              <div @click="handleClose"><span class="iconfont icon-guanbi"></span></div>
            </div>
          </div>
          <!--      挂单       -->
          <div class="content-order">
            <div :class="item.memberId ? 'content-order-item active' : 'content-order-item'"
              v-for="(item, index) in pendingOrderList" :key="item.id">
              <div class="singleEnd">
                <span>
                  <i v-show="item.handBrand" @click="updateTheHandNumber(item)" style="font-size: 20px">{{
                    item.handBrand }}</i>
                  <i v-show="item.resource === 1" @click="updateTheHandNumber(item)"
                    :class="item.handBrand ? 'iconfont icon-weixin' : 'iconfont icon-bianhao'"
                    :style="item.handBrand ? { fontSize: '24px', color: 'rgb(0, 200, 0)' } : { fontSize: '24px', color: 'rgb(204, 0, 153)' }">
                  </i>
                  <i v-show="item.memberName" class="member-name"  style="color: rgb(0, 200, 0);">{{ item.memberName | nameMask }}</i>
                  <i v-show="item.memberId" style="text-decoration: underline; color: rgb(169, 119, 2)">{{
                    item.memberMobile }}</i> <i v-show="item.resource !== 1 && !item.memberId">散客单</i>
                </span>
                <span :class="item.sign ? 'active' : ''" @click="updateTag(item)"></span>
              </div>
              <div class="orderNo">
                <span>订单号:</span> <span>{{ item.orderNo }}</span>
              </div>
              <div class="orderTime">
                <span>{{ item.addDate | dateType }}</span>
                <span>
                  <i class="iconfont icon-daojishi"></i> <i>{{ orderTimeTiming[index] }}</i>
                </span>
              </div>
              <div class="informationOfEmployees">
                <div class="slide">
                  <span :style="item.memberId ? { color: '#00ff37' } : { color: '#20993a' }"
                    v-for="(employeeItem, index) in employeeWeightRemoval(item.employeeMap)" :key="index"><i>{{
                      employeeItem.employeeNo }}</i>{{ employeeItem.employeeName }}</span>
                </div>
              </div>
              <div class="unitPriceSheet">
                <table cellspacing="0">
                  <tr>
                    <td>品项</td>
                    <td>原价</td>
                  </tr>
                  <tr v-for="items in item.torderPpItems" :key="items.id">
                    <td>{{ items.itemName }}</td>
                    <td>{{ items.price | amountType }}</td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      合计：<i style="color: red">{{ totalOrderPrice(item.torderPpItems) | amountType }}</i>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="operation">
                <!--  -->
                <span @click="cancellationOfOrder(item.id)" style="background-color: rgba(229, 229, 229, 0.83);;"> <i class="iconfont icon-shanchu1"></i> </span>
                <!-- <span
                  @click="takeTheOrder(item, item.handBrand)">取单</span> -->
                  <span @click="handleTakeOrder(item)">取单</span>

              </div>
            </div>
          </div>
          <!--       员工数据         -->
          <div class="employeeData">
            <div
              :class="idOfTheCurrentlySelectedEmployee === item.id ? 'employeeData-time active' : 'employeeData-time'"
              v-for="item in pendingEmployee" :key="item.id" @click.stop="inquireOrdersAccordingToStaff(item.id)">
              <span class="quantity">{{ item.num }}</span>
              <div class="content">
                <span>{{ item.employeeName }}</span> <span>{{ item.employeeNo }}</span>
              </div>
            </div>
          </div>
          <!--         自定义日期筛选组件          -->
          <el-drawer :visible.sync="dateFilteringPopsUp" direction="btt" size="45%" :withHeader="false"
            :append-to-body="true">
            <div class="dateSelector">
              <timeHorizon v-model="checkOrdersByDate"></timeHorizon>
            </div>
          </el-drawer>

          <el-dialog title="选择手牌号" :visible.sync="theHandNumberPopsUp" :append-to-body="true"
            custom-class="handNumberScreeningClose" :before-close="closeTheHandNumber" width="70%">
            <div class="handNumberScreening">
              <span v-for="item in defaultHandNumber" :key="item.hand"
                :class="occupied.indexOf(item.hand) !== -1 ? 'active' : ''" @click.stop="changeHand(item.hand)"> #{{
                  item.hand }} </span>
            </div>
            <div class="manualInput">
              <span>手动输入手牌号</span> <span><input type="text" maxlength="3" placeholder="请输入手牌号" v-model="addOdd"
                  oninput="value=value.replace(/[^0-9.]/g,'')" /><i @click.stop="changeHand(addOdd)">确定</i></span>
            </div>
          </el-dialog>
        </div>
      </template>
      <!--      会员充值    -->
      <template v-if="type === 2">
        <div class="memberTopUp">
          <!--      关闭       -->
          <div class="close">
            <div class="singInfo">
              <span>会员充值</span>

              <!-- 结算订单是否发送消费类短信 -->
              <div class="mies" @click="isMies = !isMies"><span :class="isMies ? 'active' : ''"></span>
                <span>发送消费信息</span>
              </div>

              <!-- 订单流水单号 -->
              <div class="orderTrackingNumber"><span>客数：</span> <input type="text" v-border_color
                  v-model.number="customerCount" oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 50px; margin-right: 10px" /></div>

              <div class="orderTrackingNumber"><span>流水单号：</span> <input type="text" v-border_color v-model="billNumber"
                  placeholder="请输入流水单号" oninput="value=value.replace(/[^0-9.]/g,'')" /></div>
            </div>
            <div class="operation">
              <div :class="whetherTheTopUpOrderIsPayable ? 'active' : ''" @click="confirmRecharge"><span
                  class="iconfont icon-jiesuan"></span> <span>确认充值</span></div>
              <div @click="handleClose"><span class="iconfont icon-guanbi"></span></div>
            </div>
          </div>
          <!--         充值          -->
          <div class="rechargeBody">
            <div class="rechargeBody-left">
              <div class="inputContent">
                <div class="inputContent-item"><span>充值金额：</span> <input v-border_color type="text"
                    v-model.trim="rechargeObject.rechargeAmount" onfocus="this.select()" @keyup="defaultRechargeAmount"
                    @blur="calculateTheTopUpPerformance" oninput="value=value.replace(/[^0-9.]/g,'')" /></div>
                <div class="inputContent-item"><span>赠送金额：</span> <input type="text"
                    v-model.trim="rechargeObject.amountOfGift" onfocus="this.select()"
                    oninput="value=value.replace(/[^0-9.]/g,'')" /></div>
                <div class="inputContent-item">
                  <template>
                    <span>优惠金额：</span> <input type="text" v-model.trim="rechargeObject.discountAmount"
                      onfocus="this.select()" oninput="value=value.replace(/[^0-9.]/g,'')" />
                  </template>
                </div>
              </div>
              <template v-if="transferCardInformation">
                <div class="transferCardInfo">
                  <span>
                    <i class="iconfont icon-chacha" @click="transferCardInformation = null"></i> <i>{{
                      transferCardInformation.cardName }}</i>
                  </span>
                </div>
              </template>
              <template v-else>
                <template v-if="membershipCardTransferList.length <= 0">
                  <div class="transferCard"><span class="iconfont icon-zhuanhuan active"></span> <span
                      class="active">会员升降卡</span></div>
                </template>
                <template v-else>
                  <div class="transferCard"
                    @click="openTransferCard(true, currentlySelectedCard.tmemberCard.tenantCardId)"><span
                      class="iconfont icon-zhuanhuan"></span> <span>会员升降卡</span></div>
                </template>
              </template>
            </div>

            <div class="rechargeBody-right">
              <!--            充值会员详情            -->
              <div class="memberInformation">
                <div class="membertitle"><span class="iconfont icon-huiyuanqiaguanli"></span> <span> 会员卡详情</span></div>
                <div class="cardInformation">
                  <!--        会员卡信息            -->
                  <template>
                    <div class="otherOperations">
                      <div class="card-Info-content">
                        <div class="card-title">
                          <div class="card-info-name">
                            <span>{{ currentlySelectedCard.tmemberCard.cardName }}</span> <span>{{
                              currentlySelectedCard.tmemberCard.cardTypeName }}</span>
                          </div>
                          <template>
                            <div class="cardBalance">
                              <div class="kagin">
                                <div class="cardBalance-content">
                                  <span>卡余额:</span> <span>{{ (Number(currentlySelectedCard.tmemberCard.initAmount) +
                                    Number(currentlySelectedCard.tmemberCard.givenAmount)) | amountType }}</span>
                                </div>
                                <div class="kagin-content">
                                  <span>本金:</span> <span>{{ currentlySelectedCard.tmemberCard.initAmount | amountType
                                  }}</span> <span>赠金:</span> <span>{{ currentlySelectedCard.tmemberCard.givenAmount |
                                      amountType }}</span>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>

                        <div class="availabilityPeriod">
                          <div class="cardRemarks">
                            <span>卡备注：</span> <span
                              style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">{{
                                currentlySelectedCard.tmemberCard.remark }}</span>
                          </div>
                          <div class="periodOfValidity">
                            <span>有效期：</span> <span>{{ currentlySelectedCard.tmemberCard.effectiveDays |
                              filterCalculationCardValidityPeriod
                            }}期</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>

              <!--            销售员工添加                -->
              <div class="Sub-card-item-yuangong">
                <div class="List-of-sub-card-items">
                  <div class="addOnSales" @click.stop="addTopUpStaff">
                    <span class="iconfont icon-a-xiaoshou2"></span> <span><i
                        style="font-size: 18px; font-weight: bold">+</i>充值员工</span>
                  </div>
                  <div class="vessel">
                    <div class="market" v-for="(item, index) in topUpSalesStaffList" :key="index">
                      <span>{{ item.employeeName }}</span>
                      <div class="market-info">
                        <span>销售</span>
                        <span>
                          <template v-if="item.achievement">
                            <input type="text" v-model="item.achievement"
                              :disabled="whetherToDisablePerformanceModification || item.brokerageClass === 'no'"
                              onfocus="this.select()" />
                          </template>
                          <template v-else>
                            <input type="text" v-model="item.percentage"
                              :disabled="whetherToDisablePerformanceModification || item.brokerageClass === 'no'"
                              onfocus="this.select()" />
                          </template>
                          <i v-if="item.brokerageClass !== 'no'" class="iconfont icon-bianji1"></i>
                        </span>
                      </div>
                      <span class="iconfont icon-closel" @click.stop="removeAnEmployee(index)"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="achievements" v-if="departmentList === 1" style="padding-left: 0;padding-top: 10px">
                <span>部门业绩:</span>
                <div>
                  <div class="assigned">
                    <div style="padding-right: 10px;height: 28px; line-height: 24px">
                      <span class="f20 text-primary">【</span>
                      <!--
                                <el-tooltip class="item" effect="dark" content="点击查看" placement="bottom" :disabled="totalCount === 0">
                                  <div class="div-Posting" @click="isInputShow">
                                    <span class="f20 text-primary">【</span><span>待分配:</span> <u>{{ totalCount }}</u>
                                  </div>
                                </el-tooltip> -->
                    </div>
                    <div v-for="item in isDepartmentalPerformance" :key="item.departmentId" style="padding-right: 5px">
                      <div v-if="item.departmentName !== ''">
                        <span class="text-primary">{{ item.departmentName }}: </span>
                        <el-input size="mini" style="width: 50px;" v-model="item.achievement"
                          :oninput="onInputNumPoint" />
                      </div>
                    </div>
                    <span class="f20 text-primary">】</span>
                  </div>
                </div>
              </div>
              <!--            付款信息              -->
              <div class="particulars">
                <div class="particulars-title"><span class="iconfont icon-dingdan"></span> <span>付款方式</span></div>
                <div class="order-content">
                  <div class="order-content-item" v-for="item in clearingForm" :key="item.iconfont"
                    @click="topUpPaymentAmount(item)">
                    <div class="typeOfPayment">
                      <span>
                        <svg class="icon" aria-hidden="true">
                          <use :href="`#${item.iconfont}`"></use>
                        </svg>
                      </span>
                      <span>{{ item.name }}</span> <span
                        :class="item.name === '智慧支付' && globalPaymentStatus === '1' ? 'money active' : 'money'"
                        v-if="item.paymentAmount > 0">{{ item.paymentAmount | amountType }}</span>
                    </div>
                  </div>
                </div>
                <div class="adjustedPayment">
                  <div class="cutOffRule"></div>
                  <!--            支付调整           -->
                  <div class="order-content-item" @click="adjustedPayment">
                    <div class="typeOfPayment">
                      <span>
                        <svg class="icon" aria-hidden="true">
                          <use href="#icon-hunhe"></use>
                        </svg>
                      </span>
                      <span>调整支付</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--        内层抽屉         -->
          <el-drawer :append-to-body="true" size="40%" :show-close="false" :withHeader="false"
            :before-close="innerDrawerHandleClose" :visible.sync="innerDrawer">
            <div class="mixedPayment">
              <div class="mixedPayment-title">
                <span>支付详情，共需支付：<i>{{ settlementAmount | amountType }}</i></span>
                <span class="iconfont icon-guanbi" @click="innerDrawerHandleClose"></span>
              </div>
              <!--            修改支付方式                -->
              <div class="modeOfPaymentList">
                <div class="modeOfPaymentList-item topUp" v-for="item in modifyPaymentAmount" :key="item.name">
                  <span style="white-space: nowrap">{{ item.name }}:</span> <input type="text" v-model="item.money"
                    @blur="excessOfAmount" oninput="value=value.replace(/[^0-9.]/g,'')" />
                  <template v-if="item.name === '智慧支付'">
                    <span @click="smartPayment">支付</span>
                  </template>
                </div>
              </div>
            </div>
          </el-drawer>
          <!--        员工信息            -->
          <el-dialog :visible.sync="topUpEmployeeShow" width="50%" title="选择员工" :append-to-body="true"
            :close-delay="false" :before-close="closeTheMembershipScreeningPopup">
            <div class="employeeList">
              <div class="confirm" @click="firmChangeOrder('topUp')">确定</div>
              <div class="dataBox">
                <div class="con" v-for="item in topUpEmployeeList" :key="item.postName">
                  <div class="position">
                    <span class="iconfont icon-zhiwei"></span> <span>{{ item.postName }}</span>
                  </div>
                  <div class="staff">
                    <div :class="subItem.label ? 'staff-item active' : 'staff-item'"
                      v-for="subItem in item.employeeDataList" :key="subItem.id" @click="addATopUpCardForSale(subItem)">
                      <span>{{ subItem.employeeNo }}</span> <span>{{ subItem.employeeName }}</span>

                      <span>
                        <i v-show="subItem.num">{{ subItem.num }}</i> <i v-show="subItem.num"
                          class="iconfont icon-chacha" @click.stop="deleteEmployeeData(subItem.id)"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>
          <!--        转卡弹窗            -->
          <el-dialog :visible.sync="memberTransferCardBoxShow" width="680px" title="选择会员卡" :append-to-body="true"
            :before-close="closeTheMembershipScreeningPopup">
            <div class="membershipCardBox">
              <div :class="item.sign ? 'member-card-item active' : 'member-card-item'"
                v-for="item in membershipCardTransferList" :key="item.id" @click="selectTransferCardRechargeCard(item)">
                <span>{{ item.cardName }}</span> <span>{{ item.cardNo }}</span>
              </div>
            </div>
          </el-dialog>
          <!--         智慧支付           -->
          <el-drawer :append-to-body="true" size="40%" :show-close="true" :withHeader="false"
            :before-close="closeTheScanCodePaymentWindow" :visible.sync="intelligentPaymentState">
            <div class="smartPayment">
              <div class="wisdomPaysTitle">
                <span>您当前正在通过</span>
                <span class="paymentMethodDetails">
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use href="#icon-shoukuan"></use>
                    </svg>
                  </span>
                  <span>智慧支付</span>
                  <span v-show="!innerDrawer">{{
                    clearingForm.reduce((pv, cu) => {
                      if (cu.name === "智慧支付") return accuracyCheck(pv, cu.paymentAmount);
                      else return pv;
                    }, 0) | amountType
                  }}</span>
                  <span v-show="innerDrawer">{{
                    modifyPaymentAmount.reduce((pv, cu) => {
                      if (cu.name === "智慧支付") return accuracyCheck(pv, cu.money);
                      else return pv;
                    }, 0) | amountType
                  }}</span>
                </span>
              </div>
              <div class="paymentModeSwitching">
                <span :class="smartPaymentMethod === '0' ? 'active' : ''"
                  @click="switchingPaymentMethods('0', 'topUp')">商家扫码收款</span> <span
                  :class="smartPaymentMethod === '1' ? 'active' : ''"
                  @click="switchingPaymentMethods('1', 'topUp')">顾客扫码收款</span>
              </div>

              <div class="collectionContents">
                <div class="merchantScanningCode" v-show="smartPaymentMethod === '0'">
                  <div class="paymentContent"><input type="text" ref="scanToPay" placeholder="请使用扫码枪扫码输入"
                      :value="codeNumber" @keydown="scanCodeGunInput" oninput="value=value.replace(/[^0-9.]/g,'')" />
                    <span>支付</span>
                  </div>
                </div>
                <div class="customerScanCode" v-show="smartPaymentMethod === '1'">
                  <div class="paymentContent">
                    <div class="payBox">
                      <template>
                        <img :src="paymentCardPaymentAddress" alt="暂无开通拉卡拉" />
                      </template>
                      <template v-if="payState === 100">
                        <div class="payImg"><span class="iconfont icon-zhifuchenggong"></span> <span>支付中</span></div>
                      </template>
                      <template v-else-if="payState === 300">
                        <div class="payImg"><span class="iconfont icon-qunfengzhifuchenggong"></span> <span>支成功</span>
                        </div>
                      </template>
                    </div>

                    <div class="payInfo"><span>扫码支付</span> <span>请顾客使用微信或支付宝扫此二维码</span></div>
                  </div>
                </div>
              </div>
            </div>
          </el-drawer>
        </div>
      </template>
      <!--      结算      -->
      <template v-if="type === 3">
        <div class="pendingOrder" @keyup="monitorInput">
          <!--      关闭       -->
          <div class="close">
            <div class="singInfo">
              <div class="gender">
                <div class="sexSelection">
                  <div :class="memberSex === 1 ? 'sexSelection-item active' : 'sexSelection-item'"><span
                      @click="memberSex = 1">男</span></div>
                  <div :class="memberSex === 0 ? 'sexSelection-item active' : 'sexSelection-item'"><span
                      @click="memberSex = 0">女</span></div>
                </div>
              </div>

              <!-- 结算订单是否发送消费类短信 -->
              <div class="mies" @click="isMies = !isMies" v-show="isIndividualTraveler"><span
                  :class="isMies ? 'active' : ''"></span> <span>发送消费信息</span></div>

              <!-- 订单流水2单号 -->

              <div class="orderTrackingNumber" style=" position: relative;">
                <div class="orderTrackingNumber"><span>客数：</span> <input type="text" v-border_color
                    v-model.number="customerCount" oninput="value=value.replace(/[^0-9.]/g,'')"
                    style="width: 50px;margin-right: 10px" /></div>
                <span style="padding-left: 30px">流水单号：</span> <input type="text" v-border_color v-model="billNumber"
                  @keyup="OnBillNumber" placeholder="请输入流水单号" oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width: 110px; font-size: 13px" />
                <div :class="{ repatInput: RunningOrdersShow == true, isShowx: RunningOrdersText != '该流水单号已录入' }"
                  v-show="RunningOrdersShow">
                  {{ RunningOrdersText }}
                  <div :class="{ repatInputafter: RunningOrdersShow, isShowx: RunningOrdersText != '该流水单号已录入' }"></div>
                </div>
              </div>
            </div>

            <div class="operation">
              <div :class="whetherItIsPayableOrNot ? 'active' : ''" @click="tallyOrder"><span
                  class="iconfont icon-jiesuan"></span> <span>结算</span></div>
              <div @click="handleClose"><span class="iconfont icon-guanbi"></span></div>
            </div>
          </div>
          <!--       结算金额      -->
          <div class="clearingForm" style="height: auto;">
            <div style="display:flex; flex-wrap: wrap;">
              <div class="title-content">
                <div class="title-content-item" style="margin-right: 0px;">
                  <span class="iconfont icon-yingfu"></span> <span>订单金额：</span> <span>{{ amountInTotal | amountType
                  }}</span>
                </div>
                <!-- <i style="color: #1E90FF; font-size: 22px">【</i> -->
                <i class="text-primary f20" style="color: #1E90FF;">【</i>
                <div class="title-content-item">
                  <span>付现：</span> <span>{{ (amountInTotal - amountOfConsumableCard - settlementAllowance) | amountType
                  }}</span>
                </div>
                <div class="title-content-item" >
                  <span>可耗卡：</span> <span>{{ amountOfConsumableCard | amountType }}</span>
                </div>
                <div class="title-content-item" style="margin: 0">
                  <span>优惠金额：</span> <input type="text" v-model="settlementAllowance" onfocus="this.select()"
                    style="width: 110px; height: 28px; border: 1px solid rgb(232, 232, 232); padding: 0 10px; box-sizing: border-box; border-radius: 5px"
                    oninput="value=value.replace(/[^0-9.]/g,'')" />
                </div>
                <i style="color: #1E90FF; font-size: 22px">】</i>
              </div>
              <!-- <div class="achievements" v-if="departmentList === 1"> -->
              <div class="achievements" v-if="departmentList === 1"
                style="flex-basis: 100%;padding-left: 0;height: 40px">
                <span>部门业绩:</span>
                <div>
                  <div class="assigned">
                    <div style="padding-right: 10px;height: 28px; line-height: 24px">
                      <el-tooltip class="item" effect="dark" content="点击去分配" placement="bottom"
                        :disabled="totalCount === 0">
                        <div class="div-Posting" @click="isInputShow">
                          <span class="f20 text-primary" style="font-size: 20px;">【</span><span>待分配:</span> <u>{{
                            totalCount }}</u>
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-for="item in DepartmentalList" :key="item" style="padding-right: 5px">
                      <div v-if="item.departmentName !== ''">
                        <span class="text-primary">{{ item.departmentName }}: </span>
                        <el-input size="mini" style="width: 100px;" v-model="item.achievement"
                          :oninput="onInputNumPoint" />
                      </div>
                    </div>
                    <span class="f20 text-primary" style="font-size: 20px;">】</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="order-content" style="height: 40px">
              <div class="order-content-item" v-for="item in clearingForm" :key="item.iconfont">
                <div class="typeOfPayment" @click="choiceOfPaymentMethod(item)">
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use :href="`#${item.iconfont}`"></use>
                    </svg>
                  </span>
                  <span>{{ item.name }}</span> <span
                    :class="item.name === '智慧支付' && globalPaymentStatus === '1' ? 'money active' : 'money'"
                    v-if="item.paymentAmount > 0"> {{ item.paymentAmount | amountType }} </span>
                </div>
              </div>
              <!--             智慧耗卡             -->
              <template v-if="isIndividualTraveler">
                <div class="order-content-item">
                  <div class="typeOfPayment">
                    <span>
                      <svg class="icon" aria-hidden="true">
                        <use href="#icon-huiyuanqia"></use>
                      </svg>
                    </span>
                    <!--              次卡               -->
                    <template v-if="isSubcard">
                      <span>智慧耗卡</span> <span class="money" v-if="numberOfCardConsumptionNumber > 0"> {{
                        numberOfCardConsumptionNumber }}次 </span>
                    </template>
                    <!--              充值卡               -->
                    <template v-else>
                      <span>智慧耗卡</span> <span class="money"
                        v-if="accuracyCheck(amountOfConsumableCardNumber, canConsumeCardIncreaseGold) > 0"> {{
                          accuracyCheck(amountOfConsumableCardNumber, canConsumeCardIncreaseGold) | amountType }} </span>
                    </template>
                  </div>
                </div>
              </template>
              <div class="interval"></div>
              <!--            支付调整           -->
              <div class="order-content-item" @click="adjustedPayment">
                <div class="typeOfPayment">
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use href="#icon-hunhe"></use>
                    </svg>
                  </span>
                  <template>
                    <span>调整支付</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!--      订单详情  -->
          <div class="content-order-list">
            <div class="content-order-item" v-for="(item, index) in orderData" :key="index">
              <div class="order-info">
                <div class="order-title">
                  <span>{{ item.packageName || item.productName }}</span>
                </div>
                <div class="order-type">
                  <span>{{ item.packageTypeName || item.productTypeName }}</span> <span>{{ item.total | amountType
                  }}</span>
                </div>
              </div>
              <div class="staff" v-for="(subItem, employeeIndex) in item.employeeList" :key="employeeIndex">
                <div class="jobType">
                  <template v-if="analyticalDataCommodity(item) === '0'">
                    <span>{{ subItem.workType[0] }}</span> <span>{{ subItem.workType[1] }}</span>
                  </template>
                  <template v-else>
                    <i>销售</i> <i>{{ employeeIndex + 1 }}</i>
                  </template>
                </div>
                <div class="employeePerformanceText">
                  <span class="employeeName">{{ subItem.employeeNo }}</span>
                  <span class="appoint" :style="{ color: subItem.appoint === 0 ? '#333333' : '#f64e60' }"
                    @click="$emit('modifyADesignation', { projectItem: item, employeeItem: subItem })"> {{
                      subItem.appoint === 0 ?
                        "非指定" : "指定" }} </span> <span class="labour">劳动</span>
                  <span class="market">销售</span>
                </div>
                <div class="employeePerformance">
                  <span class="employeeName"> {{ subItem.employeeName }} </span> <span class="appoint"></span>
                  <span class="labour">
                    <input type="text" v-model="subItem.work"
                      :disabled="calculateWhetherPerformanceIsModifiable('work', subItem, item)"
                      onfocus="this.select()" /> <span class="iconfont icon-bianji1"
                      v-if="!calculateWhetherPerformanceIsModifiable('work', subItem, item)"></span>
                  </span>
                  <span class="market">
                    <input type="text" v-model="subItem.sell"
                      :disabled="calculateWhetherPerformanceIsModifiable('sell', subItem, item)"
                      onfocus="this.select()" /> <span class="iconfont icon-bianji1"
                      v-if="!calculateWhetherPerformanceIsModifiable('sell', subItem, item)"></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!--        内层抽屉(支付调整)         -->
          <el-drawer :append-to-body="true" size="40%" :show-close="false" :withHeader="false"
            :before-close="innerDrawerHandleClose" :visible.sync="innerDrawer">
            <div class="mixedPayment">
              <div class="mixedPayment-title">
                <span>支付详情，共需支付：<i>{{ (amountInTotal - settlementAllowance) | amountType }}</i></span>
                <span class="iconfont icon-guanbi" @click="innerDrawerHandleClose"></span>
              </div>
              <!--         周一修改添加if只在type==3时   修改支付方式                -->
              <div class="modeOfPaymentList">
                <div class="modeOfPaymentList-item" v-for="item in modifyPaymentAmount" :key="item.name"
                 v-if="!(type === 3 && (item.name === '耗卡本金' || item.name === '耗卡赠金'))">
                  <span style="white-space: nowrap">{{ item.name }}:</span> <input type="text" v-model="item.money"
                    @blur="calculateWhetherTheAmountExceeded" oninput="value=value.replace(/[^0-9.]/g,'')" />
                  <template v-if="item.name === '智慧支付'">
                    <span @click="smartPayment">支付</span>
                  </template>
                </div>

                <template v-if="isIndividualTraveler">
                  <!--              次卡               -->
                  <template v-if="isSubcard">
                    <div class="modeOfPaymentList-item"><span>智慧耗卡:</span> <input type="text"
                        v-model="numberOfCardConsumptionNumber" :disabled="true" /></div>
                  </template>
                  <!--              充值卡               -->
                  <template v-else>
                    <div class="modeOfPaymentList-item">
                      <span>智慧耗卡（本金）:</span>
                      <input type="text" v-model="amountOfConsumableCardNumber"
                        :disabled="!calculateThePrincipalIncreaseModification[0]"
                        :class="!calculateThePrincipalIncreaseModification[0] ? 'active' : ''"
                        @blur="modifyTheAmountOfTheRechargeCard('amountOfConsumableCardNumber')" />
                    </div>

                    <div class="modeOfPaymentList-item">
                      <span>智慧耗卡（赠金）:</span>
                      <input type="text" v-model="canConsumeCardIncreaseGold"
                        :disabled="!calculateThePrincipalIncreaseModification[1]"
                        :class="!calculateThePrincipalIncreaseModification[1] ? 'active' : 'clearBac'"
                        @blur="modifyTheAmountOfTheRechargeCard('canConsumeCardIncreaseGold')" />
                    </div>
                  </template>
                </template>
              </div>
              <!--         智慧支付           -->
              <el-drawer :append-to-body="true" size="40%" :show-close="true" :withHeader="false"
                :before-close="closeTheScanCodePaymentWindow" :visible.sync="intelligentPaymentState">
                <div class="smartPayment">
                  <div class="wisdomPaysTitle">
                    <span>您当前正在通过</span>
                    <span class="paymentMethodDetails">
                      <span>
                        <svg class="icon" aria-hidden="true">
                          <use href="#icon-shoukuan"></use>
                        </svg>
                      </span>
                      <span>智慧支付</span>
                      <span v-show="!innerDrawer">{{
                        clearingForm.reduce((pv, cu) => {
                          if (cu.name === "智慧支付") return accuracyCheck(pv, cu.paymentAmount);
                          else return pv;
                        }, 0) | amountType
                      }}</span>
                      <span v-show="innerDrawer">{{
                        modifyPaymentAmount.reduce((pv, cu) => {
                          if (cu.name === "智慧支付") return accuracyCheck(pv, cu.money);
                          else return pv;
                        }, 0) | amountType
                      }}</span>
                    </span>
                  </div>
                  <div class="paymentModeSwitching"><span :class="smartPaymentMethod === '0' ? 'active' : ''"
                      @click="switchingPaymentMethods('0')">商家扫码收款</span> <span
                      :class="smartPaymentMethod === '1' ? 'active' : ''"
                      @click="switchingPaymentMethods('1')">顾客扫码收款</span>
                  </div>

                  <div class="collectionContents">
                    <div class="merchantScanningCode"
                      :style="smartPaymentMethod === '0' ? { height: 'auto', opacity: 1, position: 'relative', 'z-index': 999 } : { height: 0, opacity: 0, position: 'relative', 'z-index': 1 }">
                      <div class="paymentContent"><input ref="scanToPay" type="text" placeholder="请使用扫码枪扫码输入"
                          :value="codeNumber" @keydown="scanCodeGunInput"
                          oninput="value=value.replace(/[^0-9.]/g,'')" /> <span>支付</span></div>
                    </div>
                    <div class="customerScanCode"
                      :style="smartPaymentMethod === '1' ? { height: 'auto', opacity: 1, position: 'relative', 'z-index': 999 } : { height: 0, opacity: 0, position: 'relative', 'z-index': 1 }">
                      <div class="paymentContent">
                        <div class="payBox">
                          <template>
                            <img :src="paymentCardPaymentAddress" alt="暂无开通拉卡拉" />
                          </template>
                          <template v-if="payState === 100">
                            <div class="payImg"><span class="iconfont icon-zhifuchenggong"></span> <span>支付中</span>
                            </div>
                          </template>
                          <template v-else-if="payState === 300">
                            <div class="payImg"><span class="iconfont icon-qunfengzhifuchenggong"></span>
                              <span>支成功</span>
                            </div>
                          </template>
                        </div>

                        <div class="payInfo"><span>扫码支付</span> <span>请顾客使用微信或支付宝扫此二维码</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-drawer>
            </div>
          </el-drawer>

          <!--         智慧支付           -->
          <el-drawer :append-to-body="true" size="40%" :show-close="true" :withHeader="false"
            :before-close="closeTheScanCodePaymentWindow" :visible.sync="intelligentPaymentState">
            <div class="smartPayment">
              <div class="wisdomPaysTitle">
                <span>您当前正在通过</span>
                <span class="paymentMethodDetails">
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use href="#icon-shoukuan"></use>
                    </svg>
                  </span>
                  <span>智慧支付</span>
                  <span v-show="!innerDrawer">{{
                    clearingForm.reduce((pv, cu) => {
                      if (cu.name === "智慧支付") return accuracyCheck(pv, cu.paymentAmount);
                      else return pv;
                    }, 0) | amountType
                  }}</span>
                  <span v-show="innerDrawer">{{
                    modifyPaymentAmount.reduce((pv, cu) => {
                      if (cu.name === "智慧支付") return accuracyCheck(pv, cu.money);
                      else return pv;
                    }, 0) | amountType
                  }}</span>
                </span>
              </div>
              <div class="paymentModeSwitching"><span :class="smartPaymentMethod === '0' ? 'active' : ''"
                  @click="switchingPaymentMethods('0')">商家扫码收款</span> <span
                  :class="smartPaymentMethod === '1' ? 'active' : ''"
                  @click="switchingPaymentMethods('1')">顾客扫码收款</span></div>

              <div class="collectionContents">
                <div class="merchantScanningCode"
                  :style="smartPaymentMethod === '0' ? { height: 'auto', opacity: 1, position: 'relative', 'z-index': 999 } : { height: 0, opacity: 0, position: 'relative', 'z-index': 1 }">
                  <div class="paymentContent"><input type="text" ref="scanToPay" placeholder="请使用扫码枪扫码输入"
                      :value="codeNumber" @keydown="scanCodeGunInput" oninput="value=value.replace(/[^0-9.]/g,'')" />
                    <span>支付</span>
                  </div>
                </div>
                <div class="customerScanCode"
                  :style="smartPaymentMethod === '1' ? { height: 'auto', opacity: 1, position: 'relative', 'z-index': 999 } : { height: 0, opacity: 0, position: 'relative', 'z-index': 1 }">
                  <div class="paymentContent">
                    <div class="payBox">
                      <template>
                        <img :src="paymentCardPaymentAddress" alt="暂无开通拉卡拉" />
                      </template>
                      <template v-if="payState === 100">
                        <div class="payImg"><span class="iconfont icon-zhifuchenggong"></span> <span>支付中</span></div>
                      </template>
                      <template v-else-if="payState === 300">
                        <div class="payImg"><span class="iconfont icon-qunfengzhifuchenggong"></span> <span>支成功</span>
                        </div>
                      </template>
                    </div>
                    <div class="payInfo"><span>扫码支付</span> <span>请顾客使用微信或支付宝扫此二维码</span></div>
                  </div>
                </div>
              </div>
            </div>
          </el-drawer>
        </div>
      </template>
      <!--      开卡     -->
      <template v-if="type === 4">
        <div class="openACard">
          <!--      关闭       -->
          <div class="close">
            <div class="singInfo">
              <span>会员开卡</span>

              <!-- 结算订单是否发送消费类短信 -->
              <div class="mies" @click="isMies = !isMies" v-show="cardPurchase"><span
                  :class="isMies ? 'active' : ''"></span> <span>发送消费信息</span></div>

              <!-- 订单流水3单号 -->

              <div class="orderTrackingNumber" style=" position: relative;">
                <!-- <div class="orderTrackingNumber"><span>客数：</span> <input type="text" v-border_color v-model.number="customerCount" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 50px; margin-right: 10px" /></div> -->

                <span>流水单号：</span> <input type="text" v-border_color v-model="billNumber" @keyup="OnBillNumber"
                  placeholder="请输入流水单号" oninput="value=value.replace(/[^0-9.]/g,'')" />
                <div :class="{ repatInput: RunningOrdersShow == true, isShowx: RunningOrdersText != '该流水单号已录入' }"
                  v-show="RunningOrdersShow">
                  {{ RunningOrdersText }}
                  <div :class="{ repatInputafter: RunningOrdersShow, isShowx: RunningOrdersText != '该流水单号已录入' }"></div>
                </div>
              </div>
            </div>
            <div class="operationcard">
              <template v-if="cardPurchase">
                <div class="opencard" @click="handleBack"><span>返回</span></div>
              </template>
              <template>
                <div v-if="!cardPurchase"
                  :class="cardPurchase && individualCardPaymentStatus ? 'opencard active' : 'opencard'"
                  @click="openSexCard()"><span class="iconfont icon-jiesuan"></span> <span>开卡</span></div>
              </template>
              <template v-if="cardPurchase">
                <div :class="cardPurchase && individualCardPaymentStatus ? 'opencard active' : 'opencard'"
                  @click="openSexCard()"><span class="iconfont icon-jiesuan"></span> <span>结算</span></div>
              </template>
              <div @click="handleClose"><span class="iconfont icon-guanbi"></span></div>
            </div>
          </div>
          <!--         开卡          -->
          <div class="openACardBody">
            <div class="openACardBody-left">
              <!--                            会员信息                           -->
              <div class="userInfo">
                <div class="phone" style="position: relative">
                  <span>手机号</span> <input type="text" :disabled="!memberEditor" ref="memberMobileRef" maxlength="11"
                    data-type="memberMobile" v-model="editMemberInformationContent.memberMobile"
                    @keyup="updateMemberInformation" @blur="focussing" />
                  <i
                    style="position: absolute; right: 25px; top: 55%; transform: translateY(-50%); font-size: 20px; color: red">*</i>
                </div>
                <div class="name" style="position: relative">
                  <span>姓名</span> <input type="text" maxlength="18" ref="memberNameRef" data-type="memberName"
                    :disabled="!memberEditor" v-model="editMemberInformationContent.memberName"
                    @keyup="updateMemberInformation" />
                  <i
                    style="position: absolute; right: 25px; top: 55%; transform: translateY(-50%); font-size: 20px; color: red">*</i>
                </div>
                <div class="membership_number"><span>会员编号</span> <input type="text" :disabled="!memberEditor"
                    data-type="memberNo" v-model="editMemberInformationContent.memberNo"
                    @keyup="updateMemberInformation" /></div>
                <div class="wechat_id"><span>微信</span> <input type="text" :disabled="!memberEditor"
                    data-type="wechatAccount" v-model="editMemberInformationContent.wechatAccount"
                    @keyup="updateMemberInformation" /></div>
                <div class="gender">
                  <span>性别</span>
                  <div class="sexSelection">
                    <div
                      :class="editMemberInformationContent.gender === 1 ? 'sexSelection-item active' : 'sexSelection-item'"
                      data-type="gender" data-value="1" @click="updateMemberInformation"><span data-type="gender"
                        data-value="1">男</span></div>
                    <div
                      :class="editMemberInformationContent.gender === 0 ? 'sexSelection-item active' : 'sexSelection-item'"
                      data-type="gender" data-value="0" @click="updateMemberInformation"><span data-type="gender"
                        data-value="0">女</span></div>
                    <div
                      :class="editMemberInformationContent.gender === 2 ? 'sexSelection-item active' : 'sexSelection-item'"
                      data-type="gender" data-value="2" @click="updateMemberInformation"><span data-type="gender"
                        data-value="2">保密</span></div>
                  </div>
                </div>
                <div class="birthday">
                  <span>生日</span>
                  <div class="birthdayChoice"><el-date-picker v-model="editMemberInformationContent.birthday"
                      type="date" :disabled="!memberEditor" value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="mini"
                      :editable="false" data-type="birthday" placeholder="选择日期"> </el-date-picker></div>
                </div>
                <div class="member_class">
                  <span>等级</span>
                  <div class="class_select">
                    <el-select v-model="editMemberInformationContent.memberLevelName" :disabled="!memberEditor"
                      placeholder="请选择" size="mini"> <el-option v-for="item in membershipData.memberClass"
                        :key="item.value" :label="item.label" :value="item.value"> </el-option> </el-select>
                  </div>
                </div>
                <div class="matching">
                  <span>是否匹配</span>
                  <div class="enableMatching">
                    <div
                      :class="editMemberInformationContent.deductionsState === 1 ? 'enableMatching-item active' : 'enableMatching-item'"
                      data-type="deductionsState" data-value="1" @click="updateMemberInformation"><span
                        data-type="deductionsState" data-value="1">开启</span></div>
                    <div
                      :class="editMemberInformationContent.deductionsState === null || editMemberInformationContent.deductionsState === 0 ? 'enableMatching-item active' : 'enableMatching-item'"
                      data-type="deductionsState" data-value="0" @click="updateMemberInformation">
                      <span data-type="deductionsState" data-value="0">关闭</span>
                    </div>
                  </div>
                </div>
                <div class="source">
                  <span>顾客来源</span>
                  <div class="source_content">
                    <el-select v-model="editMemberInformationContent.memberSourceName" placeholder="请选择" size="mini">
                      <el-option v-for="item in membershipData.source" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option> </el-select>
                  </div>
                </div>
                <div class="remark"><textarea rows="4" cols="25" placeholder="会员备注" @blur="updateMemberInformation"
                    data-type="remark" v-model="editMemberInformationContent.remark"></textarea></div>
                <div class="newAddMemberInfo">
                  <el-button @click.stop="enableMemberInformationEditing" :type="isNewMemberInfo ? 'primary' : 'info'"
                    :disabled="!isNewMemberInfo"><i class="iconfont icon-tianjia"
                      style="margin-right: 5px"></i>创建新会员</el-button>
                </div>
              </div>
            </div>
            <!--          选卡            -->
            <template v-if="!cardPurchase" >
              <div class="openACardBody-right" >
                <!--                            充值卡、次卡、折扣卡 - 项目（个性次卡）信息                           -->
                <div class="optionalBar">
                  <el-tabs v-model="activeName" type="card" @tab-click="selectiveCardType" >
                    <el-tab-pane label="开卡" name="openACard">
                      <!--                   会员开卡                    -->
                      <div class="membershipCardOpening">
                        <div class="membership_item" v-for="item in openTheCardItemList" :key="item.cardTypeCode">
                          <div class="title_membership">
                            <span>{{ item.cardTypeName }}</span>
                          </div>
                          <div class="sunTzuCardItem">
                            <div class="sunTzuCardItem_item" v-for="subItem in item.cardItemList" :key="subItem.id"
                              @click.stop="openMembershipCard(subItem)">
                              <span :class="taggedMember.indexOf(subItem.cardNo) !== -1 ? 'active' : ''">{{
                                subItem.cardName }}</span> <span
                                :class="taggedMember.indexOf(subItem.cardNo) !== -1 ? 'active' : ''">{{ subItem.cardNo
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="个性次卡" name="personalitySubcard" >
                      <div class="personalitySubcard">
                        <div class="personalitySubcard-item" v-for="item in listOfSubCardItems"
                          :key="item.packageTypeId">
                          <div class="title-content">
                            <span @click.stop="subCardItemOption(item)" :class="item.cardActive ? 'active' : ''">
                              <i>{{ item.packageTypeName }}</i>
                            </span>
                            <!-- 字母筛选 -->
                            <div class="alphabeticScreening" v-if="getPackageAvailableLetters(item).length >= 2" style="margin-left: 30px;">
                              <div v-for="letter in getPackageAvailableLetters(item)" :key="letter"
                                :class="['alphabeticScreening-item', item.currentLetter === letter ? 'active' : '']"
                                @click.stop="selectPackageLetter(item, letter)">{{ letter.toUpperCase() }}</div>
                            </div>
                            <i v-if="item.cardActive" class="iconfont icon-shanchu2"
                              @click.stop="deleteSubCardItems(item)"></i>
                          </div>
                          <div class="contentBody">
                            <div :class="subItem.cardActive ? 'contentBody-item active' : 'contentBody-item'"
                              v-for="subItem in filteredPackageList(item)" :key="subItem.id"
                              @click.stop="subCardItemOption(subItem)">
                              <span>{{ subItem.packageName }}</span> <span>{{ subItem.packageCode }}</span> <span
                                v-if="subItem.cardActive" class="iconfont icon-shanchu2"
                                @click.stop="deleteSubCardItems(subItem)"></span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <el-dialog title="个性次卡" :visible.sync="modifyPopUp" width="550px"
                        custom-class="addPersonalitySubCard" :append-to-body="true" :modal-append-to-body="true"
                        :close-on-click-modal="false" @close="closeTheSecondaryCardInformation">
                        <div class="addPersonalSubCardInformation">
                          <div class="subCardContent">
                            <div class="project">
                              <span> <img
                                  src="http://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/hair.102f112.jpeg"
                                  alt="" /> </span>
                              <template v-if="theSecondCardSelectsTheItem.packageName">
                                <span>{{ `${theSecondCardSelectsTheItem.packageName ||
                                  ""}-${theSecondCardSelectsTheItem.packageCode || ""}` }}</span>
                              </template>
                              <template v-else>
                                <span>{{ theSecondCardSelectsTheItem.packageTypeName || "" }}</span>
                              </template>
                            </div>
                            <div class="time">
                              <div class="time-content">
                                <span>次数：</span> <i><b>【</b>次数为 9999，表示无限次<b>】</b></i>
                                <quantityInputModule @updateVisible="numberOfSubCards = $event"
                                  :numberOfSubCards="numberOfSubCards" min-number="1">
                                </quantityInputModule>
                              </div>
                              <div class="time-content">
                                <span>时限（天）：</span> <i><b>【</b>时限(天)为-1，表示无限期<b>】</b></i>
                                <quantityInputModule @updateVisible="subCardTimeLimit = $event"
                                  :numberOfSubCards="subCardTimeLimit" min-number="-1"> </quantityInputModule>
                              </div>
                            </div>
                          </div>
                          <div class="closeBox"><span @click="closeTheSecondaryCardInformation">取消</span> <span
                              @click="confirmAdd">确认添加</span>
                            <span @click="openACard">去开卡</span>
                          </div>
                        </div>
                      </el-dialog>
                    </el-tab-pane>
                  </el-tabs>
                  <span v-show="activeName === 'openACard'" class="hint">【红色，代表顾客已有此卡】</span>
                </div>
              </div>
            </template>
            <!--          购卡            -->
            <template v-else>
              <div class="openACardBody-right">
                <!--              个性次卡购卡               -->
                <template v-if="activeName === 'personalitySubcard'">
                  <div class="Individual-sub-card-settlement">
                    <div class="Sub-card-item">
                      <div class="List-of-sub-card-items">
                        <el-table :data="personalizedTimesCardPurchase" size="mini" max-height="250"
                          style="width: 100%">
                          <el-table-column prop="cardItemCode" label="编号/分类" width="180"></el-table-column>
                          <el-table-column prop="cardItemName" label="名称"></el-table-column>
                          <el-table-column prop="numberOfSubCards" label="次数"></el-table-column>
                          <el-table-column prop="subCardTimeLimit" label="时限"></el-table-column>
                          <el-table-column fixed="right" label="操作" width="120">
                            <template slot-scope="{ row, $index }">
                              <el-button @click.stop="removeTheSubCardItem($index)" type="text" size="small"> <span
                                  class="iconfont icon-shanchu1" style="font-size: 20px"></span> </el-button>
                              <el-button @click.stop="modifyItem(row, $index)" type="text" size="small"> <span
                                  class="iconfont icon-bianji1" style="font-size: 20px"></span> </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>

                    <div class="content-card">
                      <div class="content-card-item">
                        <span>总次数:</span> <span><input type="text" :disabled="true"
                            :value="countTheTotalNumberOfIndividualCycles" /></span>
                      </div>

                      <!-- <div class="content-card-item">
                        <span>开卡价格:</span> <span><input v-border_color type="number" v-model="memberCardPrice"
                            onfocus="this.select()" @keyup="defaultAmount" @input="onPriceChanged"
                            @blur="onPriceChanged" /></span>
                      </div> -->
                      <!-- 删掉了 @keyup="defaultAmount" 因为 @keyup="defaultAmount" 会填入微信,现在不填入微信 -->
                       <div class="content-card-item">
                        <span>开卡价格:</span> <span><input v-border_color type="number" v-model="memberCardPrice"
                            onfocus="this.select()"  @input="onPriceChanged"
                            @blur="onPriceChanged" /></span>
                      </div>

                      <div class="content-card-item">
                        <span>会员卡备注:</span> <span><input type="text" v-model="membershipCardRemarks"
                            onfocus="this.select()" /></span>
                      </div>
                      <!-- isNewMemberInfo=true -->
                       <!-- 个性次卡按钮 -->
                      <!-- 添加一个selectMembershipCardItems非空判断,因为个性次卡selectMembershipCardItems本来就没给selectMembershipCardItems赋值,开会员卡才赋值
                       existingRechargeCards — 存在充值卡列表（不是 null/undefined）。这个数组是查会员资料时，把会员已有的、类型为 2（充值卡）的卡存进来的。
                        existingRechargeCards.length — 充值卡列表非空，也就是这个会员名下确实有充值卡。没有充值卡就没得耗卡，按钮不显示。
                        selectMembershipCardItems && selectMembershipCardItems.cardTypeCode == 0 — 当前选中的卡是「次卡」类型（cardTypeCode == 0）。只有开的是次卡，才谈得上"用充值卡去买次卡"这个场景。-->
                      <div class="content-card-item">
                        <button v-if="existingRechargeCards && existingRechargeCards.length&&!isNewMemberInfo"
                         :class="isShow ? 'show' : ''"
                        @click="openCardShow">充值卡购买次卡</button>
                      </div>
                    </div>
                    <!-- 👇 已有充值卡独立成行（单独一个 content-card-item） -->
                      <div class="content-card-item"
                          v-if="existingRechargeCards && existingRechargeCards.length&& isShow&&!isNewMemberInfo"
                          style="display: flex; flex-wrap: wrap; align-items: center; gap: 6px; padding: 4px 0; width: 100%;">
                        <span style="font-size: 13px; color: #666; font-weight: bold; white-space: nowrap;">已有充值卡：</span>
                        <!-- 用唯一 id 作为 key 和选中判断，避免同名卡（cardNo 实为卡名）一起被选中 -->
                        <span
                          v-for="card in existingRechargeCards"
                          :key="card.id"
                              @click="selectRechargeCard(card)"
                          :style="{
                            fontSize: '12px',
                            padding: '2px 10px',
                            borderRadius: '4px',
                            border: '1px solid',
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                            background: selectedRechargeCard && selectedRechargeCard.id === card.id ? 'red' : '#409EFF',
                            borderColor: selectedRechargeCard && selectedRechargeCard.id === card.id ? '#409EFF' : '#d1e7ff',
                            color: selectedRechargeCard && selectedRechargeCard.id === card.id ? '#fff' : '#fff',
                          }"
                        >
                          {{ card.cardName }}（本金：{{ card.initAmount }}，赠金：{{ card.givenAmount }}）
                        </span>
                      </div>
                    <!--                销售人员              -->
                    <div class="Sub-card-item-yuangong">
                      <div class="List-of-sub-card-items">
                        <div class="addOnSales" @click.stop="personalitySubCardAddedSales">
                          <span class="iconfont icon-a-xiaoshou2"></span> <span><i
                              style="font-size: 18px; font-weight: bold">+</i>开卡员工</span>
                        </div>
                        <div class="vessel">
                          <div class="market" v-for="(item, index) in personalitySubCardEmployeeList" :key="index">
                            <span>{{ item.employeeName }}</span>
                            <div class="market-info">
                              <span>销售</span>
                              <span>
                                <template v-if="item.achievement">
                                  <input type="text" v-model="item.achievement"
                                    :disabled="whetherToDisablePerformanceModification || item.brokerageClass === 'no'"
                                    onfocus="this.select()" />
                                </template>
                                <template v-else>
                                  <input type="text" v-model="item.percentage"
                                    :disabled="whetherToDisablePerformanceModification || item.brokerageClass === 'no'"
                                    onfocus="this.select()" />
                                </template>

                                <i v-if="item.brokerageClass !== 'no'" class="iconfont icon-bianji1"></i>
                              </span>
                            </div>
                            <span class="iconfont icon-closel"
                              @click.stop="deletePersonalitySubCardEmployees(index)"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--                (个性)  付款信息                      -->
                    <div class="particulars">
                      <div class="particulars-title"><span class="iconfont icon-dingdan"></span> <span>付款信息</span></div>

                      <div class="paymentAmountStatistics">
                        <div class="title-content-item">
                          <span class="iconfont icon-yingfu"></span> <span>订单金额：</span> <span>{{ memberCardPrice |
                            amountType }}</span>
                        </div>
                        <i style="color: #1E90FF; font-size: 22px">【</i>
                        <div class="title-content-item">
                          <span>付现：</span> <span>{{ actualCashPay  | amountType }}</span>
                        </div>
                        <!-- 如果要隐藏v-if="existingRechargeCards && existingRechargeCards.length && isShow&&!isNewMemberInfo" -->
                         <div class="title-content-item" >
                          <span>可耗卡：</span> <span>{{ haoCardMoney | amountType }}</span>
                        </div>
                        <div class="title-content-item" style="display: flex; align-items: center; margin: 0">
                          <span style="margin-right: 10px">优惠金额:</span>
                          <span style="width: 80px; height: 30px; display: flex"> <input
                              style="width: 100%; height: 100%; border-radius: 5px; border: 1px solid #E8E8E8; padding-left: 10px; box-sizing: border-box"
                              type="number" v-model="memberCoupon" onfocus="this.select()" /> </span>
                        </div>
                        <i style="color: #1E90FF; font-size: 22px">】</i>
                        <div class="achievements" v-if="departmentList === 1">
                          <span>部门业绩:</span>
                          <div>
                            <div class="assigned">
                              <div style="padding-right: 10px;height: 28px; line-height: 24px">
                                <span class="f20 text-primary">【</span>
                                <!--
                                <el-tooltip class="item" effect="dark" content="点击查看" placement="bottom" :disabled="totalCount === 0">
                                  <div class="div-Posting" @click="isInputShow">
                                    <span class="f20 text-primary">【</span><span>待分配:</span> <u>{{ totalCount }}</u>
                                  </div>
                                </el-tooltip> -->
                              </div>
                              <div v-for="item in isDepartmentalPerformance" :key="item.departmentId"
                                style="padding-right: 5px">
                                <div v-if="item.departmentName !== ''">
                                  <span class="text-primary">{{ item.departmentName }}: </span>
                                  <el-input size="mini" style="width: 50px;" v-model="item.achievement"
                                    :oninput="onInputNumPoint" />
                                </div>
                              </div>
                              <span class="f20 text-primary">】</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="order-content">
                        <div class="order-content-item" v-for="item in clearingForm" :key="item.iconfont"
                          @click="topUpPaymentAmount(item, 'openCard')">
                          <div class="typeOfPayment">
                            <span>
                              <svg class="icon" aria-hidden="true">
                                <use :href="`#${item.iconfont}`"></use>
                              </svg>
                            </span>
                            <span>{{ item.name }}</span> <span
                              :class="item.name === '智慧支付' && globalPaymentStatus === '1' ? 'money active' : 'money'"
                              v-if="item.paymentAmount > 0">{{ item.paymentAmount | amountType }}</span>
                          </div>
                        </div>
                        <!-- 个性次卡--添加智慧耗卡：当有耗卡金额时展示 -->
                    <div class="order-content-item"
                      v-if="amountOfConsumableCardNumber > 0 || canConsumeCardIncreaseGold > 0">
                      <div class="typeOfPayment">
                        <span>
                          <svg class="icon" aria-hidden="true">
                            <use href="#icon-huiyuanqia"></use>
                          </svg>
                        </span>
                        <span>智慧耗卡</span>
                        <span class="money">
                          {{ accuracyCheck(amountOfConsumableCardNumber, canConsumeCardIncreaseGold) | amountType }}
                        </span>
                      </div>
                    </div>
                    <div class="interval"></div>
                      </div>

                      <div class="adjustedPayment">
                        <div class="cutOffRule"></div>
                        <!--            支付调整           -->
                        <div class="order-content-item" @click="adjustedPayment">
                          <div class="typeOfPayment">
                            <span>
                              <svg class="icon" aria-hidden="true">
                                <use href="#icon-hunhe"></use>
                              </svg>
                            </span>
                            <span>调整支付</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <el-dialog title="个性次卡" :visible.sync="modifyPopUp" :close-on-click-modal="false" width="550px"
                      custom-class="addPersonalitySubCard" :append-to-body="true" :modal-append-to-body="true"
                      @close="closeTheSecondaryCardInformation">
                      <div class="addPersonalSubCardInformation">
                        <div class="subCardContent">
                          <div class="project">
                            <span> <img src="http://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/hair.102f112.jpeg"
                                alt="" /> </span>
                            <template v-if="theSecondCardSelectsTheItem.packageName">
                              <span>{{ `${theSecondCardSelectsTheItem.packageName ||
                                ""}-${theSecondCardSelectsTheItem.packageCode || ""}` }}</span>
                            </template>
                            <template v-else>
                              <span>{{ theSecondCardSelectsTheItem.packageTypeName || "" }}</span>
                            </template>
                          </div>
                          <div class="time">
                            <div class="time-content">
                              <span>次数：</span> <i><b>【</b>次数为 9999，表示无限次<b>】</b></i>
                              <quantityInputModule @updateVisible="numberOfSubCards = $event"
                                :numberOfSubCards="numberOfSubCards" min-number="1"> </quantityInputModule>
                            </div>
                            <div class="time-content">
                              <span>时限（天）：</span> <i><b>【</b>时限(天)为-1，表示无限期<b>】</b></i>
                              <quantityInputModule @updateVisible="subCardTimeLimit = $event"
                                :numberOfSubCards="subCardTimeLimit" min-number="-1"> </quantityInputModule>
                            </div>
                          </div>
                        </div>
                        <div class="closeBox"><span @click="closeTheSecondaryCardInformation">取消</span> <span
                            @click="confirmTheModificationOfSubCardItems">确认修改</span></div>
                      </div>
                    </el-dialog>
                  </div>
                </template>
                <!--              会员卡购卡               -->
                <!--              selectMembershipCardItems.cardTypeCode这里可以获取到卡的类型,直接借来用               -->
                <template v-if="activeName === 'openACard'">
                  <div class="membershipCardPurchase">
                    <div class="Sub-card-item">
                      <div class="List-of-sub-card-items">
                        <img :src="selectMembershipCardItems.cardTypeCode | filterCardPic('bg')" alt="" />
                        <span>
                          <i>{{ selectMembershipCardItems.cardName }}</i> <i>{{ selectMembershipCardItems.cardNo }}</i>
                        </span>
                        <span>{{ selectMembershipCardItems.cardTypeName }}</span>
                      </div>
                    </div>

                    <div class="content-card">
                      <div class="content-card-item">
                        <span>开卡价格:</span> <span><input v-border_color :disabled="!openTheCardToModifyTheOriginalPrice"
                            type="number" v-model="memberCardPrice" onfocus="this.select()" @input="onPriceChanged"
                            @blur="onPriceChanged" /></span>
                      </div>

                      <div class="content-card-item" v-show="selectMembershipCardItems.cardTypeName === '充值卡'">
                        <span>赠送金额:</span> <span><input type="number" :disabled="!amountGiftCanBemodifiedByopeningCard"
                            v-model="amountOfGift" onfocus="this.select()" /></span>
                      </div>

                      <div class="content-card-item">
                        <span>会员卡备注:</span> <span><input type="text" v-model="membershipCardRemarks"
                            onfocus="this.select()" /></span>
                      </div>
                       <div class="content-card-item">
                        <button v-show="existingRechargeCards && existingRechargeCards.length&&selectMembershipCardItems.cardTypeCode==0&&!isNewMemberInfo"
                         :class="isShow ? 'show' : ''"
                        @click="openCardShow">充值卡购买次卡</button>
                      </div>
                    </div>
                     <!-- 会员卡购卡 -已有充值卡独立成行（单独一个 content-card-item） -->
                      <!-- selectMembershipCardItems.cardTypeCode这里可以获取到卡的类型,直接借来用控制显示,当==0(次卡)时才显示 -->
                      <div class="content-card-item"
                          v-if="existingRechargeCards && existingRechargeCards.length&&selectMembershipCardItems.cardTypeCode==0 && isShow&&!isNewMemberInfo"
                          style="display: flex; flex-wrap: wrap; align-items: center; gap: 6px; padding: 4px 0; width: 100%;">
                        <span style="font-size: 13px; color: #666; font-weight: bold; white-space: nowrap;">可选充值卡：</span>
                        <!-- 用唯一 id 作为 key 和选中判断，避免同名卡（cardNo 实为卡名）一起被选中 -->
                        <span
                          v-for="card in existingRechargeCards"
                          :key="card.id"
                              @click="selectRechargeCard(card)"
                          :style="{
                            fontSize: '12px',
                            padding: '2px 10px',
                            borderRadius: '4px',
                            border: '1px solid',
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                            background: selectedRechargeCard && selectedRechargeCard.id === card.id ? 'red' : '#409EFF',
                            borderColor: selectedRechargeCard && selectedRechargeCard.id === card.id ? '#409EFF' : '#d1e7ff',
                            color: selectedRechargeCard && selectedRechargeCard.id === card.id ? '#fff' : '#fff',
                          }"
                        >
                          {{ card.cardName }}（本金：{{ card.initAmount }}，赠金：{{ card.givenAmount }}）
                        </span>
                      </div>

                    <!--                销售人员              -->
                    <div class="Sub-card-item-yuangong">
                      <div class="List-of-sub-card-items">
                        <div class="addOnSales" @click.stop="personalitySubCardAddedSales">
                          <span class="iconfont icon-a-xiaoshou2"></span> <span><i
                              style="font-size: 18px; font-weight: bold">+</i>开卡员工</span>
                        </div>
                        <div class="vessel">
                          <div class="market" v-for="(item, index) in personalitySubCardEmployeeList" :key="index">
                            <span>{{ item.employeeName }}</span>
                            <div class="market-info">
                              <span>销售</span>
                              <span>
                                <template v-if="item.achievement">
                                  <input type="text" v-model="item.achievement"
                                    :disabled="whetherToDisablePerformanceModification || item.brokerageClass === 'no'"
                                    onfocus="this.select()" />
                                </template>
                                <template v-else>
                                  <input type="text" v-model="item.percentage"
                                    :disabled="whetherToDisablePerformanceModification || item.brokerageClass === 'no'"
                                    onfocus="this.select()" />
                                </template>
                                <i v-if="item.brokerageClass !== 'no'" class="iconfont icon-bianji1"></i>
                              </span>
                            </div>
                            <span class="iconfont icon-closel"
                              @click.stop="deletePersonalitySubCardEmployees(index)"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--          会员卡购卡      付款信息              -->
                    <div class="particulars">
                      <div class="particulars-title"><span class="iconfont icon-dingdan"></span> <span>付款方式</span></div>

                      <div class="paymentAmountStatistics">
                        <div class="title-content-item">
                          <span class="iconfont icon-yingfu"></span> <span>订单金额：</span> <span>{{ memberCardPrice |
                            amountType }}</span>
                        </div>
                        <i style="color: #1E90FF; font-size: 22px">【</i>
                        <div class="title-content-item">
                          <span>付现：</span> <span>{{ actualCashPay | amountType }}</span>
                        </div>
                         <div class="title-content-item" v-show="existingRechargeCards && existingRechargeCards.length&&selectMembershipCardItems.cardTypeCode==0&&!isNewMemberInfo">
                            <span>可耗卡：</span> <span>{{  haoCardMoney | amountType }}</span>
                         </div>
                        <div class="title-content-item" style="display: flex; align-items: center; margin: 0">
                          <span style="margin-right: 10px">优惠金额:</span>
                          <span style="width: 80px; height: 30px; display: flex"> <input
                              style="width: 100%; height: 100%; border-radius: 5px; border: 1px solid #E8E8E8; padding-left: 10px; box-sizing: border-box"
                              type="number" v-model="memberCoupon" @blur="onPriceChanged" onfocus="this.select()" /> </span>
                        </div>
                        <i style="color: #1E90FF; font-size: 22px">】</i>
                        <div class="achievements" v-if="departmentList === 1">
                          <span>部门业绩:</span>
                          <div>
                            <div class="assigned">
                              <div style="padding-right: 10px;height: 28px; line-height: 24px">
                                <span class="f20 text-primary">【</span>

                                <!-- <el-tooltip class="item" effect="dark" content="点击查看" placement="bottom" :disabled="totalCount === 0">
                                  <div class="div-Posting" @click="isInputShow">
                                    <span class="f20 text-primary">【</span><span>待分配:</span> <u>{{ totalCount }}</u>
                                  </div>
                                </el-tooltip> -->
                              </div>
                              <div v-for="item in isDepartmentalPerformance" :key="item.departmentId"
                                style="padding-right: 5px">
                                <div v-if="item.departmentName !== ''">
                                  <span class="text-primary">{{ item.departmentName }}: </span>
                                  <el-input size="mini" style="width: 50px;" v-model="item.achievement"
                                    :oninput="onInputNumPoint" />
                                </div>
                              </div>
                              <span class="f20 text-primary">】</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="order-content">
                        <div class="order-content-item" v-for="item in clearingForm" :key="item.iconfont"
                          @click="topUpPaymentAmount(item, 'openCard')">
                          <div class="typeOfPayment">
                            <span>
                              <svg class="icon" aria-hidden="true">
                                <use :href="`#${item.iconfont}`"></use>
                              </svg>
                            </span>
                            <span>{{ item.name }}</span> <span
                              :class="item.name === '智慧支付' && globalPaymentStatus === '1' ? 'money active' : 'money'"
                              v-if="item.paymentAmount > 0">{{ item.paymentAmount | amountType }}</span>
                          </div>
                        </div>

                      <!-- 开卡购卡--添加智慧耗卡：当有耗卡金额时展示 -->
                    <div class="order-content-item"
                      v-if="amountOfConsumableCardNumber > 0 || canConsumeCardIncreaseGold > 0">
                      <div class="typeOfPayment">
                        <span>
                          <svg class="icon" aria-hidden="true">
                            <use href="#icon-huiyuanqia"></use>
                          </svg>
                        </span>
                        <span>智慧耗卡</span>
                        <span class="money">
                          {{ accuracyCheck(amountOfConsumableCardNumber, canConsumeCardIncreaseGold) | amountType }}
                        </span>
                      </div>
                    </div>
                    <div class="interval"></div>
                      </div>

                      <div class="adjustedPayment">
                        <div class="cutOffRule"></div>
                        <!--            支付调整           -->
                        <div class="order-content-item" @click="adjustedPayment">
                          <div class="typeOfPayment">
                            <span>
                              <svg class="icon" aria-hidden="true">
                                <use href="#icon-hunhe"></use>
                              </svg>
                            </span>
                            <span>调整支付</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!--        type==4-内层抽屉         -->
                <el-drawer :append-to-body="true" size="40%" :show-close="false" :withHeader="false"
                  :before-close="innerDrawerHandleClose" :visible.sync="innerDrawer">
                  <div class="mixedPayment">
                    <div class="mixedPayment-title">
                      <span>支付详情，共需支付：<i>{{ cashByPersonalCard | amountType }}</i></span>
                      <span class="iconfont icon-guanbi" @click="innerDrawerHandleClose"></span>
                    </div>
                    <!--            修改支付方式
                    v-if="!(item.name === '耗卡本金' || item.name === '耗卡赠金') || consumptionApplicable" 负责"看不见"，resetRechargeCardConsumption 负责"把值清掉"        -->
                    <div class="modeOfPaymentList">
                      <div class="modeOfPaymentList-item topUp" v-for="item in modifyPaymentAmount" :key="item.name"
                        v-if="!(item.name === '耗卡本金' || item.name === '耗卡赠金') || consumptionApplicable">
                          <span style="white-space: nowrap">{{ item.name }}:</span>
                          <input type="text"
                            v-model="item.money"
                            @blur="item.name === '耗卡本金' || item.name === '耗卡赠金' ? validateCardConsumption(item) : excessOfAmount('openACard')"
                            oninput="value=value.replace(/[^0-9.]/g,'')" />
                        <template v-if="item.name === '智慧支付'">
                          <span @click="smartPayment">支付</span>
                        </template>
                      </div>
                    </div>
                  </div>
                </el-drawer>
                <!--        员工信息            -->
                <el-dialog :visible.sync="topUpEmployeeShow" width="50%" title="选择员工" :append-to-body="true"
                  :show-close="false" :before-close="closeTheMembershipScreeningPopup">
                  <div class="employeeList">
                    <div class="confirm" @click="firmChangeOrder('openACard')">确定</div>
                    <div class="dataBox">
                      <div class="con" v-for="item in topUpEmployeeList" :key="item.postName">
                        <div class="position">
                          <span class="iconfont icon-zhiwei"></span> <span>{{ item.postName }}</span>
                        </div>
                        <div class="staff">
                          <div :class="subItem.label ? 'staff-item active' : 'staff-item'"
                            v-for="subItem in item.employeeDataList" :key="subItem.id"
                            @click="personalitySubCardSelectionOfEmployees(subItem)">
                            <span>{{ subItem.employeeNo }}</span> <span>{{ subItem.employeeName }}</span>
                            <span>
                              <i v-show="subItem.num">{{ subItem.num }}</i> <i v-show="subItem.num"
                                class="iconfont icon-chacha" @click.stop="deleteEmployeeData(subItem.id)"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-dialog>
                <!--         智慧支付           -->
                <el-drawer :append-to-body="true" size="40%" :show-close="true" :withHeader="false"
                  :before-close="closeTheScanCodePaymentWindow" :visible.sync="intelligentPaymentState">
                  <div class="smartPayment">
                    <div class="wisdomPaysTitle">
                      <span>您当前正在通过</span>
                      <span class="paymentMethodDetails">
                        <span>
                          <svg class="icon" aria-hidden="true">
                            <use href="#icon-shoukuan"></use>
                          </svg>
                        </span>
                        <span>智慧支付</span>
                        <span v-show="!innerDrawer">{{
                          clearingForm.reduce((pv, cu) => {
                            if (cu.name === "智慧支付") return accuracyCheck(pv, cu.paymentAmount);
                            else return pv;
                          }, 0) | amountType
                        }}</span>
                        <span v-show="innerDrawer">{{
                          modifyPaymentAmount.reduce((pv, cu) => {
                            if (cu.name === "智慧支付") return accuracyCheck(pv, cu.money);
                            else return pv;
                          }, 0) | amountType
                        }}</span>
                      </span>
                    </div>
                    <div class="paymentModeSwitching">
                      <span :class="smartPaymentMethod === '0' ? 'active' : ''"
                        @click="switchingPaymentMethods('0', 'openCard')">商家扫码收款</span> <span
                        :class="smartPaymentMethod === '1' ? 'active' : ''"
                        @click="switchingPaymentMethods('1', 'openCard')">顾客扫码收款</span>
                    </div>

                    <div class="collectionContents">
                      <div class="merchantScanningCode" v-show="smartPaymentMethod === '0'">
                        <div class="paymentContent"><input type="text" ref="scanToPay" placeholder="请使用扫码枪扫码输入"
                            :value="codeNumber" @keydown="scanCodeGunInput"
                            oninput="value=value.replace(/[^0-9.]/g,'')" /> <span>支付</span></div>
                      </div>
                      <div class="customerScanCode" v-show="smartPaymentMethod === '1'">
                        <div class="paymentContent">
                          <div class="payBox">
                            <template>
                              <img :src="paymentCardPaymentAddress" alt="暂无开通拉卡拉" />
                            </template>
                            <template v-if="payState === 100">
                              <div class="payImg"><span class="iconfont icon-zhifuchenggong"></span> <span>支付中</span>
                              </div>
                            </template>
                            <template v-else-if="payState === 300">
                              <div class="payImg"><span class="iconfont icon-qunfengzhifuchenggong"></span>
                                <span>支成功</span>
                              </div>
                            </template>
                          </div>
                          <div class="payInfo"><span>扫码支付</span> <span>请顾客使用微信或支付宝扫此二维码</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-drawer>
              </div>
            </template>
          </div>
        </div>
      </template>
      <!--      员工轮牌    -->
      <template v-if="type === 5">
        <employeeRotation @handleClose="handleClose"></employeeRotation>
      </template>
    </el-drawer>
    <!-- 部门业绩弹出框开始 -->
    <el-dialog title="部门业绩分配" :visible.sync="isInput" width="30%">
      <div class="inputShow" v-if="DepartmentInput">
        <div>
          <h2>
            <span>未分配:</span> <span>{{ totalCount }}</span>
          </h2>
        </div>
        <div class="line_between"></div>
        <el-form>
          <el-form-item v-for="i in isDepartmentalPerformance" :key="i.departmentId" :label="i.departmentName">
            <el-input v-model="i.achievement" style="width: 100px" v-if="i.departmentId" :oninput="onInputNumPoint" />
          </el-form-item>
        </el-form>
      </div>
      <div v-else class="inputShow" style="height: 200px">
        <div>
          <h2>
            <span>未分配:</span> <span>{{ totalCount }}</span>
          </h2>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isInput = false">取 消</el-button>
        <el-button type="primary" @click="isInputAddTo">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 部门业绩弹出框结束 -->
  </div>
</template>

<script>
import { Loading } from "element-ui";
import moment from "moment";
import quantityInputModule from "./quantityInputModule/index.vue";
import dummyInput from "./dummyInput/index.vue";
import timeHorizon from "./timeHorizon/index.vue";
import paperlessPublic from "../mixins/paperlessPublic";

import employeeRotation from "./employeeRotation/index.vue"; // 轮牌组件
import { mapState } from "vuex";

import receivingAudio from "../../../common/receivingAudio";

export default {
  name: "pendingOrder",
  data() {
    return {
      //控制无纸化充值卡列表的显示
      isShow:false,
      // 流水订单字段开始
      endTime: "", //结束时间
      startTime: "", //开始时间
      customerCount: 1, // 客数

      RunningOrdersShow: false, //重复订单显示
      RunningOrdersText: "", //重复订单提示字段

      // 流水订单字段开始

      odd: "", // 手牌号
      addOdd: "", // 添加手牌号
      intelligentPaymentState: false, // 智慧支付状态
      smartPaymentMethod: "0", // 0商家 1顾客
      paymentCardPaymentAddress: "", // 智慧耗卡支付地址
      paymentOrderId: "", // 支付订单id
      paymentTimer: "", // 支付计时器
      payState: "", // 支付状态
      isMies: true, // 是否发送消费消费类短信
      memberSex: 0, // 用户性别
      //2026.8.5新增
      existingRechargeCards: [], // 新增：存储会员已有的所有充值卡完整信息
      selectedRechargeCard: null, // 当前选中的充值卡对象（null 表示未选中）
      //9.4加
      haoCardMoney:0,
      // 支付方式
      clearingForm: [
        {
          name: "微信",
          iconfont: "icon-weixin",
          paymentAmount: 0,
        },
        {
          name: "支付宝",
          iconfont: "icon-zhifubaozhifu",
          paymentAmount: 0,
        },
        {
          name: "现金",
          iconfont: "icon-_xianjin",
          paymentAmount: 0,
        },
        {
          name: "银联刷卡",
          iconfont: "icon-yinlian",
          paymentAmount: 0,
        },
        {
          name: "团购",
          iconfont: "icon-tuangou",
          paymentAmount: 0,
        },
        {
          name: "代金券",
          iconfont: "icon-daijinjuan",
          paymentAmount: 0,
        },
        {
          name: "智慧支付",
          iconfont: "icon-zhifu",
          paymentAmount: 0,
        },
        {
          name: "其他",
          iconfont: "icon-qitaxuanze",
          paymentAmount: 0,
        },
      ],
      inputEquipmentShow: false, // 外层抽屉
      innerDrawer: false, // 内层抽屉
      numberOfCardConsumptionNumber: 0, // 可耗卡次数
      amountOfConsumableCardNumber: 0, // 可耗卡金额（本金）
      canConsumeCardIncreaseGold: 0, // 可耗卡金额（增金）
      settlementAllowance: 0, // 结算价优惠金额
      // 修改支付方式
      //调整支付用
      modifyPaymentAmount: [
        {
          name: "微信",
          money: "",
        },
        {
          name: "支付宝",
          money: "",
        },
        {
          name: "现金",
          money: "",
        },
        {
          name: "银联刷卡",
          money: "",
        },
        {
          name: "团购",
          money: "",
        },
        {
          name: "代金券",
          money: "",
        },
        {
          name: "智慧支付",
          money: "",
        },
        {
          name: "其他",
          money: "",
        },
        {
          name: "耗卡本金",
          money: "",
        },
         {
          name: "耗卡赠金",
          money: "",
        },
      ],
      topUpEmployeeList: [], // 员工列表
      topUpEmployeeShow: false, // 销售员工弹窗
      topUpSalesStaffList: [], // 充值销售员工列表
      rechargeObject: {
        rechargeAmount: 0, // 充值金额
        amountOfGift: 0, // 赠送金额
        discountAmount: 0, // 优惠金额
      },
      checkOrdersByDate: [], // 根据日期查询订单
      dateFilteringPopsUp: false, // 日期筛选弹出
      theHandNumberPopsUp: false, // 修改挂单弹出
      occupied: [], // 已挂单数据
      updateTheCorrespondingDataOfTheHand: null, // 更新手牌对应订单数据
      orderTimeTiming: [], // 计算挂单时间
      orderTimeOut: null, // 计时器id
      /** ***************************************************** 开卡 ***************************************************** **/
      memberListShow: true, // 会员信息数据框
      membershipCardTransferList: [], // 会员转卡列表
      transferCardInformation: null, // 充值卡转卡信息
      memberTransferCardBoxShow: false, // 会员转卡盒子
      membershipData: {
        memberClass: [
          {
            value: "粉丝会员",
            label: "粉丝会员",
          },
          {
            value: "普通会员",
            label: "普通会员",
          },
          {
            value: "白银会员",
            label: "白银会员",
          },
          {
            value: "黄金会员",
            label: "黄金会员",
          },
          {
            value: "铂金会员",
            label: "铂金会员",
          },
          {
            value: "钻石会员",
            label: "钻石会员",
          },
        ],
        source: [
          {
            value: "团购",
            label: "团购",
          },
          {
            value: "系统录入",
            label: "系统录入",
          },
          {
            value: "手工录入",
            label: "手工录入",
          },
          {
            value: "顾客推荐",
            label: "顾客推荐",
          },
        ],
      },
      activeName: "openACard",
      openTheCardItemList: [], // 开卡卡项列表
      listOfSubCardItems: [], // 次卡项目列表
      modifyPopUp: false, // 修改个性次卡
      numberOfSubCards: 1, // 次卡次数
      subCardTimeLimit: -1, // 次卡时限
      theSecondCardSelectsTheItem: {}, // 次卡选择的项目
      personalizedTimesCardPurchase: [], // 个性次卡选购
      cardPurchase: false, // false选卡 true购卡
      memberCardPrice: 0, // 会员开卡价格
      memberCoupon: 0, // 会员优惠金额
      amountOfGift: 0, // 赠送金额
      membershipCardRemarks: "", // 会员卡备注
      personalitySubCardEmployeeList: [], // 个性次卡员工列表
      selectMembershipCardItems: null, // 选购的会员卡项
      memberEditor: true, // 会员编辑
      // 修改会员数据
      editMemberInformationContent: {
        birthday: "", // 生日时间
        memberLevelName: "粉丝会员", // 会员等级
        memberSourceName: "手工录入", // 顾客来源
        memberMobile: "", // 会员手机号
        memberName: "", // 会员姓名
        memberNo: "", // 会员号
        gender: 0, // 性别
        deductionsState: 1, // 是否匹配
        remark: "", // 备注
        id: "", // 会员id
        wechatAccount: "", // 微信号
      },
      currentlyTheOrderIsSelected: [], // 当前所选的挂单列表
      barCode: "", // 条码
      timearr: [], // 记录用户输入内容所用时间
      laklaShow: "", // 校验是否开通拉卡拉
      tradeNo: "", // 拉卡拉流水单号
      codeNumber: "", // 用户所扫描的付款码
      paymentSuccessful: false, // 判断是否成功支付 true 成功支付 false待支付
      timeIndex: 0, // 计时
      isNewMemberInfo: false, // 是否可进行新增
      taggedMember: [], // 已开会员卡
      idOfTheCurrentlySelectedEmployee: "", // 当前所选员工id
      listOfEmployeeRoyaltyRightsData: [], // 员工提成权限数据列表
      openCardTemporaryDataList: [], // 开卡临时数据列表
      oddID: "",
      // 默认手牌号
      defaultHandNumber: [
        { hand: "001" },
        { hand: "002" },
        { hand: "003" },
        { hand: "004" },
        { hand: "005" },
        { hand: "006" },
        { hand: "007" },
        { hand: "008" },
        { hand: "009" },
        { hand: "010" },
        { hand: "011" },
        { hand: "012" },
        { hand: "013" },
        { hand: "014" },
        { hand: "015" },
        { hand: "016" },
        { hand: "017" },
        { hand: "018" },
        { hand: "019" },
        { hand: "020" },
      ],
      billNumber: "", // 流水单号
      localServerTime: new Date(),
      unassigned: 0, // 未分配业绩
      performance: 0, // 已分配业绩
      isInput: false, // 未分配输入框
      DepartmentalPerformance: [], // 部门业绩分配
      // isDepartmentalPerformance: [], // 业绩修改是否是部门
      DepartmentInput: false,
      DepartmentList: [], // 部门列表
      orderId: "", // 订单id
      isFocusedAndBlurred: false,
      oldData: null, // 保存修改前的数据
      consumeObj: {
        chargeTime: "",
        remark: "",
        orderType: 30,
        payTypeDTOList: [],
        consumeDTO: [],
        customerSex: "0",
      },
      onInputNumPoint: "value=value.replace(/[^0-9.]/g,'')", // 只能输入数字和小数点
    };
  },
  // props父组件传参
  props: {
    departmentList: {
      type: Number,
      default: false,
    },
    isDepartmentalPerformance: {
      type: Object,
      default: (_) => [],
    },
    DepartmentalList: {
      type: Object,
      default: (_) => [],
    },
    orderPrice: {
      type: Array,
      default: (_) => { },
    },
    drawer: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
    },
    currentSelectedMember: {
      type: Object,
      required: true,
      default: (_) => ({
        memberName: "", // 会员姓名
        memberMobile: "", // 会员手机号
        memberNo: "", // 会员编号
        wechatAccount: "", // 微信号
        memberLevelName: "", // 会员等级
        memberSourceName: "手工录入", // 来源
        birthday: "", // 生日
        gender: "2", // 性别
      }),
    },
    orderData: {
      type: Array,
      default: (_) => [],
    },
    currentlySelectedCard: {
      type: Object,
      default: (_) => ({}),
    },
    orderTypes: {
      type: Number,
      default: 0,
    },
    orderDataHasBeenPosted: {
      type: Array,
      default: (_) => [],
    },
  },
  components: {
    quantityInputModule,
    dummyInput,
    timeHorizon,
    employeeRotation,
  },
  mounted() {
    this.localServerTime = this.serverTime || JSON.parse(localStorage.getItem("serverTime"));

    // 设置订单默认时间
    this.checkOrdersByDate = [moment(new Date(this.localServerTime.date.split(" ")[0])).format("YYYY-MM-DD 00:00:00"), moment(new Date(this.localServerTime.date.split(" ")[0])).format("YYYY-MM-DD 23:59:59")];
    this.updatePermissionData(); // 获取权限数据
  },
  mixins: [paperlessPublic],
  directives: {},
  filters: {
    //挂单的名字截断
     nameMask(name) {
    if (!name) return "";
    const str = String(name);
    // 超过 3 个字符：前 3 位 + 后面固定 *
    return str.length > 3 ? str.slice(0, 3) +"**" : str;
  },
    // 金钱计算
    amountType(amount) {
      amount = amount || 0;
      return "￥" + parseFloat(amount).toFixed(2);
    },
    // 计算卡有效期
    filterCalculationCardValidityPeriod(numberOfDays) {
      if (numberOfDays >= 9999) return "无限";
      else return numberOfDays;
    },
    // 日期格式化
    dateType(date) {
      let toDate = date.split(" ");
      let yearToDate = toDate[0].split("-");
      let hourMinuteSecond = toDate[1].split(":");
      let [year, month, day, time, minute, second] = [...yearToDate, ...hourMinuteSecond];
      return `${month}-${day} ${time}:${minute}`;
    },
  },
  watch: {
    // 监听手机号变化
  'editMemberInformationContent.memberMobile'(newVal, oldVal) {
    //手机号变化时支付方式没清空,后面有空加
    if (newVal !== oldVal && oldVal) {
      // 手机号变化时，先清空充值卡列表（等查询到新会员再重新填充）
      this.existingRechargeCards = [];
      this.taggedMember = [];
      this.selectedRechargeCard = null;//  清空选中的充值卡
      this.memberCoupon = 0; // 新增：清空优惠金额
      this.haoCardMoney=0;
      //其实有空可以优化一下,把要清空的耗卡数据包装成一个方法要清空耗卡数据直接调用方法就行这样不会乱,但这交给后来者了,26年9月5号
      this.resetRechargeCardConsumption();
    }
  },
      // 监听会员是否存在状态变化
  isNewMemberInfo(newVal) {
    if (newVal === true) {
      // 切换为新会员时，清空所有耗卡相关数据
      this.resetRechargeCardConsumption();

      // 同时清空选中的充值卡
      this.selectedRechargeCard = null;

      // 清空内层抽屉中的耗卡输入值
      this.modifyPaymentAmount.forEach(item => {
        if (item.name === '耗卡本金' || item.name === '耗卡赠金') {
          item.money = '';
        }
      });

      // 清空支付方式中的智慧耗卡金额
      this.clearingForm.forEach(item => {
        if (item.name === '智慧耗卡') {
          item.paymentAmount = 0;
        }
      });
      //  重置微信支付为现付金额
      this.$nextTick(() => {
        // 清空所有支付方式
        this.clearingForm.forEach(item => {
          item.paymentAmount = 0;
        });
        // 设置微信支付 = cashByPersonalCard
        const wechat = this.clearingForm.find(item => item.name === "微信");
        if (wechat) {
          wechat.paymentAmount = this.cashByPersonalCard;
        }
      });
    }
},
    //2026年8.10添加三个监听方法
    //监听开卡价格
      memberCardPrice() {
        //this.syncPaymentOnPriceChange();//填入现有的支付方式
        //先给它全清空了再填入价格
         this.clearAllPayments();//这个是共用清空方法清空全部支付方式
         this.defaultAmount();//这个是公用方法,默认填入微信
  },
//监听优惠
  memberCoupon() {
     //先给它全清空了再填入价格
     this.clearAllPayments();//这个是共用清空方法,清空全部支付方式
    this.defaultAmount();//这个是公用方法,默认填入微信
  },

  cardPurchase(newVal) {
    // 进入个性次卡购卡界面时初始化支付金额
    if (newVal && this.type === 4 && this.activeName === 'personalitySubcard') {
      this.$nextTick(() => {
        this.defaultAmount();
      });
    }
  },
    // 监听部门业绩
    DepartmentalList() {
      this.getDepartmentalPerformance();
    },
    // 计算耗卡次数
    orderData: {
      deep: true,
      immediate: true,
      handler(newValue) {
        // 监听用户当前所选卡项是否是次卡或者个性次卡
        if (this.isSubcard) {
          // 如果次卡有折扣项目 则添加耗卡次数
          this.numberOfCardConsumptionNumber = newValue.reduce((previousValue, currentValue) => {
            if (currentValue.isDiscount) return ++previousValue;
            else return previousValue;
          }, 0);
        }
      },
    },
    // 个性次卡监听总次数是否发生变总次数发生变化开卡价格清空
    countTheTotalNumberOfIndividualCycles() {
      this.memberCardPrice = 0; // 清空开卡价格
      this.clearingForm.forEach((item) => {
        item.paymentAmount = 0;
      });
    },
    // 监听支付订单是否发生变化
    paymentOrderId(newValue) {
      if (this.paymentTimer) clearInterval(this.paymentTimer);
      if (!newValue) return;
      console.log("订单id发生变化");
      // 每2秒监听一下是否支付方程
      this.enableOrderPaymentStatus();
    },
    // 监听是否修改了优惠金额
    settlementAllowance() {
      this.clearingForm.forEach((item) => {
        item.paymentAmount = 0;
      });
    },
    // //监听充值金额变化,用原本的@key方法
    // 'rechargeObject.rechargeAmount':{
    //     handler() {
    //       console.log("监听充值金额变化")
    //     this.clearingForm.forEach((item) => {
    //       item.paymentAmount = 0;
    //     });
    //   },
    // },
    // 监听充值优惠金额变化
    "rechargeObject.discountAmount": {
      handler() {
         console.log("监听优惠金额变化")
        this.clearingForm.forEach((item) => {
          item.paymentAmount = 0;
        });
         this.clearingForm.forEach((item) => {
      item.name === "微信" && (item.paymentAmount = this.settlementAmount > 0 ? this.settlementAmount : 0);
    });
      },
    },
    drawer(newVal) {
      if (newVal && this.type === 1) {
        const serverTimeStr = localStorage.getItem('serverTime')
        if (serverTimeStr) {
          try {
            const serverTime = JSON.parse(serverTimeStr)
            if (serverTime && serverTime.date) {
              this.checkOrdersByDate = [
                moment(new Date(serverTime.date.split(' ')[0])).format('YYYY-MM-DD 00:00:00'),
                moment(new Date(serverTime.date.split(' ')[0])).format('YYYY-MM-DD 23:59:59')
              ]
            }
          } catch (e) {
            console.error('解析 serverTime 失败', e)
          }
        }
      }
    },
  },
  computed: {

    // 用于界面显示的实付现金（订单金额 - 已耗卡 - 优惠）
actualCashPay() {
  // 已耗卡合计（本金 + 赠金）
  //不要这个因为这个改输入框值,付现也变太智能了,暂时不用
 // const totalCard = this.accuracyCheck(this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold);
 const totalCard = this.haoCardMoney;
  // 订单金额 - 耗卡 - 优惠，若小于0则显示0
  let cash = this.accuracyCheck(this.memberCardPrice, totalCard, '-');
  cash = this.accuracyCheck(cash, this.memberCoupon, '-');
  //return Math.max(0, cash);
  return cash;
},
    ...mapState(["serverTime"]),
    // 部门业绩分配
    totalName() {
      return Math.max(0, this.isDepartmentalPerformance.reduce((total, item) => total - item.achievement, this.memberCardPrice).toFixed(2));
    },
    totalCount() {
      return Math.max(0, this.isDepartmentalPerformance.reduce((total, item) => total - item.achievement, this.performance).toFixed(2));
    },
    totalAmount() {
      return Math.max(0, this.isDepartmentalPerformance.reduce((total, item) => total - item.achievement, this.rechargeObject.rechargeAmount).toFixed(2));
    },

    /** ***************************************************** 开单 ***************************************************** **/
    // 商品价格合计
    amountInTotal() {
      return this.orderData.reduce((previousValue, currentValue) => {
        return this.accuracyCheck(parseFloat(previousValue), parseFloat(currentValue.total));
      }, 0);
    },
    // 计算可耗卡金额
    amountOfConsumableCard() {
      // 散客消费取消监听
      if (!this.currentlySelectedCard) return 0;
      let cardTypeCode = "";
      let givenAmount = "";
      let initAmount = "";
      if (this.currentlySelectedCard.tmemberCard) {
        cardTypeCode = this.currentlySelectedCard.tmemberCard.cardTypeCode;
        givenAmount = this.currentlySelectedCard.tmemberCard.givenAmount;
        initAmount = this.currentlySelectedCard.tmemberCard.initAmount;
      }

      if (Number(cardTypeCode) === 3 || Number(cardTypeCode) === 0) return 0;
      // 计算订单中可耗卡金额统计
      let totalCardConsumption = this.orderData.reduce((previousValue, currentValue) => {
        if (currentValue.isDiscount) return previousValue + parseFloat(currentValue.total);
        return previousValue;
      }, 0);
      // 订单中可耗卡金额统计大于（赠金+本金）则返回（赠金+本金）的最大值，如果小于则返回订单中可耗卡金额统计大于
      return totalCardConsumption >= givenAmount + initAmount ? givenAmount + initAmount : totalCardConsumption;
    },
    // 是次卡 true次卡、个性次卡 false充值卡
    isSubcard() {
      // 散客消费取消监听
      if (!this.currentlySelectedCard) return;
      // const { cardTypeCode } = this.currentlySelectedCard.tmemberCard // 获取卡号
      let cardTypeCode = this.currentlySelectedCard.tmemberCard ? this.currentlySelectedCard.tmemberCard.cardTypeCode : null;
      if (cardTypeCode === 3 || cardTypeCode === 0) return true;
      else return false;
    },
    // 判断当前是散客还是会员消费 true会员 false散客
    isIndividualTraveler() {
      if (this.currentlySelectedCard) return true;
      else return false;
    },
    // 计算本金增金是否可修改
    calculateThePrincipalIncreaseModification() {
      // 散客消费取消监听
      if (!this.currentlySelectedCard) return 0;
      let cardTypeCode = "";
      let givenAmount = "";
      let initAmount = "";
      if (this.currentlySelectedCard.tmemberCard) {
        cardTypeCode = this.currentlySelectedCard.tmemberCard.cardTypeCode;
        givenAmount = this.currentlySelectedCard.tmemberCard.givenAmount;
        initAmount = this.currentlySelectedCard.tmemberCard.initAmount;
      }
      if (Number(cardTypeCode) === 3 || Number(cardTypeCode) === 0) return [false, false];
      return [initAmount > 0, givenAmount > 0];
    },
    // 计算组合支付金额合计
    adjustTheTotalPaymentAmount() {
      // 计算修改金额
      let calculatedAmount = this.modifyPaymentAmount.reduce((previousValue, currentValue) => {
        return this.accuracyCheck(previousValue, currentValue.money);
      }, 0);
      if (calculatedAmount > 0) return calculatedAmount;
      else return 0;
    },
    // 计算是否可进行支付 true 可支付 false 不可支付
    whetherItIsPayableOrNot() {
      console.log("计算是否可进行支付");
      // console.log("测试", this.orderPrice);
      // 智慧耗卡（本金） + 智慧耗卡（增金）
      let principalAndIncrease = this.accuracyCheck(this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold);
      // 其他支付
      let otherPayments = this.clearingForm.reduce((previousValue, currentValue) => {
        return this.accuracyCheck(previousValue, currentValue.paymentAmount);
      }, 0);
      let wisdomConsumptionCard = this.amountOfConsumableCard === principalAndIncrease ? this.amountOfConsumableCard : principalAndIncrease;
      // 加上优惠金额
      let totalValueOfGoods = this.accuracyCheck(wisdomConsumptionCard, this.settlementAllowance);
      // 判断优惠金额是否大于订单金额本身
      if (this.accuracyCheck(this.amountInTotal, totalValueOfGoods, "-") === 0) {
        return true;
      } else {
        return this.accuracyCheck(otherPayments, totalValueOfGoods) === this.amountInTotal;
      }
    },
    // 计算该订单是否存在智慧耗卡 true存在 false不存在
    whetherThereIsWisdomConsumptionCard() {
      // numberOfCardConsumptionNumber, // 可耗卡次数
      // amountOfConsumableCardNumber, // 可耗卡金额（本金）
      // canConsumeCardIncreaseGold, // 可耗卡金额（增金）
      let rechargeTheCard = this.accuracyCheck(this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold);
      return rechargeTheCard > 0 || this.numberOfCardConsumptionNumber > 0;
    },
    /** ***************************************************** 会员充值 ***************************************************** **/
    // 充值订单结算金额
    settlementAmount() {
      // 充值金额 - 优惠金额
      return this.accuracyCheck(this.rechargeObject.rechargeAmount, this.rechargeObject.discountAmount, "-");
    },
    // 充值单计算是否可进行支付 true可支付 false不可支付
    whetherTheTopUpOrderIsPayable() {
      // 统计付款金额
      let amountInTotal = this.clearingForm.reduce((previousValue, currentValue) => {
        return this.accuracyCheck(previousValue, currentValue.paymentAmount);
      }, 0);
      // 判断充值金额是否大于0
      if (this.rechargeObject.rechargeAmount > 0) {
        // 如果充值金额大于0 在判断充值金额 - 优惠金额是否等于所统计的付款金额
        return amountInTotal === this.settlementAmount;
        // 如果充值金额等于0 在判断优惠金额是否大于0
      } else if (this.rechargeObject.amountOfGift > 0) {
        return amountInTotal === this.settlementAmount;
      }
    },
    // 计算个性次卡开卡总次数
    countTheTotalNumberOfIndividualCycles() {
      return this.personalizedTimesCardPurchase.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.numberOfSubCards;
      }, 0);
    },
    // 开卡价格 - 优惠金额
    //计算属性会在依赖的价格数据变化时自动重新计算，间接实现“监听"
   cashByPersonalCard() {
  // 应付金额 = 开卡价格 - 优惠金额
  //  this.$nextTick(() => {
  //         this.clearingForm.forEach((item) => {
  //         item.paymentAmount = 0;
  //         item.name === "微信" && (item.paymentAmount = cashPayment <= 0 ? 0 : cashPayment);
  //           });
  //         });
  return this.accuracyCheck(this.memberCardPrice, this.memberCoupon, '-');
  //this.memberCardPrice 是订单金额（即开卡价格）。
//this.memberCoupon 是优惠金额。
},
// 智慧耗卡是否适用：个性次卡，或会员卡里的次卡(cardTypeCode === 0)
consumptionApplicable() {
  //   // 新会员不能耗卡
  // if (this.isNewMemberInfo) return false;

    if (this.activeName === 'personalitySubcard') return true;
    return !!(this.selectMembershipCardItems && this.selectMembershipCardItems.cardTypeCode === 0);
},
    // 计算个性次卡单是否可进行支付 true可支付 false 不可支付
    individualCardPaymentStatus() {
      // 9.4 新增：优惠金额不能大于订单金额
  // if (this.memberCoupon > this.memberCardPrice) {
  //   return false;
  // }
      let amountInTotal = this.clearingForm.reduce((previousValue, currentValue) => {
        return this.accuracyCheck(previousValue, currentValue.paymentAmount);
      }, 0);
        // 智慧耗卡（本金 + 赠金）
          const cardConsumption = this.accuracyCheck(
            this.amountOfConsumableCardNumber,
            this.canConsumeCardIncreaseGold
          );
           // 总支付 = 其他支付 amountInTotal+ 智慧耗卡cardConsumption
        const totalPayment = this.accuracyCheck(amountInTotal, cardConsumption);
        // // 应付 <= 0 时，要求所有支付方式总金额为 0
        //   if (this.cashByPersonalCard <= 0) {
        //     return totalPayment === 0;
        //   }
        // // if (this.cashByPersonalCard <= 0) return true;
        // else if (totalPayment === 0) return false;
        // else return totalPayment === this.cashByPersonalCard;
                      // ① 优惠 > 开卡价：应付为负，直接不允许支付（与充值行为一致）
              if (this.cashByPersonalCard < 0) return false;

              // ② 优惠 = 开卡价：应付为 0，要求所有支付方式合计为 0
              if (this.cashByPersonalCard === 0) return totalPayment === 0;

              // ③ 正常：支付合计必须等于应付
              return totalPayment === this.cashByPersonalCard;
    },
    /** ***************************************************** 挂单 ***************************************************** **/
    // 是否可进行合并订单 true 可合并 false不可合并
    combinedSingularStat() {
      return this.currentlyTheOrderIsSelected.length > 1;
    },
    // 计算当前会员是否是新会员
    isNewMember() {
      return !!this.editMemberInformationContent.id;
    },
    // 挂单员工
    pendingEmployee() {
      let newOrderData = [];
      let employeeList = [];
      this.orderDataHasBeenPosted.forEach((item) => {
        item.employeeMap.forEach((subItem) => {
          this.$set(subItem, "num", 0);
          employeeList.push(subItem);
        });
      });
      employeeList.forEach((item) => {
        let sign = true;
        newOrderData.forEach((subItem) => {
          if (item.employeeNo === subItem.employeeNo) {
            sign = false;
          }
        });

        if (sign) {
          newOrderData.push(item);
        }
      });

      newOrderData.forEach((item) => {
        this.orderDataHasBeenPosted.forEach((subItem) => {
          this.employeeWeightRemoval(subItem.employeeMap).forEach((emp) => {
            if (item.employeeNo === emp.employeeNo) item.num++;
          });
        });
      });
      return newOrderData;
    },
    // 挂单列表
    pendingOrderList() {
      if (this.idOfTheCurrentlySelectedEmployee === "") return this.orderDataHasBeenPosted;
      return this.orderDataHasBeenPosted.filter((item) => {
        return item.employeeMap.some((subItem) => this.idOfTheCurrentlySelectedEmployee === subItem.id);
      });
    },
  },
  created() {
    this.getCurrentTime();
    // // 获取部门业绩
    // console.log("objData", this.DepartmentalList);
    this.getDepartmentalPerformance();
  },

  methods: {
handleTakeOrder(item) {
  const dates = (this.checkOrdersByDate || []).map(d => (d || "").split(" ")[0]);
  const startTime = dates[0] ? dates[0] + " 00:00:00" : "";
  const endTime = dates[1] ? dates[1] + " 23:59:59" : "";

  this.API.paperless.obtainOrderingData({
    status: 100,
    pageIndex: 1,
    pageSize: 500,
    startTime,
    endTime,
    sort: 2,
    repeat: 2,
    extraNum: 2,
    extraStatue: 1,
    countMemberNum: 0,
    handBrand: "",
  }).then((res) => {
    const list = (res.data.pageInfo.list || []).filter(o => o.orderType === 40);
    const target = list.find(o => o.id === item.id);
    if (!target) {
      this.$message.warning("该挂单已不存在，请刷新后重试");
      return;
    }
    this.takeTheOrder(target, target.handBrand);   // 用最新的 target 走取单
  });
},

 handleBack() {//点击 返回的事件
 //返回清空开卡金额
  this.memberCardPrice = 0;
  console.log("点击了返回的事件")
      this.cardPurchase = false
        //  清空部门业绩填的值（开卡/充值用的 isDepartmentalPerformance，结算用的 DepartmentalList 一起清）
  this.isDepartmentalPerformance.forEach(item => {
    item.achievement = 0;
  });
  if (Array.isArray(this.DepartmentalList)) {
    this.DepartmentalList.forEach(item => {
      item.achievement = 0;
    });
  }
      // 这里加你要执行的方法
      //isShow默认flase
      // if( this.isShow)//如果isShow=flase
      // this.openCardShow()
      //this.selectMembershipCardItems = null;//清空选中的卡项//像是有隐藏的bug暂时先不清
      this.memberCoupon = 0;//返回就清空优惠金额
       this.membershipCardRemarks = "";    //  清空会员卡备注
       this.personalitySubCardEmployeeList = [];  //  清空开卡员工
       this.openCardTemporaryDataList = [];       //  清空员工弹窗里的临时选中
       this.clearingForm.forEach((item) => (item.paymentAmount = 0));//清空支付方式
       if (this.isShow) {
         this.isShow =false
    this.selectedRechargeCard = null;
    this.amountOfConsumableCardNumber = 0;
    this.canConsumeCardIncreaseGold = 0;
    this.haoCardMoney=0;

    // 清空内层抽屉中的耗卡输入
    this.modifyPaymentAmount.forEach(item => {
      if (item.name === '耗卡本金' || item.name === '耗卡赠金') {
        item.money = '';
      }
    });

    // 清空支付方式中的智慧耗卡
    this.clearingForm.forEach(item => {
      if (item.name === '智慧耗卡') {
        item.paymentAmount = 0;
      }
    });
    // 清除全部支付方式重置微信支付为现付金额
      this.$nextTick(() => {
        // 清空所有支付方式
        this.clearingForm.forEach(item => {
          item.paymentAmount = 0;
        });
        // 设置微信支付 = cashByPersonalCard
        const wechat = this.clearingForm.find(item => item.name === "微信");
        if (wechat) {
          wechat.paymentAmount = this.cashByPersonalCard;
        }
      });
  }

    },

    onPriceChanged() {
  if (this.selectedRechargeCard) {
    this.applyRechargeCardPayment();
  }
},
    applyRechargeCardPayment() {
  if (!this.selectedRechargeCard) return;// 如果没有选中任何充值卡，则直接退出，不进行耗卡金额分配
  const payable = this.cashByPersonalCard;// 获取当前订单的“应付现金”金额->订单金额（memberCardPrice） - 优惠金额（memberCoupon）
   const payMoney = this.memberCardPrice;
  const initAmount = parseFloat(this.selectedRechargeCard.initAmount) || 0;// 获取所选充值卡的本金余额（未消费的充值本金），若为空则默认为 0
  const givenAmount = parseFloat(this.selectedRechargeCard.givenAmount) || 0;// 获取所选充值卡的赠金余额（商家赠送的金额），若为空则默认为 0
  const cardTotal = initAmount + givenAmount;//// 计算该张充值卡的总可用余额（本金 + 赠金），用于后续判断能否全额抵扣订单金额
  this.haoCardMoney = Math.min(this.memberCardPrice, cardTotal);

  // 清空所有现金支付方式（微信、支付宝等）
  this.clearingForm.forEach(item => item.paymentAmount = 0);

  let usePrincipal = 0;
  let useBonus = 0;

  if (cardTotal >= payMoney && payMoney > 0) {
    // 卡余额足够：全部用智慧耗卡，现金为0
    if (initAmount >= payMoney) {
      usePrincipal = payMoney;
    } else {
      usePrincipal = initAmount;
      useBonus = this.accuracyCheck(payMoney, initAmount, '-');
    }
  } else if (cardTotal > 0 && cardTotal < payMoney) {
    // 卡余额不足：卡全用完，手动补差额
    usePrincipal = initAmount;
    useBonus = givenAmount;
  //   const remainder = this.accuracyCheck(payable, cardTotal, '-');
  //   const wechat = this.clearingForm.find(item => item.name === "微信");
  //   if (wechat) wechat.paymentAmount = remainder;
  // } else {
  //   // 卡余额为0，全部微信
  //   const wechat = this.clearingForm.find(item => item.name === "微信");
  //   if (wechat) wechat.paymentAmount = payable;
  }

  // 更新耗卡金额（同步到数据和内层抽屉）
  this.amountOfConsumableCardNumber = usePrincipal;
  this.canConsumeCardIncreaseGold = useBonus;
  this.modifyPaymentAmount.forEach(item => {
    if (item.name === '耗卡本金') item.money = usePrincipal;
    if (item.name === '耗卡赠金') item.money = useBonus;
  });
},
// 重置耗卡数据（切卡/开非次卡时调用）
resetRechargeCardConsumption() {
    this.selectedRechargeCard = null;
    this.amountOfConsumableCardNumber = 0;
    this.canConsumeCardIncreaseGold = 0;
    this.modifyPaymentAmount.forEach(item => {
        if (item.name === '耗卡本金' || item.name === '耗卡赠金') item.money = 0;
    });
},
     //26.8.5添加选中卡时逻辑,对本金赠金输入框进行限制输入
    validateCardConsumption(item) {
  // 没选卡不给填
  if (!this.selectedRechargeCard) {
    item.money = '';
    return this.$message.warning('请先选择充值卡');
  }

  const inputVal = parseFloat(item.money) || 0;//输入的本金值或赠金值
  const maxPrincipal = parseFloat(this.selectedRechargeCard.initAmount) || 0;//本金
  const maxBonus = parseFloat(this.selectedRechargeCard.givenAmount) || 0;//赠金

  // 校验本金不能超过卡的本金
  if (item.name === '耗卡本金' && inputVal > maxPrincipal) {
    this.$message.warning(`本金不能超过卡余额：￥${maxPrincipal}`);
    item.money = maxPrincipal;
    return this.$message.warning('本金不能超过卡的本金');
  }

  // 校验赠金不能超过卡的赠金
  if (item.name === '耗卡赠金' && inputVal > maxBonus) {
    this.$message.warning(`赠金不能超过卡余额：￥${maxBonus}`);
    item.money = maxBonus;
  }

  // 同步到外层
  const principalItem = this.modifyPaymentAmount.find(i => i.name === '耗卡本金');
  const bonusItem = this.modifyPaymentAmount.find(i => i.name === '耗卡赠金');
  this.amountOfConsumableCardNumber = parseFloat(principalItem.money) || 0;
  this.canConsumeCardIncreaseGold = parseFloat(bonusItem.money) || 0;

  // 继续走金额差额校验
  this.excessOfAmount('openACard');
},
    //26.8.5添加选中卡时逻辑,选中先获取现付金额,当选中卡本金+赠金大于现付,则清空其他支付方式,在本金和赠金输入框填入
    selectRechargeCard(card) {
  // 如果点击的是已选中的卡，则取消选中（用唯一 id 判断，避免同名卡误判）
  if (this.selectedRechargeCard && this.selectedRechargeCard.id === card.id) {
    this.selectedRechargeCard = null;
    // 清空耗卡
    this.amountOfConsumableCardNumber = 0;
    this.canConsumeCardIncreaseGold = 0;
    this.haoCardMoney=0;
    this.modifyPaymentAmount.forEach(item => {
      if (item.name === '耗卡本金' || item.name === '耗卡赠金') item.money = 0;
    });
    // 恢复默认：微信付全款
    const payable = this.cashByPersonalCard;
    this.clearingForm.forEach(item => {
      item.paymentAmount = 0;
      if (item.name === '微信') item.paymentAmount = payable;
    });
    return;
  }

  // 选中新卡
  this.selectedRechargeCard = card;
  this.applyRechargeCardPayment(); // 自动分配
},
    // 获取个性次卡某个分类下的可用拼音首字母
    getPackageAvailableLetters(cardGroup) {
      if (!cardGroup || !cardGroup.packagesList) return [];
      return [...new Set(cardGroup.packagesList.map(c => c.pinyin && c.pinyin[0]))]
        .filter(Boolean)
        .sort();
    },
    // 切换选中的字母
    selectPackageLetter(cardGroup, letter) {
      this.$set(cardGroup, 'currentLetter', cardGroup.currentLetter === letter ? '' : letter);
    },
    // 返回过滤后的项目列表
    filteredPackageList(cardGroup) {
      if (!cardGroup || !cardGroup.packagesList) return [];
      if (!cardGroup.currentLetter) return cardGroup.packagesList;
      return cardGroup.packagesList.filter(item => item.pinyin && item.pinyin[0] === cardGroup.currentLetter);
    },
    // 部门业绩获取
    getDepartmentalPerformance() {
       console.log("部门业绩获取-1", this.DepartmentalList);
       console.log('DepartmentalList =', this.DepartmentalList);
        console.log('isDepartmentalPerformance =', this.isDepartmentalPerformance);
        //这地方有问题DepartmentalList会变空,但是现在好像没啥影响先不动
      // console.log('DepartmentalList =', this.DepartmentalList, '长度 =', this.DepartmentalList.length);
        //  加这一行，DepartmentalList 为空直接返回
  if (!this.DepartmentalList || !this.DepartmentalList.length) {
    this.DepartmentInput = false;
    return;
  }
      console.log("部门业绩获取", this.DepartmentalList);
      this.API.goods.getDepartmentalPerformance({}).then((res) => {
        this.DepartmentalPerformance = res.data;
        if (this.DepartmentalList[this.DepartmentalList.length - 1].unAchievement > 0) {
          this.DepartmentInput = true;
          let index = this.DepartmentalList.length - 1;
          this.unassigned = this.DepartmentalList[index].unAchievement;
          this.performance = this.DepartmentalList[index].unAchievement;
        } else {
          this.DepartmentInput = false;
          return this.DepartmentalList.map((item) => {
            return [(this.unassigned = item.achievement), (this.performance = item.achievement)];
          });
        }
      });
    },
    //显示/隐藏无纸化充值卡列表
    openCardShow(){
      //isShow默认flase
       this.isShow = this.isShow ? false : true;
       // 如果隐藏列表，清空所有充值卡相关数据
  if (!this.isShow) {
    this.selectedRechargeCard = null;
    this.amountOfConsumableCardNumber = 0;
    this.canConsumeCardIncreaseGold = 0;
    this.haoCardMoney=0;

    // 清空内层抽屉中的耗卡输入
    this.modifyPaymentAmount.forEach(item => {
      if (item.name === '耗卡本金' || item.name === '耗卡赠金') {
        item.money = '';
      }
    });

    // 清空支付方式中的智慧耗卡
    this.clearingForm.forEach(item => {
      if (item.name === '智慧耗卡') {
        item.paymentAmount = 0;
      }
    });
    // 清除全部支付方式重置微信支付为现付金额
      this.$nextTick(() => {
        // 清空所有支付方式
        this.clearingForm.forEach(item => {
          item.paymentAmount = 0;
        });
        // 设置微信支付 = cashByPersonalCard
        const wechat = this.clearingForm.find(item => item.name === "微信");
        if (wechat) {
          wechat.paymentAmount = this.cashByPersonalCard;
        }
      });
  }else{
     // ---------- 展开：默认选中第一张充值卡 ----------
    this.$nextTick(() => {
      if (this.existingRechargeCards && this.existingRechargeCards.length) {
        // selectRechargeCard 内部已包含"选中 → 自动分配耗卡金额"的逻辑
        this.selectRechargeCard(this.existingRechargeCards[0]);
      }
    });
  }
    },
    // 流水单号重复提示开始 2024-05-25

    OnBillNumber() {
      // billNumber
      if (this.billNumber.length >= 4) {
        console.log(this.billNumber);
        this.repeat();
      } else {
        this.RunningOrdersShow = false;
      }
    },
    // 订单重复查询接口
    repeat() {
      this.API.goods
        .orderRepeat({
          serialNum: this.billNumber,
          startTime: this.startTime,
          endTime: this.endTime,
        })
        .then((res) => {
          console.log(res);
          this.RunningOrdersText = res.msg;
          this.RunningOrdersShow = true;
          if (res.msg == "") this.RunningOrdersShow = false;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },

    // 获取当前时间和前两天时间
    // getCurrentTime() {
    //   // 获取当前时间并打印
    //   var _this = this;
    //   let yy = new Date().getFullYear();
    //   let mm = new Date().getMonth() + 1;
    //   let dd = new Date().getDate();
    //   let hh = new Date().getHours();
    //   let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
    //   let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();

    //   var d = new Date().getDate() - 2; // 减二是算之前时间，+ 2 是之后时间
    //   _this.startTime = yy + "-" + mm + "-" + d + " " + hh + ":" + mf + ":" + ss;
    //   console.log(_this.startTime);
    //   _this.startTime = this.startTime;

    //   _this.endTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
    //   console.log(_this.endTime);
    //   _this.endTime = this.endTime;
    // },
    // TODO：获取当前时间和前两天时间,2026.7.8修改
getCurrentTime() {
  var _this = this
  let yy = new Date().getFullYear()
  let mm = new Date().getMonth() + 1
  let dd = new Date().getDate()
  let hh = new Date().getHours()
  let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
  let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()

  // 两天前的时间 —— 用 Date 对象算，自动处理跨月（28/29/30/31 天都正确）
  //var twoDaysAgo = new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000)
  var twoDaysAgo = new Date()
  twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)
  let d2 = twoDaysAgo.getDate()
  let m2 = twoDaysAgo.getMonth() + 1
  let y2 = twoDaysAgo.getFullYear()

  _this.startTime = y2 + '-' + (m2 < 10 ? '0' + m2 : m2) + '-' + (d2 < 10 ? '0' + d2 : d2) + ' ' + (hh < 10 ? '0' + hh : hh) + ':' + mf + ':' + ss
  _this.endTime = yy + '-' + (mm < 10 ? '0' + mm : mm) + '-' + (dd < 10 ? '0' + dd : dd) + ' ' + (hh < 10 ? '0' + hh : hh) + ':' + mf + ':' + ss
},
    // 流水单号重复提示结束

    /** ***************************************************** 工具 ***************************************************** **/
    // 扫码抢设备监听
    async scanCodeGunInput(event) {
      // 如果是回车键则不需要执行
      if (event.keyCode !== 13) {
        // 判断输入内容是否为数字
        this.codeNumber += event.key;
      }

      // 获取当前时间 当条码长度%2！=0时表示基数, 等于表示偶数, 基础 === 开始时间 、 偶数 === 结束时间
      if (this.codeNumber.length % 2 !== 0) this.timearr[0] = new Date(this.localServerTime.date.split(" ")[0]).getTime();
      // 获取基数时间
      else this.timearr[1] = new Date(this.localServerTime.date.split(" ")[0]).getTime(); // 获取偶数时间

      // 判断条码长度大于1表示已经输入2位以上字符 则进行输入的时间计算 如时间大于 40毫秒则视为用户手动输入 小于40毫秒则视为扫码枪输入
      if (this.codeNumber.length > 1 && this.timearr[1] - this.timearr[0] > 500) {
        // 清空数据
        this.codeNumber = "";
        this.timearr = [0, 0];
      } else if (this.codeNumber.length > 1 && this.timearr[1] - this.timearr[0] <= 500) {
        console.log(event.keyCode);
        if (event.keyCode === 13) {
          console.log("立即支付");
          // lakalPayment @param { payCrashAmount  支付金额   receiptCode  付款码   amountMoney  门店id }
          this.barCode = this.codeNumber;

          // 拉卡拉流水单号为空禁止运行此函数
          if (!this.barCode) return this.$message.warning("请使用扫码枪扫码");
          let moment = 0;
          if (this.innerDrawer) {
            moment = this.modifyPaymentAmount.reduce((previousValue, currentValue) => {
              if (currentValue.name === "智慧支付") return this.accuracyCheck(previousValue, currentValue.money);
              else return previousValue;
            }, 0);
          } else {
            moment = this.clearingForm.reduce((previousValue, currentValue) => {
              if (currentValue.name === "智慧支付") return this.accuracyCheck(previousValue, currentValue.paymentAmount);
              else return previousValue;
            }, 0);
          }
          // 发送请求调起用户支付窗口
          let param = {
            // 获取付款合计金额
            payCrashAmount: moment, // 付款金额
            tenantId: window.localStorage.getItem("tenantId"), // 店铺id
            receiptCode: this.barCode + "", // 付款码
          };
          // 支付请求
          const paymentRequest = await this.API.goods.lakalPayment(param);
          const { code, tradeNo, payMode, amount } = paymentRequest.data;

          // 存储拉卡拉支付流水单号
          if (code === "000000") {
            receivingAudio(amount, payMode == "WECHAT" ? 1 : 2);

            this.tradeNo = tradeNo;
            this.$message.success("支付成功");
            this.globalPaymentStatus = "1"; // 修改全局支付状态
            setTimeout(() => {
              // 清空输入信息
              this.codeNumber = "";
              this.timearr = [0, 0];
              this.intelligentPaymentState = false;
              // 如果是充值和开卡重新分配一下金额
              if (this.type === 2 || this.type === 4) {
                // 如果是外层支付则不需要在分配
                if (this.innerDrawer) this.innerDrawerHandleClose();
              }

              this.innerDrawer = false;

              // 判断当前订单是否可进行结算
              this.whetherItIsPayableOrNot &&
                this.$confirm("支付成功、是否立即结算订单", "支付完成", {
                  confirmButtonText: "立即结算",
                  cancelButtonText: "暂不结算",
                  showClose: false,
                  type: "success",
                }).then(async () => {
                  // 调用结算代码
                  if (this.type === 2) {
                    await this.confirmRecharge(); // 充值结算代码
                  } else if (this.type === 3) {
                    await this.tallyOrder(); // 项目产品结算代码
                  } else if (this.type === 4) {
                    await this.openSexCard(); // 会员开卡结算
                  }

                  this.globalPaymentStatus = "0"; // 改回全局支付状态
                });
            }, 800);
          } else {
            this.$message.error("扫码失败,请重新扫码!");
            // 清空输入信息
            this.codeNumber = "";
            this.timearr = [0, 0];
          }
        }
      }
    },
    // 挂单计时
    openOrderTiming() {
      this.orderTimeOut && clearInterval(this.orderTimeOut);
      this.orderDataHasBeenPosted.forEach((item) => {
        this.orderTimeTiming.push(this.timeFormat(item.addDate));
      });
      this.orderTimeOut = setInterval(() => {
        this.orderDataHasBeenPosted.forEach((item, index) => {
          this.$nextTick(() => {
            this.orderTimeTiming[index] = this.timeFormat(item.addDate);
            // console.log('更新')
            this.$forceUpdate();
          });
        });
      }, 1000);
    },
    timeFormat(time) {
      let d1 = new Date(time);
      // console.log('当前服务器时间', this.localServerTime.date)
      let d2 = new Date();
      let cha = Math.abs(d2.getTime() - d1.getTime());
      let days = parseInt(cha / (24 * 60 * 60 * 1000));
      let hours = parseInt((cha % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      let mins = parseInt((cha % (60 * 60 * 1000)) / (60 * 1000));
      let s = parseInt((cha % (60 * 1000)) / 1000);

      if (days) {
        hours += 24 * days;
      }
      if (hours >= 72) return "72:00:00";

      return `${hours <= 9 ? "0" + hours : hours}:${mins <= 9 ? "0" + mins : mins}:${s <= 9 ? "0" + s : s}`;
    },
    /** ***************************************************** 开单 ***************************************************** **/
    // 员工去重
    employeeWeightRemoval(employeeList) {
      let newEmployeeList = [];
      employeeList.forEach((item) => {
        let sign = true;
        newEmployeeList.forEach((subItem) => {
          if (item.id === subItem.id) sign = false;
        });
        if (sign) newEmployeeList.push(item);
      });
      return newEmployeeList;
    },
    // 默认支付方式设置
    defaultPaymentMethodSettings() {
      this.clearingForm.forEach((item) => {
        item.name === "微信" && (item.paymentAmount = this.amountInTotal);
      });
    },
    // 关闭弹出层
    handleClose() {

      // 重置 isShow 为 false
      this.isShow = false;
        // 重置个性次卡中选中的充值卡
      this.selectedRechargeCard = null;
      // 流水单号重复提示关闭
      this.RunningOrdersShow = false;
      // 重新刷新挂单数据
      this.$emit("getThePendingOrderNumber");
      this.$emit("upDrawer");
      this.clearingForm.forEach((item) => (item.paymentAmount = 0)); // 数据清空
      this.numberOfCardConsumptionNumber = 0; // 可耗卡次数
      this.amountOfConsumableCardNumber = 0; // 可耗卡金额（本金）
      this.canConsumeCardIncreaseGold = 0; // 可耗卡金额 （赠金）
      this.modifyPaymentAmount.forEach((item) => (item.money = "")); // 清空修改结算价数据
      // 重置充值金额
      Object.assign(this.rechargeObject, {
        rechargeAmount: 0, // 充值金额
        amountOfGift: 0, // 赠送金额
        discountAmount: 0, // 优惠金额
      });
      this.settlementAllowance = 0; // 优惠金额
      this.topUpSalesStaffList = []; // 充值员工列表
      this.isMies = true; // 是否发送消费类短信
      this.globalPaymentStatus = "0"; // 全局支付状态
      // 开卡
      this.activeName = "openACard"; // 回复
      this.cardPurchase = false; // 设置选卡状态
      this.personalizedTimesCardPurchase = []; // 个性次卡开卡选购项目
      this.memberCardPrice = 0; // 开卡价格
      this.memberCoupon = 0; // 优惠金额
      this.amountOfGift = 0; // 赠送金额
      this.personalitySubCardEmployeeList = []; // 个性次卡员工列表
      this.membershipCardRemarks = ""; // 清除卡备注
      this.clearMemberInfo(); // 清除开卡数据
      // 挂单
      this.currentlyTheOrderIsSelected = [];
      this.checkOrdersByDate = ""; // 清除时间
      this.idOfTheCurrentlySelectedEmployee = ""; // 清除筛选的员工id
      this.transferCardInformation = null; // 转卡数据清除
      this.billNumber = ""; // 流水单号
      // 重置部门业绩
      this.$emit("updateDepartmentalList", null);
      // 关闭计时器
      clearInterval(this.orderTimeOut);

    },
    // 监听输入
    monitorInput() {
      console.log("监听成功");
    },
    // 选择支付方式
    choiceOfPaymentMethod(item) {
      // 智慧耗卡（本金） + 智慧耗卡（增金）
      let principalAndIncrease = this.accuracyCheck(this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold);
      const { name } = item;
      // 可耗卡金额计算
      let consumableCard = this.accuracyCheck(principalAndIncrease, this.settlementAllowance);
      // 清空组合金额
      this.modifyPaymentAmount.forEach((item) => {
        item.money = "";
      });
      console.log("可耗卡金额", consumableCard);
      this.clearingForm.forEach((payment) => {
        payment.paymentAmount = 0;
        if (payment.name === name) {
          let assignedAmount = this.accuracyCheck(this.amountInTotal, consumableCard, "-");
          payment.paymentAmount = assignedAmount <= 0 ? 0 : assignedAmount;
        }
      });
      // this.intelligentPaymentState = true;

      // 商品合计金额减去可耗卡金额 再减去优惠金额
      let totalMinusConsumableCards = this.accuracyCheck(this.amountInTotal, this.amountOfConsumableCard, "-");
      if (item.name === "智慧支付" && this.accuracyCheck(totalMinusConsumableCards, this.settlementAllowance || 0, "-") !== 0 && this.whetherToEnableLacaraPayment) {
        if (item.paymentAmount > 0) {
          // 打开智慧支付弹出框
          this.intelligentPaymentState = true;
          this.$nextTick(() => {
            this.$refs.scanToPay.focus();
          });
        }
      }
    },
    // 内层抽屉关闭时
    innerDrawerHandleClose() {
      console.log("内层抽屉关闭");
      this.innerDrawer = false; // 外层窗口关闭
      this.closeTheScanCodePaymentWindow(); // 关闭内层扫码支付窗口
      this.adjustTheAmountAllocationInPayment(); // 分配金额
    },
    // 调整支付中金额分配
    adjustTheAmountAllocationInPayment() {
      // 分配金额
      this.clearingForm.forEach((item) => {
        const { name } = item;
        this.modifyPaymentAmount.forEach((subItem) => {
          const { name: subName, money } = subItem;
          if (name === subName) item.paymentAmount = money;
        });
      });
  //     // 同步耗卡本金和赠金到外层
  //   this.modifyPaymentAmount.forEach((subItem) => {
  //   if (subItem.name === '耗卡本金') {
  //     this.amountOfConsumableCardNumber = parseFloat(subItem.money) || 0;
  //   }
  //   if (subItem.name === '耗卡赠金') {
  //     this.canConsumeCardIncreaseGold = parseFloat(subItem.money) || 0;
  //   }
  // });
  // 同步耗卡本金和赠金到外层
  // 仅 type 4 个性次卡/开卡购卡通过 modifyPaymentAmount 填写，type 3 直接 v-model 绑定外层字段，此处跳过空值避免覆盖
  const principalItem = this.modifyPaymentAmount.find(i => i.name === '耗卡本金');
  const bonusItem = this.modifyPaymentAmount.find(i => i.name === '耗卡赠金');
  if (principalItem && principalItem.money !== '') {
    this.amountOfConsumableCardNumber = parseFloat(principalItem.money) || 0;
  }
  if (bonusItem && bonusItem.money !== '') {
    this.canConsumeCardIncreaseGold = parseFloat(bonusItem.money) || 0;
  }

    },
    // 关闭扫码支付窗口
    closeTheScanCodePaymentWindow() {
      this.paymentOrderId = ""; // 清空支付订单
      this.smartPaymentMethod = "0"; // 默认支付方式
      this.payState = ""; // 清除支付状态
      this.intelligentPaymentState = false; // 关闭
      console.log("关闭支付窗口回调");
    },
    // 调整支付
    adjustedPayment() {
      this.clearingForm.forEach((payment) => payment.name == "智慧耗卡" || (payment.paymentAmount = 0)); // 清空所有余额
      this.principalGrantAllocation(); // 本金赠金金额分配
      this.innerDrawer = true; // 打开内层抽屉
      this.intelligentPaymentState = false; // 关闭外层
    },
    // 自动给调整本金 赠金 金额分配
    principalGrantAllocation() {
      if (this.currentlySelectedCard) {
        let cardTypeCode = "";
        let givenAmount = 0;
        let initAmount = 0;
        if (this.currentlySelectedCard.tmemberCard) {
          cardTypeCode = this.currentlySelectedCard.tmemberCard;
          givenAmount = this.currentlySelectedCard.tmemberCard.givenAmount;
          initAmount = this.currentlySelectedCard.tmemberCard.initAmount;
        }
        if (Number(cardTypeCode) !== 3 || Number(cardTypeCode) !== 0) {
          console.log("执行自动金额非配", givenAmount, initAmount);
          // 本金赠金合计
          let amountInTotal = this.accuracyCheck(givenAmount, initAmount);
          let expendableAmount = this.accuracyCheck(this.amountOfConsumableCard, this.settlementAllowance, "-");
          // 合计金额如果大于项目金额说明可全耗卡 合计金额如果小于项目金额说明 不可全耗卡
          if (amountInTotal > expendableAmount) {
            // 判断本金是否大于
            if (initAmount > expendableAmount) {
              this.amountOfConsumableCardNumber = expendableAmount;
            } else if (givenAmount > this.accuracyCheck(expendableAmount, initAmount, "-")) {
              this.amountOfConsumableCardNumber = initAmount;
              this.canConsumeCardIncreaseGold = this.accuracyCheck(expendableAmount, initAmount, "-");
            }
          } else {
            this.amountOfConsumableCardNumber = initAmount; // （本金）
            this.canConsumeCardIncreaseGold = givenAmount; // （赠金）
          }
        }

        console.log("自动金额分配", this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold);
      }
    },
    // 修改充值卡金额
    modifyTheAmountOfTheRechargeCard(type) {
      const { givenAmount, initAmount } = this.currentlySelectedCard.tmemberCard; // 获取卡号
      // 判断修改的 本金 + 卡金 是否大于卡总余额
      if (this.accuracyCheck(this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold) > this.amountOfConsumableCard) {
        this[type] = 0;
        // return this.$message.error("超出可耗卡余额");
        return this.$message.error("订单包含不可耗卡品项");
      }
      // 判断是否超出自身余额
      if (this.amountOfConsumableCardNumber > initAmount) {
        this[type] = initAmount;
        return this.$message.error("本金超出可耗卡余额");
      }
      if (this.canConsumeCardIncreaseGold > givenAmount) {
        this[type] = givenAmount;
        return this.$message.error("赠金超出可耗卡余额");
      }
      this.calculateWhetherTheAmountExceeded(); // 计算金额是否超出
    },
    // 计算金额是否超出
    calculateWhetherTheAmountExceeded() {
      // 智慧耗卡（本金） + 智慧耗卡（增金）
      let principalAndIncrease = this.accuracyCheck(this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold);
      // 合计修改金额
      let totalAmountOfCurrentUsers = this.modifyPaymentAmount.reduce((previousValue, currentValue) => {
        const { money } = currentValue;
        return this.accuracyCheck(parseFloat((money || 0).toString()), previousValue);
      }, 0);
      // 精准度计算 其他支付 + 智慧耗卡（本金）智慧耗卡（增金）
      let totalAmount = this.accuracyCheck(totalAmountOfCurrentUsers, principalAndIncrease);

      // 判断用户当前所输入金额是否可以结算订单
      let hillsideFinalAmount = this.accuracyCheck(this.amountInTotal, this.settlementAllowance || 0, "-");
      if (hillsideFinalAmount === totalAmount) {
        console.log("支付");
      } else {
        if (totalAmount < hillsideFinalAmount) {
          let differentialGold = this.accuracyCheck(hillsideFinalAmount, totalAmount, "-");
          this.$message.warning(`共需支付：￥${hillsideFinalAmount}，还差：￥${differentialGold}`);
        } else if (totalAmount > hillsideFinalAmount) {
          let superGold = this.accuracyCheck(totalAmount, hillsideFinalAmount, "-");
          this.$message.warning(`共需支付：￥${hillsideFinalAmount}，超出：￥${superGold}`);
        }
      }

      // 分配金额
      this.adjustTheAmountAllocationInPayment();
      console.log("当前用户所输入总金额", totalAmountOfCurrentUsers);
    },
    // 结算订单
    async tallyOrder() {
      let loadingInstance = null; // 加载对象
      try {
        if (!this.whetherItIsPayableOrNot) {
          this.$message.warning("请选择支付方式");
          return false;
        }
        if (JSON.parse(window.localStorage.getItem("tenant")).serialNumState === 1 && !this.billNumber) {
          this.$message.warning("请输入流水单号");
          return false;
        }
        // 开启加载结算订单
        loadingInstance = Loading.service({
          fullscreen: true,
          text: "支付中",
          background: "rgba(0, 0, 0, .7)",
          spinner: "el-icon-loading",
        });
        let isOrderId = this.orderData.some((item) => !!item.orderId); // true 待付款订单 false快速开单订单
        let order = {
          orderId: "",
          orderNo: "",
        };
        let memberCardId = "";
        let memberInfo = {};
        // 判断是散客消费还是会员消费
        if (this.isIndividualTraveler) {
          const { id: memberId, gender } = this.currentSelectedMember;
          memberInfo.memberId = memberId; // 会员id
          memberInfo.gender = gender.toString(); // 用户客户性别
        }
        // 判断有无卡信息
        if (this.currentlySelectedCard) {
          memberCardId = this.currentlySelectedCard.tmemberCard ? this.currentlySelectedCard.tmemberCard.id : "";
        }
        memberInfo.memberCardId = memberCardId;
        let consumableCard = this.accuracyCheck(this.canConsumeCardIncreaseGold, this.amountOfConsumableCardNumber);
        // 整理支付订单请求体参数
        let params = {
          customerCount: this.customerCount, // 客数
          chargeTime: "", // 修改收款时间
          // 项目内容
          consumeDTO: {
            consumerItemDTOList: null, // 订单项目列表
            freeAmount: 0, // 优惠金额
            memberCardId: null, // 会员卡id
            memberId: null, // 会员id
          },
          costCardAmount: this.amountOfConsumableCard || 0, // 耗卡金额
          costGivenAmount: this.canConsumeCardIncreaseGold || 0, // 赠金
          costInitAmount: this.amountOfConsumableCardNumber || 0, // 本金
          customerSex: this.memberSex, // 性别
          freeAmount: this.settlementAllowance || 0, // 优惠金额
          flag: this.isMies, // 是否发送消费类短信
          costCardTime: this.numberOfCardConsumptionNumber || "", // 耗卡次数
          orderType: this.orderTypes, // 订单类型 30会员单 40散客单
          payCrashAmount: this.accuracyCheck(this.amountInTotal, consumableCard, "-").toString(), // 付现金额
          payTypeDTOList: [], // 支付方式列表
          payableAmount: this.amountInTotal, // 结算金额
          remark: this.billNumber, // 流水单
          totalAmount: this.amountInTotal, // 订单合计金额
        };
        // 项目订单合算
        params.consumeDTO.consumerItemDTOList = this.orderData.map((orderItem) => {
          const { total, price, id: orderId, employeeList } = orderItem;
          // 判断是否是待付款订单 并且订单id不能为空
          if (isOrderId && orderItem.orderId) {
            order.orderId = orderItem.orderId; // 待付款订单id
            order.orderNo = orderItem.orderNo; // 待付款订单号
          }
          // 判断当前是产品还是项目
          let itemType = orderItem.packageTypeName ? 0 : 1;
          // 销售员数据合算
          let salesList = employeeList.map((employeeItem) => {
            const { appoint, sell, work, workType, id: employeeId } = employeeItem;
            return {
              appoint, // 指定 非指定
              employeeId, // 销售员id
              sell, // 销售
              work, // 劳动
              workType, // 劳动类型
            };
          });
          return {
            costPrice: total, // 结算价
            employeeAppointDTOList: salesList,
            itemId: orderId, // 项目id
            itemType, // 订单类型
            num: 1, // 订单数量
            originPrice: price, // 订单原价
            ppItemId: isOrderId ? orderItem.ppItemId : "",
          };
        });
        // 合并会员信息
        Object.assign(params.consumeDTO, memberInfo);
        // 合并组合支付 + 其他支付金额信息
        let payTogether = JSON.parse(JSON.stringify(this.clearingForm));
        payTogether.forEach((item) => {
          const { name } = item;
          this.modifyPaymentAmount.forEach((subItem) => {
            const { name: subName, money } = subItem;
            if (name === subName && money > 0) {
              item.paymentAmount = money;
            }
          });
        });
        console.log("组合支付", payTogether);
        // 支付方式整理
        payTogether.forEach((payItem) => {
          const { name, paymentAmount } = payItem;
          let pay = {
            amount: 0,
            payType: "",
            payTypeName: "",
          };
          switch (name) {
            case "智慧支付":
              Object.assign(pay, {
                amount: paymentAmount,
                payType: 0,
                payTypeName: "智慧支付",
              });
              break;
            case "微信":
              Object.assign(pay, {
                amount: paymentAmount,
                payType: 1,
                payTypeName: "微信",
              });
              break;
            case "支付宝":
              Object.assign(pay, {
                amount: paymentAmount,
                payType: 2,
                payTypeName: "支付宝",
              });
              break;
            case "现金":
              Object.assign(pay, {
                amount: paymentAmount,
                payType: 3,
                payTypeName: "现金",
              });
              break;
            case "银联刷卡":
              Object.assign(pay, {
                amount: paymentAmount,
                payType: 4,
                payTypeName: "银联刷卡",
              });
              break;
            case "团购":
              Object.assign(pay, {
                amount: paymentAmount,
                payType: 5,
                payTypeName: "团购",
              });
              break;
            case "代金券":
              Object.assign(pay, {
                amount: paymentAmount,
                payType: 6,
                payTypeName: "代金券",
              });
              break;
            case "积分":
              Object.assign(pay, {
                amount: paymentAmount,
                payType: 7,
                payTypeName: "积分",
              });
              break;
            case "其他":
              Object.assign(pay, {
                amount: paymentAmount,
                payType: 8,
                payTypeName: "其他",
              });
              break;
          }
          if (parseFloat(pay.amount)) params.payTypeDTOList.push(pay);
        });
        // 判断当时订单有无次卡交易
        if (this.whetherThereIsWisdomConsumptionCard) {
          params.payTypeDTOList.push({
            // 判断是耗次数还是耗卡金
            amount: this.isSubcard ? 0 : this.accuracyCheck(this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold),
            payType: 9,
            payTypeName: "智慧耗卡",
          });
        }
        // 如果没有支持耗卡在判断是否有0元支付 处理0元支付情况
        if (!params.payTypeDTOList.length) {
          let finalSettlement = this.accuracyCheck(this.accuracyCheck(this.amountInTotal, this.amountOfConsumableCard, "-"), this.settlementAllowance, "-");
          if (finalSettlement <= 0) {
            params.payTypeDTOList.push({
              payType: 8,
              amount: finalSettlement,
              payTypeName: "其他",
            });
          }
        }
        console.log("当前请求参数", params);
        let code = "";
        if (isOrderId) {
          Object.assign(params, order);
          console.log("请求参数", params);
          // 待付款支付 && 合并订单支付
          this.API.paperless.orderPendingPaymentSettlement(params).then(async (res) => {
            code = res.code;
            if (code === 0) {
              this.$message.success("结算成功");
              setTimeout(async () => {
                this.$nextTick(() => {
                  loadingInstance.close(); // 关闭加载
                });
                // 添加部门业绩
                let data = [];
                // let dataId = await this.API.order.getOrdermemberCardIdGetOrderId({ memberCardId: res.data });
                let tenant = localStorage.getItem("tenantId");
                for (let i = 0; i < this.DepartmentalList.length; i++) {
                  data.push({
                    orderId: res.data,
                    tenantId: tenant,
                    departmentId: this.DepartmentalList[i].departmentId,
                    departmentName: this.DepartmentalList[i].departmentName,
                    achievement: Number(this.DepartmentalList[i].achievement),
                    unAchievement: Number(this.DepartmentalList[i].unAchievement),
                  });
                }
                data[data.length - 1].unAchievement = this.totalCount;
                await this.API.goods.postAddDepartmentalPerformance(data).then((res) => {
                  console.log("res.data", res.data);
                });
                this.$emit("updateDepartmentalList", null);
                this.$emit("clearOrderInfo", memberCardId || undefined); // 清除父组件支付订单
                this.handleClose(); // 关闭支付窗口
              }, 800);
            } else {
              this.$message.error("订单结算失败");
              this.$nextTick(() => {
                loadingInstance.close(); // 关闭加载
              });
              return false;
            }
          });
        } else {
          console.log("请求参数", params);
          // 快速开单支付
          this.API.paperless.tallyOrder(params).then(async (res) => {
            code = res.code;
            if (code === 0) {
              this.$message.success("结算成功");
              setTimeout(() => {
                this.$nextTick(() => { });
                this.$emit("clearOrderInfo", memberCardId || undefined); // 清除父组件支付订单
                this.handleClose(); // 关闭支付窗口
              }, 800);
            } else {
              this.$message.error("订单结算失败");
              this.$nextTick(() => {
                loadingInstance.close(); // 关闭加载
              });
              return false;
            }
            // 添加部门业绩
            let dataName = [];
            // let dataId = await this.API.order.getOrdermemberCardIdGetOrderId({ memberCardId: memberCardId });
            let tenant = localStorage.getItem("tenantId");
            for (let i = 0; i < this.DepartmentalList.length; i++) {
              dataName.push({
                orderId: res.data,
                tenantId: tenant,
                departmentId: this.DepartmentalList[i].departmentId,
                departmentName: this.DepartmentalList[i].departmentName,
                achievement: Number(this.DepartmentalList[i].achievement),
                unAchievement: Number(this.DepartmentalList[i].unAchievement),
              });
              // console.log("dataName", dataName);
            }
            dataName[dataName.length - 1].unAchievement = this.totalCount;
            await this.API.goods.postAddDepartmentalPerformance(dataName).then((res) => {
              console.log("res.data", res.data);
            });
            this.$emit("updateDepartmentalList", null);
            loadingInstance.close(); // 关闭加载
            this.customerCount = 1;
          });
        }
      } catch (error) {
        console.log(error);
        this.$message.error("订单结算异常");
        this.$nextTick(() => {
          loadingInstance.close(); // 关闭加载
        });
        return false;
      }
      return Promise.resolve(true);
    },
    // 开启支付支付
    smartPayment() {
      // 判断是否开通了拉卡拉
      if (!this.whetherToEnableLacaraPayment) return this.$message.warning("店铺尚未开通线上支付");
      let amount = "";
      this.modifyPaymentAmount.forEach((item) => item.name === "智慧支付" && (amount = item.money));
      if (!parseFloat(amount)) return this.$message.warning("请先输入金额后支付");
      this.intelligentPaymentState = true;
      this.$nextTick(() => {
        this.$refs.scanToPay.focus();
      });
    },
    // 切换支付方式
    async switchingPaymentMethods(payType, orderType) {
      this.smartPaymentMethod = payType;
      this.paymentOrderId = ""; // 清空订单id
      if (payType === "1") {
        let amount = "";
        if (this.innerDrawer) {
          this.modifyPaymentAmount.forEach((item) => {
            if (item.name === "智慧支付") amount = item.money;
          });
        } else if (orderType === "topUp") {
          amount = this.settlementAmount;
        } else if (orderType === "openCard") {
          amount = this.cashByPersonalCard;
        } else amount = this.accuracyCheck(this.amountInTotal, this.settlementAllowance, "-");
        const param = {
          amount: amount,
          renewTenantId: window.localStorage.getItem("tenantId"),
          mark: "pay_order",
        };
        // 顾客扫码支付获取二维码信息
        const { data } = await this.API.paperless.wisdomPaysByCard(param);
        this.paymentCardPaymentAddress = data.img; // 获取h5支付二维码
        this.paymentOrderId = data.id;
      } else if (payType === "0") {
        // 清空输入信息
        this.codeNumber = "";
        this.timearr = [0, 0];
        this.$nextTick(() => {
          this.$refs.scanToPay.focus();
        });
      }
    },
    // 计算业绩是否可修改
    calculateWhetherPerformanceIsModifiable(performanceType, employeeItem, orderItem) {
      let state = false;
      // 系统权限控制是否禁止修改业绩
      if (this.permissionList.some((item) => item.resourceCode === "ORDER_MANAGE08")) return true;

      // 查看项目是否禁止修改业绩
      if (this.analyticalDataCommodity(orderItem) === "0") {
        // 项目
        if (performanceType === "work") state = false;
        else if (performanceType === "sell") {
          if (orderItem.salesBrokerage === 0) return true;
        }
      } else {
        // 产品
        console.log("产品");
        if (performanceType === "work") return true;
        else if (performanceType === "sell") state = false;
      }
      // 获取当前员工是否开启了 劳动业绩提成 或者 销售业绩提成
      let employeePermissionData = this.listOfEmployeeRoyaltyRightsData.filter((item) => item.id === employeeItem.id)[0]["permissionList"] || [];
      if (!employeePermissionData.length) return true;
      // 员工是否开启劳动提成
      if (performanceType === "work") {
        employeePermissionData.some((item) => item.brokerageType === "work") || (state = true);
      }
      // 员工是否开启销售提成
      if (performanceType === "sell") {
        employeePermissionData.some((item) => item.brokerageType === "sell") || (state = true);
      }
      return state;
    },
    /** ***************************************************** 会员充值 ***************************************************** **/
    // 添加充值员工
    async addTopUpStaff() {
      // 获取门店销售员工
      const { data } = await this.API.paperless.acquireExistingEmployeesOfTheStore();
      // 员工数据
      let newEmployeeData = [];
      let position = [];
      data.forEach((item) => {
        this.$set(item, "label", false); // 是否选择
        this.$set(item, "num", 0); // 数量
        if (position.indexOf(item.postName) === -1) {
          position.push(item.postName);
          newEmployeeData.push({
            postName: item.postName,
            employeeDataList: [],
          });
        }
        newEmployeeData.forEach((subItem) => {
          if (item.postName === subItem.postName) subItem.employeeDataList.push(item);
        });
      });
      this.topUpEmployeeList = newEmployeeData; // 销售员
      this.topUpEmployeeShow = true; // 打开员工添加面板
    },
    // 获取员工提成权限数据
    async getEmployeeRoyaltyAuthorityData() {
      const { data: employeePermissionData } = await this.API.paperless.accessToAllEmployeeCommissions();
      this.listOfEmployeeRoyaltyRightsData = employeePermissionData;
      return Promise.resolve(true);
    },
    // 关闭会员筛选弹窗
    closeTheMembershipScreeningPopup() {
      this.topUpEmployeeShow = false;
      this.memberTransferCardBoxShow = false;
      this.openCardTemporaryDataList = [];
    },
    // 选择员工
    addATopUpCardForSale(item) {
      if (this.topUpSalesStaffList.length >= 5) return this.$message.warning("员工添加上限");
      this.$set(item, "percentage", 0); // 销售
      this.$set(item, "achievement", 0); // 销售
      if (this.openCardTemporaryDataList.length >= 5 - this.topUpSalesStaffList.length) return this.$message.warning("员工数量上限");
      item.label = true;
      item.num += 1;
      this.openCardTemporaryDataList.push(item);
    },
    // 计算充值业绩
    async calculateTheTopUpPerformance() {
      const { id: memberCardId } = this.currentlySelectedCard.tmemberCard; // 会员卡id
      const price = this.rechargeObject.rechargeAmount; // 充值金额
      const employeeIds = this.topUpSalesStaffList.map((item) => item.id).toString() || ","; // 员工id
      const param = { memberCardId, price, employeeIds };
      const { data: employeePerformance } = await this.API.paperless.rechargePerformanceCalculation(param);
      console.log("充值业绩计算", employeePerformance);
      this.topUpSalesStaffList.forEach((staff) => {
        employeePerformance.forEach((performance) => {
          if (staff.id === performance.employeeId) {
            staff.achievement = performance.achievement || 0; // 销售
            staff.percentage = performance.percentage || 0; // 劳动
            staff.brokerageClass = performance.brokerageClass; // 提成种类
            staff.brokerageTypev = performance.brokerageType; // 提成类型
          }
        });
      });
    },
    // 默认充值金额
    defaultRechargeAmount() {
      this.clearingForm.forEach((payItem) => {
        payItem.paymentAmount = 0;
      });
      this.clearingForm.forEach((item) => {
         // 充值金额 - 优惠金额 = 实际应付
    item.name === "微信" && (item.paymentAmount = this.settlementAmount > 0 ? this.settlementAmount : 0);
  });
    },
    // 移除销售员工
    removeAnEmployee(index) {
      this.topUpSalesStaffList.splice(index, 1);
      // 重新员工充值业绩
      this.calculateTheTopUpPerformance();
    },
    // 充值支付金额
    topUpPaymentAmount(item, type) {
      this.clearingForm.forEach((payItem) => {
        payItem.paymentAmount = 0;
      });
      if (type === "openCard") {
        //当 type === "openCard" 时点击支付方式会填满 cashByPersonalCard，没考虑耗卡。改为扣掉耗卡后的余额：
        //这是在开卡购卡页面（type === 4，就是选完卡后那个结算界面）点击支付方式时触发的
        //<!-- 会员卡购卡 -->
        //<div class="order-content-item" v-for="item in clearingForm" :key="item.iconfont"
        // @click="topUpPaymentAmount(item, 'openCard')">
        //<!-- 个性次卡购卡 -->
        //<div class="order-content-item" v-for="item in clearingForm" :key="item.iconfont"
        //@click="topUpPaymentAmount(item, 'openCard')">
        //
        // 计算耗卡总额,点击支付方式改为扣掉耗卡后的余额
         if (this.consumptionApplicable) {
        // 次卡/个性次卡：扣掉耗卡后微信补差价
        const cardConsumption = this.accuracyCheck(
            this.amountOfConsumableCardNumber,
            this.canConsumeCardIncreaseGold
        );
        //设置
        const remainder = this.accuracyCheck(this.cashByPersonalCard, cardConsumption, '-');
        item.paymentAmount = remainder <= 0 ? 0 : remainder;
      } else {
        // 充值卡/折扣卡：直接填满现付
        item.paymentAmount = this.cashByPersonalCard <= 0 ? 0 : this.cashByPersonalCard;
      }
    }else if (this.type === 2) {
    // === 充值（本次修复）===
    item.paymentAmount = this.settlementAmount <= 0 ? 0 : this.settlementAmount;
  }
      // 打开智慧支付
      this.whetherToEnableLacaraPayment &&
        this.clearingForm.forEach((payItem) => {
          if (payItem.name === "智慧支付" && payItem.paymentAmount > 0) {
            this.intelligentPaymentState = true;
            this.$nextTick(() => {
              this.$refs.scanToPay.focus();
            });
          }
        });

    }, // 金额是否超出
    // 支付差额提醒
    excessOfAmount(type) {
      let amountPayable = 0;
      if (type === "openACard") {
        amountPayable = this.cashByPersonalCard;
      } else {
        amountPayable = this.settlementAmount;
      }
      // 输入合计金额
      let amountInTotal = this.modifyPaymentAmount.reduce((previousValue, currentValue) => {
        return this.accuracyCheck(previousValue, currentValue.money);
      }, 0);
      let calculate = this.accuracyCheck(amountInTotal, amountPayable, "-");
      if (calculate === 0) return;
      if (calculate > 0) return this.$message.warning(`共需支付：￥${amountPayable}，超出：￥${calculate}`);
      if (calculate < 0) return this.$message.warning(`共需支付：￥${amountPayable}，还差：￥${calculate * -1}`);
    },
    unpaid(employeeList, openEmployeeList) {
      return new Promise((resolve, reject) => {
        if (this[employeeList].length) {
          resolve(true);
        } else {
          this.$confirm("您未添加员工，是否确认结账", "提示", {
            confirmButtonText: "立即结算",
            cancelButtonText: "添加员工",
            showClose: false,
            distinguishCancelAndClose: true,
            type: "warning",
          })
            .then(() => {
              resolve(true);
            })
            .catch((action) => {
              action === "cancel" && this[openEmployeeList](); // 打开添加员工
              reject(new Error("false"));
            });
        }
      });
    },
    // 确认充值
    async confirmRecharge() {
      if (!this.whetherTheTopUpOrderIsPayable) {
        this.$message.warning("请选择支付方式");
        return false;
      } // 判断当前订单是否可以支付
      if (JSON.parse(window.localStorage.getItem("tenant")).serialNumState === 1 && !this.billNumber) {
        this.$message.warning("请输入流水单号");
        return false;
      }
      // 判断员工数据是否为空
      this.unpaid("topUpSalesStaffList", "addTopUpStaff").then(async () => {
        // 开启加载结算订单
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "支付中",
          background: "rgba(0, 0, 0, .7)",
          spinner: "el-icon-loading",
        });
        try {
          const { id: memberCardId } = this.currentlySelectedCard.tmemberCard; // 会员卡id
          const employeeIds = this.topUpSalesStaffList.map((item) => item.id).toString(); // 员工id
          const { id: memberId } = this.currentSelectedMember; // 会员id

          let param = {
            customerCount: this.customerCount, // 客数
            chargeTime: "",
            costCardAmount: 0,
            donationAmount: parseFloat(this.rechargeObject.amountOfGift) || 0, // 赠送金额
            flag: this.isMies, // 是否发送消息
            freeAmount: parseFloat(this.rechargeObject.discountAmount) || 0, // 优惠金额
            orderType: 20,
            payCrashAmount: parseFloat(this.settlementAmount), // 结算价
            payTypeDTOList: [], // 支付方式
            payableAmount: parseFloat(this.rechargeObject.rechargeAmount), // 充值金额
            reChargeDTO: {
              memberCardId, // 会员卡
              employeeIds, // 员工id组
              memberId, // 会员id
              price: parseFloat(this.rechargeObject.rechargeAmount),
              sendPrice: parseFloat(this.rechargeObject.amountOfGift),
              tenantCardId: "", // 转卡id
              orderEmployeeBrokerageVOList: [], // 员工数组
            },
            rechargeAmount: parseFloat(this.rechargeObject.rechargeAmount), // 充值金额
            remark: this.billNumber, // 流水单
            totalAmount: parseFloat(this.rechargeObject.rechargeAmount), // 充值金额
          };
          // 添加员工提成
          for (let i = 0; i < 5; i++) {
            let employeeObject = { achievement: "", employeeId: "", employeeNo: "", percentage: "" };
            if (this.topUpSalesStaffList[i]) {
              employeeObject.achievement = this.topUpSalesStaffList[i].achievement || null;
              employeeObject.employeeId = this.topUpSalesStaffList[i].id;
              employeeObject.employeeNo = this.topUpSalesStaffList[i].employeeNo;
              employeeObject.percentage = this.topUpSalesStaffList[i].percentage || null;
            }
            param.reChargeDTO.orderEmployeeBrokerageVOList.push(employeeObject);
          }
          // 添加支付方式
          this.clearingForm.forEach((payItem) => {
            const { name, paymentAmount } = payItem;
            let pay = {
              amount: 0,
              payType: "",
              payTypeName: "",
            };
            switch (name) {
              case "智慧支付":
                Object.assign(pay, {
                  amount: paymentAmount,
                  payType: 0,
                  payTypeName: "智慧支付",
                });
                break;
              case "微信":
                Object.assign(pay, {
                  amount: paymentAmount,
                  payType: 1,
                  payTypeName: "微信",
                });
                break;
              case "支付宝":
                Object.assign(pay, {
                  amount: paymentAmount,
                  payType: 2,
                  payTypeName: "支付宝",
                });
                break;
              case "现金":
                Object.assign(pay, {
                  amount: paymentAmount,
                  payType: 3,
                  payTypeName: "现金",
                });
                break;
              case "银联刷卡":
                Object.assign(pay, {
                  amount: paymentAmount,
                  payType: 4,
                  payTypeName: "银联刷卡",
                });
                break;
              case "团购":
                Object.assign(pay, {
                  amount: paymentAmount,
                  payType: 5,
                  payTypeName: "团购",
                });
                break;
              case "代金券":
                Object.assign(pay, {
                  amount: paymentAmount,
                  payType: 6,
                  payTypeName: "代金券",
                });
                break;
              case "积分":
                Object.assign(pay, {
                  amount: paymentAmount,
                  payType: 7,
                  payTypeName: "积分",
                });
                break;
              case "其他":
                Object.assign(pay, {
                  amount: paymentAmount,
                  payType: 8,
                  payTypeName: "其他",
                });
                break;
            }
            if (parseFloat(pay.amount)) param.payTypeDTOList.push(pay);
          });
          // 是否需要转卡
          if (this.transferCardInformation) {
            param.reChargeDTO.tenantCardId = this.transferCardInformation.id;
          }
          // 判断支付方式是否为空 支付方式为空的是付款为0的单
          if (!param.payTypeDTOList.length) param.payTypeDTOList.push({ amount: 0, payType: 8, payTypeName: "其他" });
          // 充值单发送求
          const { code, msg, data } = await this.API.paperless.tallyOrder(param);
          if (code === 0) {
            // 添加部门业绩-充值
            let dataName = [];
            // let dataId = await this.API.order.getOrdermemberCardIdGetOrderId({ memberCardId: data });
            let tenant = localStorage.getItem("tenantId");
            for (let i = 0; i < this.isDepartmentalPerformance.length; i++) {
              dataName.push({
                orderId: data,
                tenantId: tenant,
                departmentId: this.isDepartmentalPerformance[i].departmentId,
                departmentName: this.isDepartmentalPerformance[i].departmentName,
                achievement: Number(this.isDepartmentalPerformance[i].achievement),
                unAchievement: Number(this.isDepartmentalPerformance[i].unAchievement),
              });
            }
            dataName[dataName.length - 1].unAchievement = this.totalAmount;

            await this.API.goods.postAddDepartmentalPerformance(dataName).then((res) => {
              console.log("res.data", res.data);
            });
            this.isDepartmentalPerformance.forEach((item) => (item.achievement = 0));
            this.$emit("updateDepartmentalList", null);
            this.$message.success("金额充值成功");
            this.$emit("selectMemberInformation", this.currentSelectedMember, undefined, memberCardId); // 触发父组件事件 更新会员卡实时余额
            setTimeout(() => {
              this.$nextTick(() => {
                loadingInstance.close(); // 关闭加载
              });
              this.handleClose(); // 关闭支付窗口
            }, 800);
          } else {
            console.log("充值支付错误", msg);
            this.$message.error("订单结算异常");
            this.$nextTick(() => {
              loadingInstance.close(); // 关闭加载
            });
          }
          console.log("请求数据", param);
        } catch (error) {
          console.log("充值支付错误", error);
          this.$message.error("订单结算异常");
          this.$nextTick(() => {
            loadingInstance.close(); // 关闭加载
          });
        }
      });
      return true;
    },
    // 开启会员转卡 bol 是否开启选卡弹窗 removeEntry 是要去除的卡项id字符串
    async openTransferCard(bol = true, removeEntry) {
      // 开启加载
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "加载中",
        background: "rgba(0, 0, 0, .7)",
        spinner: "el-icon-loading",
      });
      // 获取会员卡数据
      let param = {
        query_type: "like",
        give: 0,
        card_type_code: 2,
        on_sale_status: 0,
      };
      const { data } = await this.API.paperless.obtainMembershipCardList(param);
      // 判断是否有要出去的卡项id
      if (removeEntry) {
        let newData = data; // 存储当前所有充值卡项
        let removeEntryList = removeEntry.split(",").filter((item) => item);
        removeEntryList.forEach((item) => {
          newData = newData.filter((subItem) => subItem.id !== item);
        });
        // 根据会员id获取
        const { data: memberResult } = await this.API.paperless.getMemberParticulars({
          phone: this.currentSelectedMember.memberMobile,
          cardLeachStatus: "1",
        });
        // 标记出已用户已开的会员卡
        memberResult.forEach((item) => {
          newData.forEach((subItem) => {
            if (item.tmemberCard.tenantCardId === subItem.id) {
              this.$set(subItem, "sign", true);
            }
          });
        });
        this.membershipCardTransferList = newData;
      } else this.membershipCardTransferList = data; // 添加会员卡数据

      if (this.membershipCardTransferList.length <= 0) {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      }
      bol && (this.memberTransferCardBoxShow = true); // 打开卡项选择弹窗
      // 关闭加载
      this.$nextTick(() => {
        loadingInstance.close();
      });
      return Promise.resolve(true);
    },
    // 选择转卡充值卡
    selectTransferCardRechargeCard(item) {
      console.log("转卡信息", item);
      this.transferCardInformation = item; // 添加转卡信息
      this.$nextTick(() => {
        this.memberTransferCardBoxShow = false; // 关闭卡项选择弹窗
      });
    },
    /** ***************************************************** 会员开卡 ***************************************************** **/
    // 选择卡种
    async selectiveCardType(tab, event) {
      console.log("选择卡种", tab, event);
      console.log(this.activeName);
      await this.openCardDataRequest(); // 请求开卡数据
      // 清空数据
      this.personalizedTimesCardPurchase = [];
      this.theSecondCardSelectsTheItem = {};
       this.resetRechargeCardConsumption();  // 新增
      // 判断请求
      if (this.activeName === "openACard") {
      }
    },
    // 开卡数据请求
    openCardDataRequest() {
      return new Promise(async (resolve, reject) => {
        // 判断请求
        if (this.activeName === "openACard") {
          const { data } = await this.API.paperless.obtainMembershipCardList({ query_type: "like", give: 0, on_sale_status: 0 });
          let newCardList = [];
          // console.log('请求数据', data)
          data.forEach((item) => {
            let sign = true;
            let subscript = 0;
            // 添加标记
            this.$set(item, "cardActive", false);
            newCardList.forEach((subItem, subIndex) => {
              if (item.cardTypeCode === subItem.cardTypeCode) {
                sign = false;
                subscript = subIndex;
              }
            });
            if (sign) {
              newCardList.push({
                cardTypeCode: item.cardTypeCode,
                cardTypeName: item.cardTypeName,
                cardActive: item.active,
                cardItemList: [item],
              });
            } else newCardList[subscript].cardItemList.push(item);
          });
          console.log("请求数据", data);
          let subcard = null; // 次卡
          let refillCard = null; // 充值卡
          let discountCard = null; // 折扣卡
          newCardList.forEach((item) => {
            // 项目根据编号排序
            for (let i = 0; i < item.cardItemList.length; i++) {
              for (let j = 0; j < item.cardItemList.length; j++) {
                let num1 = Number(item.cardItemList[i].cardNo) ? Number(item.cardItemList[i].cardNo) : item.cardItemList[i].cardNo.charCodeAt();
                let num2 = Number(item.cardItemList[j].cardNo) ? Number(item.cardItemList[j].cardNo) : item.cardItemList[j].cardNo.charCodeAt();
                if (num1 > num2) {
                  let temp = item.cardItemList[i];
                  item.cardItemList[i] = item.cardItemList[j];
                  item.cardItemList[j] = temp;
                }
              }
            }

            if (item.cardTypeName === "充值卡") refillCard = item;
            if (item.cardTypeName === "次卡") subcard = item;
            if (item.cardTypeName === "折扣卡") discountCard = item;
          });
          this.openTheCardItemList = [refillCard, subcard, discountCard].filter((item) => item !== null); // 存储会员卡项

          resolve("数据请求成功");
        } else if (this.activeName === "personalitySubcard") {
          let param = {
            query_type: "like",
            on_sale_status: 0,
            pinyin: 0,
          };
          // 获取项目类型
          let projectTypeParams = {
            dict_type: "DT_007",
            asc: "order_num",
          };
          const { data: projectData } = await this.API.paperless.getGoodDict(projectTypeParams);
          const { data } = await this.API.paperless.getGoodPackageList(param);
          let subcardData = [];
          let newSubData = [];
          data.forEach((item) => {
            let sign = true;
            let subscript = 0;
            // // 添加标记
            this.$set(item, "cardActive", false);
            subcardData.forEach((subItem, index) => {
              if (item.packageTypeName === subItem.packageTypeName) {
                sign = false;
                subscript = index;
              }
            });
            if (sign) {
              subcardData.push({
                packageTypeName: item.packageTypeName,
                packageTypeId: item.packageTypeId,
                cardActive: item.cardActive,
                packagesList: [item],
              });
            } else subcardData[subscript].packagesList.push(item);
          });
          projectData.forEach((subItem) => {
            subcardData.forEach((packg) => {
              if (subItem.dictName === packg.packageTypeName) newSubData.push(packg);
            });
          });
          // 项目列表
          this.listOfSubCardItems = [{ packageTypeName: "全部项目", packagesList: [], cardActive: false }, ...newSubData];
          // 确保每个分类都有 currentLetter
          this.listOfSubCardItems.forEach(item => {
            if (!item.hasOwnProperty('currentLetter')) this.$set(item, 'currentLetter', '');
          });
          resolve("数据请求成功");
        }
      });
    },
    // 选择次卡项目
    subCardItemOption(item) {
      this.numberOfSubCards = 1; // 次卡次数
      this.subCardTimeLimit = -1; // 次卡时限
      this.theSecondCardSelectsTheItem = item; // 存储到预选
      // 检测项目是否已经添加
      if (!this.checksWhetherTheItemHasBeenAdded()) return (this.theSecondCardSelectsTheItem = {});
      this.modifyPopUp = true; // 打开项目次数、时限设置窗口
    },
    // 关闭次卡开卡
    closeTheSecondaryCardInformation() {
      this.theSecondCardSelectsTheItem = {}; // 次卡选择的项目
      this.modifyPopUp = false; // 关闭窗口
    },
    // 检测项目是否已经添加
    checksWhetherTheItemHasBeenAdded() {
      const { packageTypeName, id } = this.theSecondCardSelectsTheItem;
      // 判断是否选择了全部项目
      if (packageTypeName === "全部项目" && this.personalizedTimesCardPurchase.length >= 1) {
        this.$message.warning("项目不能重复选择");
        return false;
      }
      let taboo = this.personalizedTimesCardPurchase.some((item) => item.packageTypeName === "全部项目");
      if (taboo) {
        if (this.personalizedTimesCardPurchase.length >= 1) {
          this.$message.warning("项目不能重复选择");
          return false;
        }
      }
      console.log(this.theSecondCardSelectsTheItem);
      let superclass = []; // 父类
      let subclass = []; // 子类
      this.personalizedTimesCardPurchase.forEach((item) => {
        let { id } = item;
        if (!id) superclass.push(item);
        else subclass.push(item);
      });

      if (id) {
        // 判断用户先前是否选择了父级项目
        const fatherMsg = superclass.every((item) => item.packageTypeName !== packageTypeName);
        // 判断用户先前是否选了相同子类
        const sonMsg = subclass.every((item) => item.id !== id);
        if (fatherMsg && sonMsg) return true;
        this.$message.warning("项目不能重复选择");
        return false;
      } else {
        // 判断是否选择了子类
        const sonMsg = subclass.every((item) => item.packageTypeName !== packageTypeName);
        // 判断用户先前是否选择了相同父级项目
        const fatherMsg = superclass.every((item) => item.packageTypeName !== packageTypeName);
        if (fatherMsg && sonMsg) return true;
        this.$message.warning("项目不能重复选择");
        return false;
      }
    },
    // 确认添加项目
    confirmAdd() {
      this.theSecondCardSelectsTheItem.cardActive = true; // 修改堆内存地址数据中的标记
      // 存储次数
      this.$set(this.theSecondCardSelectsTheItem, "numberOfSubCards", this.numberOfSubCards); // 次卡次数
      this.$set(this.theSecondCardSelectsTheItem, "subCardTimeLimit", this.subCardTimeLimit); // 时限天数
      const { packageTypeName, packageName, packageCode } = this.theSecondCardSelectsTheItem;
      this.$set(this.theSecondCardSelectsTheItem, "cardItemCode", packageCode || packageTypeName);
      this.$set(this.theSecondCardSelectsTheItem, "cardItemName", packageName || packageTypeName);
      this.personalizedTimesCardPurchase.push(this.deepCopy(this.theSecondCardSelectsTheItem)); // 添加项目
      this.closeTheSecondaryCardInformation(); // 关闭设置次卡次数 时限窗口
    },
    // 开个性次卡
    openSexCard() {
      // 拉起支付 购卡
      if (this.cardPurchase) return this.payByCard(); // 调用接口结算
      if (this.personalizedTimesCardPurchase.length <= 0) return this.$message.warning("请先选择开卡项目");
      this.cardPurchase = true; // 开启结算窗口
    },
    // 开会员卡
    openMembershipCard(cardItem) {
      console.log("会员卡开卡");
      this.selectMembershipCardItems = cardItem; // 添加筛选的会员卡
      console.log("选中的卡信息",this.selectMembershipCardItems);
      this.cardPurchase = true; // 开启结算窗口
      this.memberCardPrice = cardItem.amount || 0; // 会员卡价格
      // 新增：只有次卡(cardTypeCode === 0)才有耗卡，开充值卡/折扣卡时清空残留耗卡数据,个性次卡另外有,这是开卡里的
    if (cardItem.cardTypeCode !== 0) {
        this.resetRechargeCardConsumption();
    }
          //  改成 nextTick 里调用 defaultAmount，
        //    避免被 memberCardPrice watch 的 clearAllPayments 覆盖,宏任务
        this.$nextTick(() => {
          this.defaultAmount();
        });
      // 添加默认支付方式
      // this.clearingForm.forEach((item) => {
      //   console.log("item", cardItem.amount || 0);
      //   item.name === "微信" && (item.paymentAmount = cardItem.amount || 0);
      // });
      this.getDepartmentalPerformance();
    },
    // 修改次卡项目
    modifyItem(item, $index) {
      this.theSecondCardSelectsTheItem = this.deepCopy(item);
      this.numberOfSubCards = this.theSecondCardSelectsTheItem.numberOfSubCards;
      this.subCardTimeLimit = this.theSecondCardSelectsTheItem.subCardTimeLimit;
      this.modifyPopUp = true;
    },
    // 确认修改
    confirmTheModificationOfSubCardItems() {
      this.personalizedTimesCardPurchase.forEach((item) => {
        if (this.theSecondCardSelectsTheItem.cardItemCode === item.cardItemCode && this.theSecondCardSelectsTheItem.cardItemName === item.cardItemName) {
          this.$nextTick(() => {
            item.numberOfSubCards = this.numberOfSubCards;
            item.subCardTimeLimit = this.subCardTimeLimit;
            this.closeTheSecondaryCardInformation(); // 关闭设置次卡次数 时限窗口
          });
        }
      });
    },
    // 移除次卡项目
    removeTheSubCardItem($index) {
      const item = this.personalizedTimesCardPurchase.splice($index, 1)[0];
      if (item.packageName) {
        this.listOfSubCardItems.forEach((packagesTypeCode) => {
          packagesTypeCode.packagesList.forEach((packagesItem) => {
            if (item.id === packagesItem.id) packagesItem.cardActive = false;
          });
        });
      } else if (item.packageTypeName === "全部项目") {
        this.listOfSubCardItems[0].cardActive = false;
      } else {
        this.listOfSubCardItems.forEach((packagesTypeCode) => {
          if (packagesTypeCode.packageTypeName === item.packageTypeName) packagesTypeCode.cardActive = false;
        });
      }
      // 判断是否还存储有所选的次卡开卡项目如果没有则返回选择次卡开卡项目页面
      this.personalizedTimesCardPurchase.length || (this.cardPurchase = false);
    },
    // 删除次卡项目
    deleteSubCardItems(item) {
      let id = "";
      let $index = "";
      if (item.id) id = item.id;
      else id = item.packageTypeId;

      this.personalizedTimesCardPurchase.forEach((person, index) => {
        if (id === person.packageTypeId || id === person.id) $index = index;
      });

      this.removeTheSubCardItem($index);
    },
    // 开启个性次卡添加销售员工
    personalitySubCardAddedSales() {
      this.addTopUpStaff(); // 添加销售员工
    },
    // 添加个性次卡销售全员
    personalitySubCardSelectionOfEmployees(staff) {
      this.$set(staff, "achievement", 0); // 销售
      this.$set(staff, "brokerageClass", ""); // 是否可手动修改
      if (this.personalitySubCardEmployeeList.length >= 5) return this.$message.warning("员工数量上限");
      if (this.openCardTemporaryDataList.length >= 5 - this.personalitySubCardEmployeeList.length) return this.$message.warning("员工数量上限");
      staff.label = true;
      staff.num += 1;
      this.openCardTemporaryDataList.push(staff);
    },
    // 确定修改订单
    async firmChangeOrder(type) {
      if (type === "openACard") {
        this.personalitySubCardEmployeeList = [...this.personalitySubCardEmployeeList, ...this.openCardTemporaryDataList];
        this.topUpEmployeeShow = false;
        this.openCardTemporaryDataList = []; // 清除临时员工
        await this.individualRecalculationOfEmployeePerformance(); // 重新计算业绩
      } else if (type === "topUp") {
        this.topUpSalesStaffList = [...this.topUpSalesStaffList, ...this.openCardTemporaryDataList];
        this.openCardTemporaryDataList = []; // 清除临时员工
        this.topUpEmployeeShow = false;
        await this.calculateTheTopUpPerformance(); // 重新计算业绩
      }

      this.$forceUpdate();
    },
    // 删除个性次卡员工信息
    deletePersonalitySubCardEmployees(index) {
      this.personalitySubCardEmployeeList.splice(index, 1);
    },
    // 删除员工数据
    deleteEmployeeData(id) {
      let index = this.openCardTemporaryDataList.findIndex((item) => item.id === id);
      this.openCardTemporaryDataList[index].num -= 1;
      if (!this.openCardTemporaryDataList[index].num) this.openCardTemporaryDataList[index].label = false;
      this.openCardTemporaryDataList.splice(index, 1);
    },
    // 个性次卡计算员工业绩
    async individualRecalculationOfEmployeePerformance() {
      // 个性次卡计算员工业绩
      if (this.activeName === "personalitySubcard") {
        let param = {
          tenantCardId: window.localStorage.getItem("tenantCardId"),
          originPrice: this.memberCardPrice,
          employeeIds: this.personalitySubCardEmployeeList.map((item) => item.id).toString() || ",",
        };

        const { data } = await this.API.paperless.calculateIndividualSubPerformance(param);
        data.orderEmployeeBrokerageVOList.forEach((item) => {
          const { employeeId, achievement, brokerageClass, percentage } = item;
          this.personalitySubCardEmployeeList.forEach((subItem) => {
            if (employeeId === subItem.id) {
              subItem.achievement = achievement || 0;
              subItem.percentage = percentage || 0;
              subItem.brokerageClass = brokerageClass;
            }
          });
        });
      } else {
        let param = {
          tenantCardId: this.selectMembershipCardItems.id,
          originPrice: this.memberCardPrice,
          employeeIds: this.personalitySubCardEmployeeList.map((item) => item.id).toString() || ",",
        };
        // 开卡计算员工业绩
        const { data } = await this.API.paperless.createCardDetailAndBrokerage(param);
        data.orderEmployeeBrokerageVOList.forEach((item) => {
          const { employeeId, percentage, achievement, brokerageClass } = item;
          this.personalitySubCardEmployeeList.forEach((subItem) => {
            if (employeeId === subItem.id) {
              subItem.achievement = achievement || 0;
              subItem.percentage = percentage || 0;
              subItem.brokerageClass = brokerageClass;
            }
          });
        });
      }
    },
    // 更新会员信息
    async updateMemberInformation($event) {
      let type = "";
      let value = "";
      if ($event.target) {
        type = $event.target.dataset.type;
        value = $event.target.dataset.value;
      } else {
        type = $event.$el.dataset.type;
        value = $event.$el.dataset.value;
      }
      if (type === "deductionsState") this.editMemberInformationContent.deductionsState = Number(value);
      if (type === "gender") this.editMemberInformationContent.gender = Number(value);

      // 添加了8开头的手机号 下面那个是以前的
      if (type === "memberMobile" && !/^[1|8][3|4|5|6|7|8｜9][0-9]{9}$/.test(this.editMemberInformationContent.memberMobile)) return this.clearMemberInfo(type);
      // if (type === "memberMobile" && !/^1[3,4,5,6,7,8,9][0-9]{9}$/.test(this.editMemberInformationContent.memberMobile)) return this.clearMemberInfo(type);
    },
    // 会员数据查询
    memberDataQuery(value) {
      if (value === "") return;
      return new Promise(async (resolve, reject) => {
        // 根据手机号或者姓名或者会员号进行查询
        let param = {
          query: value,
        };
        let { data } = await this.API.paperless.getMemberInfoList(param);
        console.log("查询的会员资料", data);
        // 如果有会员信息进行查询
        await this.anOpenCardItemIsMarked(data[0] ? data[0].memberMobile : null);
        resolve(data);
      });
    },
    // 表单校验
    async focussing($event) {
      let type = "";
      if ($event.target) {
        type = $event.target.dataset.type;
      } else {
        type = $event.$el.dataset.type;
      }

      // 添加了8开头的手机号 下面那个是以前的
      if (type === "memberMobile" && !/^[1|8][3|4|5|6|7|8｜9][0-9]{9}$/.test(this.editMemberInformationContent.memberMobile)) {
        // if (type === "memberMobile" && !/^1[3,4,5,6,7,8,9][0-9]{9}$/.test(this.editMemberInformationContent.memberMobile)) {
        return this.$message.warning("手机号不正确");
      }
      // 更新会员数据
      let memberList = null;
      if (type === "memberMobile") {
        memberList = await this.memberDataQuery(this.editMemberInformationContent.memberMobile);
      }
      memberList[0] && this.addMembershipDetails(memberList[0]);
      this.whetherNewMembersCanBeAdded(); // 更新是否是新会员状态
    },
    // 清除会员信息
    clearMemberInfo(deleteType) {
      let clearMember = {
        birthday: "", // 生日时间
        memberLevelName: "粉丝会员", // 会员等级
        memberSourceName: "手工录入", // 顾客来源
        memberMobile: "", // 会员手机号
        memberName: "", // 会员姓名
        memberNo: "", // 会员号
        gender: 0, // 性别
        deductionsState: 1, // 是否匹配
        remark: "", // 备注
        id: "", // 会员id
        wechatAccount: "", // 会员编号
      };
      delete clearMember[deleteType];
      Object.assign(this.editMemberInformationContent, clearMember);
      this.isNewMemberInfo = false;
      this.taggedMember = [];
    },
    // 是否可新增会员
    whetherNewMembersCanBeAdded() {
      // 添加了8开头的手机号 下面那个是以前的
      this.isNewMemberInfo = this.isNewMember === false && /^[1|8][3|4|5|6|7|8｜9][0-9]{9}$/.test(this.editMemberInformationContent.memberMobile);
      // this.isNewMemberInfo = this.isNewMember === false &&/^1[3,4,5,6,7,8,9][0-9]{9}$/.test(this.editMemberInformationContent.memberMobile);
    },
    // 已开卡项标记
    async anOpenCardItemIsMarked(memberMobile) {
      console.log("开始标记", memberMobile);
      if (!memberMobile) return;
      let { data: dataCard } = await this.API.paperless.getMemberParticulars({
        phone: memberMobile,
        cardLeachStatus: 1,
      });
      //2026年7月9号修改
      //0 = 次卡,1 = 折扣卡,2 = 充值卡,3 = 个性次卡
      ///let newCard = dataCard.filter((item) => item.tmemberCard.cardTypeCode !== 3);
      //!==3将个性次卡移出数组taggedMember这样不管用户有没有都不会红,现在让数组中只有充值卡===2
      let newCard = dataCard.filter((item) => item.tmemberCard.cardTypeCode ===2);
      //从 dataCard 数组中过滤出 cardTypeCode === 2 的项（即会员卡类型为 2 的卡）
      // 【新增】存储完整充值卡2对象,并且总金额>0（用于展示）智慧耗卡要的数组
      this.existingRechargeCards = newCard
       .filter(item => {
          // 过滤条件：剩余可用余额 > 0
          return item.tmemberCard.remaindAmount > 0;
        }).map(item => item.tmemberCard);
      console.log("所有卡类型为2的完整信息:", newCard);
      let cardNoList = [];
      newCard.forEach((item) => {
        cardNoList.push(item.tmemberCard.cardNo);//cardNo卡名
      });
      this.taggedMember = cardNoList;
      return Promise.resolve();
    },
    // 去开卡
    openACard() {
      this.confirmAdd(); // 添加个性次卡项目
      this.openSexCard(); // 开卡结算页面
    },
    // 支付开卡订单
    async payByCard(afterTheResult) {
      // afterTheResult 0继续开卡 1去耗卡
      if (!this.cardPurchase) return false;
      let loadingInstance = null;
      let memberId = this.editMemberInformationContent.id || "";
      // 判断当前用户信息是否有填写会员手机号 和 会员姓名
      if (!this.editMemberInformationContent.memberMobile) {
        this.$refs.memberMobileRef.focus();
        this.$message.warning("请先填写会员手机号");
        return false;
      }
      if (!this.editMemberInformationContent.memberName) {
        this.$refs.memberNameRef.focus();
        this.$message.warning("请填写会员名");
        return false;
      }
      if (this.memberCardPrice <= 0 && this.amountOfGift <= 0) {
        this.$message.warning("请输入开卡价格");
        return false;
      }
      if (!this.individualCardPaymentStatus) {
        this.$message.warning("请选择支付方式");
        return false;
      }
      if (this.activeName !== "openACard") {
        if (!this.personalizedTimesCardPurchase.length) {
          this.$message.warning("开卡项目不能为空");
          return false;
        }
      }
      if (JSON.parse(window.localStorage.getItem("tenant")).serialNumState === 1 && !this.billNumber) {
        this.$message.warning("请输入流水单号");
        return false;
      }
      // 判断员工数据是否为空
      this.unpaid("personalitySubCardEmployeeList", "personalitySubCardAddedSales").then(async () => {
        try {
          // 开启加载图标
          loadingInstance = Loading.service({
            fullscreen: true,
            text: "支付中",
            background: "rgba(0, 0, 0, .7)",
            spinner: "el-icon-loading",
          });
          // 查看当前是否不是无会员信息 无会员信息需要添加
          if (this.isNewMemberInfo) {
            // 发送请求添加会员信息
            this.editMemberInformationContent.tenantId = window.localStorage.getItem("tenantId");
            this.editMemberInformationContent.memberLevelId = ""; // 会员等级id
            this.editMemberInformationContent.lockGrade = 0; // 会员锁定等级
            const { data } = await this.API.paperless.addMemberInformation(this.editMemberInformationContent);
            memberId = data; // 存储会员信息
          }

            //开卡请求体
          if (this.activeName === "openACard") {
            // let param = {
            //   customerCount: this.customerCount,
            //   chargeTime: "",
            //   costCardAmount: 0,
            //   creatCardDTO: {
            //     employeeIds: "",
            //     memberId: memberId,
            //     orderEmployeeBrokerageVOList: [],
            //     originPrice: parseFloat(this.memberCardPrice),
            //     sendPrice: parseFloat(this.amountOfGift),
            //     tenantCardId: this.selectMembershipCardItems.id,
            //   },
            //   flag: this.isMies,
            //   freeAmount: parseFloat(this.memberCoupon),
            //   orderType: 10,
            //   payCrashAmount: parseFloat(this.cashByPersonalCard),
            //   payTypeDTOList: [],
            //   payableAmount: parseFloat(this.memberCardPrice),
            //   remark: this.billNumber,
            //   totalAmount: parseFloat(this.memberCardPrice),
            // };
             let param = {
              //customerCount: this.customerCount,
              chargeTime: "",
	            orderType: 10,
 	            payTypeDTOList: [],

             	creatCardDTO: {
                employeeIds: "",
                memberId: memberId,
                orderEmployeeBrokerageVOList: [],
                originPrice: parseFloat(this.memberCardPrice),
                sendPrice: parseFloat(this.amountOfGift),
                tenantCardId: this.selectMembershipCardItems.id,
              },
	            remark: this.billNumber,
	            totalAmount: parseFloat(this.memberCardPrice),
             	freeAmount: parseFloat(this.memberCoupon),
              payCrashAmount: parseFloat(this.cashByPersonalCard),
             	costCardAmount: this.accuracyCheck(this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold), // 耗卡总额
              payableAmount: parseFloat(this.memberCardPrice),
	            costInitAmount: this.amountOfConsumableCardNumber || 0, // 耗卡本金
              costGivenAmount: this.canConsumeCardIncreaseGold || 0, // 耗卡赠
              flag: this.isMies,
	            consumeDTO: {
              memberCardId: this.selectedRechargeCard ? this.selectedRechargeCard.id : '',// 选中卡id

              },

            };

            // 销售员工信息
            param.creatCardDTO.employeeIds = this.personalitySubCardEmployeeList.map((item) => item.id).toString();
            for (let i = 0; i < 5; i++) {
              let id = "";
              let employeeNo = "";
              let achievement = "";
              let percentage = "";
              if (this.personalitySubCardEmployeeList[i]) {
                id = this.personalitySubCardEmployeeList[i].id;
                employeeNo = this.personalitySubCardEmployeeList[i].employeeNo;
                achievement = this.personalitySubCardEmployeeList[i].achievement;
                percentage = this.personalitySubCardEmployeeList[i].percentage;
              }
              param.creatCardDTO.orderEmployeeBrokerageVOList.push({
                employeeId: id || "",
                achievement: parseFloat(achievement) || null,
                employeeNo: employeeNo || "",
                percentage: parseFloat(percentage) || null,
              });
            }
            // 支付方式
            this.clearingForm.forEach((payItem) => {
              const { name, paymentAmount } = payItem;
              let pay = {
                amount: 0,
                payType: "",
                payTypeName: "",
              };
              switch (name) {
                case "智慧支付":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 0,
                    payTypeName: "智慧支付",
                  });
                  break;
                case "微信":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 1,
                    payTypeName: "微信",
                  });
                  break;
                case "支付宝":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 2,
                    payTypeName: "支付宝",
                  });
                  break;
                case "现金":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 3,
                    payTypeName: "现金",
                  });
                  break;
                case "银联刷卡":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 4,
                    payTypeName: "银联刷卡",
                  });
                  break;
                case "团购":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 5,
                    payTypeName: "团购",
                  });
                  break;
                case "代金券":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 6,
                    payTypeName: "代金券",
                  });
                  break;
                case "积分":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 7,
                    payTypeName: "积分",
                  });
                  break;
                case "其他":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 8,
                    payTypeName: "其他",
                  });
                  break;
              }
              if (parseFloat(pay.amount)) param.payTypeDTOList.push(pay);
            });
            // 添加智慧耗卡到支付方式列表
              const cardConsumption = this.accuracyCheck(
                this.amountOfConsumableCardNumber,
                this.canConsumeCardIncreaseGold
              );
              if (cardConsumption > 0) {
                  param.payTypeDTOList.push({
                    amount: cardConsumption,
                    payType: 9,
                    payTypeName: "智慧耗卡",
                  });
                }
            // 判断支付方式是否为空 处理0元支付情况
            if (!param.payTypeDTOList.length) {
              let finalSettlement = this.accuracyCheck(this.memberCardPrice, this.memberCoupon, "-");
              if (finalSettlement <= 0) {
                param.payTypeDTOList.push({
                  payType: 8,
                  amount: finalSettlement,
                  payTypeName: "其他",
                });
              }
            }
            console.log("开卡请求参数", param);
            const { data: memberCardId } = await this.API.paperless.membersOpenCardsToSettleOrders(param);
            // 判断是否有卡备注 如果有卡备注需要在发送一次请求更新卡信息
            let cardRemarksRequestData = {
              id: memberCardId,
              remark: this.membershipCardRemarks,
            };
            if (this.membershipCardRemarks) {
              await this.API.paperless.withTheNewCardInformation(cardRemarksRequestData);
            }
            // 添加部门业绩-开卡
            let dataName = [];
            let dataId = await this.API.order.getOrdermemberCardIdGetOrderId({ memberCardId: memberCardId });
            let tenant = localStorage.getItem("tenantId");
            for (let i = 0; i < this.isDepartmentalPerformance.length; i++) {
              dataName.push({
                orderId: dataId.data,
                tenantId: tenant,
                departmentId: this.isDepartmentalPerformance[i].departmentId,
                departmentName: this.isDepartmentalPerformance[i].departmentName,
                achievement: Number(this.isDepartmentalPerformance[i].achievement),
                unAchievement: Number(this.isDepartmentalPerformance[i].unAchievement),
              });
            }
            dataName[dataName.length - 1].unAchievement = this.totalName;

            await this.API.goods.postAddDepartmentalPerformance(dataName).then((res) => {
              console.log("res.data", res.data);
            });
            this.$emit("updateDepartmentalList", null);
            this.isDepartmentalPerformance.forEach((item) => (item.achievement = 0));

            this.customerCount = 1;
            this.$message.success("结算成功");
            this.$emit("selectMemberInformation", this.editMemberInformationContent, undefined, memberCardId); // 触发父组件事件 更新会员卡实时余额
            // 开卡耗卡
            setTimeout(() => {
              this.$nextTick(() => {
                loadingInstance.close(); // 关闭加载
                this.handleClose(); // 关闭支付窗口
              });
            }, 800);
          } else {
            /** * 个性次卡开卡 **/
            // 店铺开卡
            let openCardParam = {
              tenantId: window.localStorage.getItem("tenantId"),
            };
            // 计算当前筛选的项
            let details = this.personalizedTimesCardPurchase.map((project) => {
              const { packageName, packageTypeName, packageTypeId, numberOfSubCards, subCardTimeLimit } = project;
              project.frequency = numberOfSubCards;
              project.timeLimit = subCardTimeLimit;
              let cardTime = {};
              if (packageName) {
                project.itemId = project.id;
                project.itemName = packageName;
                project.itemType = "package";
                cardTime = project;
              } else if (packageTypeName && packageTypeName !== "全部项目") {
                project.itemType = "package_classify";
                project.packageTypeId = 999;
                project.itemName = packageTypeName;
                project.packageTypeName = "全部项目";
                project.itemId = packageTypeId;
                this.listOfSubCardItems.forEach((projectType) => {
                  if (packageTypeName === projectType.packageTypeName) {
                    project.children = projectType.packagesList;
                  }
                });
                cardTime = project;
              } else {
                let itemListCopy = this.deepCopy(this.listOfSubCardItems);
                itemListCopy.splice(0, 1);
                itemListCopy.forEach((item) => {
                  item.children = item.packagesList;
                });
                project.itemId = "999";
                project.itemName = "项目";
                project.itemType = "package_classify";
                project.children = itemListCopy;
                cardTime = project;
              }
              return cardTime;
            });
            openCardParam.details = details;
            const { data: tenantCardId } = await this.API.paperless.storeOpeningCard(openCardParam);
            //个性次卡结账请求体
            //let param = { ... };请求体编辑,后面对其中赋值
            let param = {
              chargeTime: "",
              orderType: 10,
              payTypeDTOList: [],
              creatCardDTO: {
              tenantCardId,
              employeeIds: "",
              memberId,
              sendPrice: 0, // 赠送金额
              originPrice: parseFloat(this.memberCardPrice), // 原价
              orderEmployeeBrokerageVOList: [],

              },
              remark: this.billNumber,
              totalAmount: parseFloat(this.memberCardPrice), // 总金额
              freeAmount: parseFloat(this.memberCoupon), // 优惠金额
              payCrashAmount: parseFloat(this.cashByPersonalCard), // 实付金额
              costCardAmount: this.accuracyCheck(this.amountOfConsumableCardNumber, this.canConsumeCardIncreaseGold), // 耗卡总额
              payableAmount: parseFloat(this.memberCardPrice), // 总金额
              costInitAmount: this.amountOfConsumableCardNumber || 0, // 耗卡本金
              costGivenAmount: this.canConsumeCardIncreaseGold || 0, // 耗卡赠金
              //customerCount: this.customerCount,
              flag: this.isMies,
              consumeDTO: {
              memberCardId: this.selectedRechargeCard ? this.selectedRechargeCard.id : '',// 选中卡id

              },

            };
            // 销售员工信息
            param.creatCardDTO.employeeIds = this.personalitySubCardEmployeeList.map((item) => item.id).toString();
            for (let i = 0; i < 5; i++) {
              let id = "";
              let employeeNo = "";
              let achievement = "";
              let percentage = "";
              if (this.personalitySubCardEmployeeList[i]) {
                id = this.personalitySubCardEmployeeList[i].id;
                employeeNo = this.personalitySubCardEmployeeList[i].employeeNo;
                achievement = this.personalitySubCardEmployeeList[i].achievement;
                percentage = this.personalitySubCardEmployeeList[i].percentage;
              }
              param.creatCardDTO.orderEmployeeBrokerageVOList.push({
                employeeId: id || "",
                achievement: parseFloat(achievement) || null,
                employeeNo: employeeNo || "",
                percentage: parseFloat(percentage) || null,
              });
            }

            // 支付方式
            this.clearingForm.forEach((payItem) => {
              const { name, paymentAmount } = payItem;
              let pay = {
                amount: 0,
                payType: "",
                payTypeName: "",
              };
              switch (name) {
                case "智慧支付":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 0,
                    payTypeName: "智慧支付",
                  });
                  break;
                case "微信":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 1,
                    payTypeName: "微信",
                  });
                  break;
                case "支付宝":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 2,
                    payTypeName: "支付宝",
                  });
                  break;
                case "现金":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 3,
                    payTypeName: "现金",
                  });
                  break;
                case "银联刷卡":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 4,
                    payTypeName: "银联刷卡",
                  });
                  break;
                case "团购":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 5,
                    payTypeName: "团购",
                  });
                  break;
                case "代金券":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 6,
                    payTypeName: "代金券",
                  });
                  break;
                case "积分":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 7,
                    payTypeName: "积分",
                  });
                  break;
                case "其他":
                  Object.assign(pay, {
                    amount: paymentAmount,
                    payType: 8,
                    payTypeName: "其他",
                  });
                  break;
              }
              if (parseFloat(pay.amount)) param.payTypeDTOList.push(pay);
            });
            // 添加智慧耗卡到支付方式列表
              const cardConsumption = this.accuracyCheck(
                this.amountOfConsumableCardNumber,
                this.canConsumeCardIncreaseGold
              );
              if (cardConsumption > 0) {//耗卡存在
                param.payTypeDTOList.push({//传入请求体
                  amount: cardConsumption,//耗卡金额
                  payType: 9,
                  payTypeName: '智慧耗卡',
                });
              }
            // 判断支付方式是否为空 处理0元支付情况
            if (!param.payTypeDTOList.length) {
              let finalSettlement = this.accuracyCheck(this.memberCardPrice, this.memberCoupon, "-");
              if (finalSettlement <= 0) {
                param.payTypeDTOList.push({
                  payType: 8,
                  amount: finalSettlement,
                  payTypeName: "其他",
                });
              }
            }
            console.log("请求参数信息", param);
            const { data: memberCardId } = await this.API.paperless.individualSubCardOrderSettlement(param);

            // 添加部门业绩-次卡
            let dataName = [];
            let dataId = await this.API.order.getOrdermemberCardIdGetOrderId({ memberCardId: memberCardId });
            let tenant = localStorage.getItem("tenantId");
            for (let i = 0; i < this.isDepartmentalPerformance.length; i++) {
              dataName.push({
                orderId: dataId.data,
                tenantId: tenant,
                departmentId: this.isDepartmentalPerformance[i].departmentId,
                departmentName: this.isDepartmentalPerformance[i].departmentName,
                achievement: Number(this.isDepartmentalPerformance[i].achievement),
                unAchievement: Number(this.isDepartmentalPerformance[i].unAchievement),
              });
            }
            dataName[dataName.length - 1].unAchievement = this.totalName;

            await this.API.goods.postAddDepartmentalPerformance(dataName).then((res) => {
              console.log("res.data", res.data);
            });
            this.isDepartmentalPerformance.forEach((item) => (item.achievement = 0));
            this.$emit("updateDepartmentalList", null);
            this.customerCount = 1;
            this.$message.success("订单结算成功");
            console.log("结算成功", this.editMemberInformationContent);
            this.$emit("selectMemberInformation", this.editMemberInformationContent, undefined, memberCardId); // 触发父组件事件 更新会员卡实时余额
            // 开卡耗卡
            setTimeout(() => {
              this.$nextTick(() => {
                loadingInstance.close(); // 关闭加载
                this.handleClose(); // 关闭支付窗口
              });
            }, 800);
          }
        } catch (error) {
          console.log("开卡支付错误", error);
          this.$message.error("订单结算异常");
          this.monitorCarriageReturnPayment(this.payByCard); // 回车2次结算
          this.$nextTick(() => {
            loadingInstance.close(); // 关闭加载
          });
          return false;
        }
      });
      return true;
    },
    // 会员信息编辑保存
    async enableMemberInformationEditing() {
      console.log(this.whetherNewMembersCanBeAdded);
      // 开启加载
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "加载中",
        background: "rgba(0, 0, 0, .7)",
        spinner: "el-icon-loading",
      });
      let param = this.deepCopy(this.editMemberInformationContent);
      param.memberLevelId = param.memberLevelId || ""; // 会员等级id
      param.lockGrade = param.lockGrade || 0; // 会员锁定等级
      param.remark = param.remark || "";
      // 发送请求添加会员信息
      const { data } = await this.API.paperless.addMemberInformation(param);
      this.editMemberInformationContent.id = data; // 存储会员id
      this.$nextTick(() => {
        loadingInstance.close();
        this.$message.success("会员信息添加成功");
        this.isNewMemberInfo = false;
      });
    },
    // 当点击开卡的时候提前更新会员信息数据过来
    addMembershipDetails({ birthday, memberLevelName, memberSourceName, memberMobile, memberName, memberNo, gender, deductionsState, remark, id }) {
      // 更新会员信息
      this.editMemberInformationContent.birthday = birthday || ""; // 生日
      this.editMemberInformationContent.memberLevelName = memberLevelName || ""; // 会员等级
      this.editMemberInformationContent.memberSourceName = memberSourceName || ""; // 顾客来源
      this.editMemberInformationContent.memberMobile = memberMobile || ""; // 会员手机号
      this.editMemberInformationContent.memberName = memberName || ""; // 会员姓名
      this.editMemberInformationContent.memberNo = memberNo || ""; // 会员号
      this.editMemberInformationContent.gender = gender; // 性别
      this.editMemberInformationContent.deductionsState = deductionsState; // 是否匹配
      this.editMemberInformationContent.remark = remark || ""; // 备注
      this.editMemberInformationContent.id = id || ""; // 会员id
    },
    // 开卡价格/变化时：用户选过支付方式就填入，否则默认微信
syncPaymentOnPriceChange() {
  const amount = this.cashByPersonalCard;

  // 记住当前哪个支付方式有金额（= 用户选过的）
  const activeNames = this.clearingForm
    .filter(item => item.paymentAmount > 0)
    .map(item => item.name);

  // 全部清 0
  this.clearingForm.forEach(item => {
    item.paymentAmount = 0;
  });

  // 用户没选过 → 默认微信
  if (activeNames.length === 0) {
    const wechat = this.clearingForm.find(item => item.name === '微信');
    if (wechat) wechat.paymentAmount = amount > 0 ? amount : 0;
    return;
  }

  // 用户选过 → 填到原来那个方式（多个时取第一个）
  const target = this.clearingForm.find(item => item.name === activeNames[0]);
  if (target) target.paymentAmount = amount > 0 ? amount : 0;
},
    // 开卡价格优惠金额变化时清空所有支付方式
clearAllPayments() {
  // 清空 clearingForm 所有支付方式
  this.clearingForm.forEach(item => {
    item.paymentAmount = 0;
  });
//这是开卡价格/优惠价格变化时要不要清空耗卡重新选
  // // 清空智慧耗卡
  // this.amountOfConsumableCardNumber = 0;
  // this.canConsumeCardIncreaseGold = 0;
  // this.haoCardMoney = 0;

  // // 清空内层抽屉的耗卡输入
  // this.modifyPaymentAmount.forEach(item => {
  //   if (item.name === '耗卡本金' || item.name === '耗卡赠金') {
  //     item.money = '';
  //   }
  // });

  // // 取消选中卡，防止 blur 时 onPriceChanged 把耗卡又分配回来
  // this.selectedRechargeCard = null;
},
    // 设置默认金额
    defaultAmount() {
       // 如果已选中充值卡，由 cashByPersonalCard 统一控制耗卡逻辑，不再设置微信支付,当卡不足时cashByPersonalCard要自动恢复微信支付
        if (this.selectedRechargeCard) {
          return;
        }
        // 自动设置微信支付为现付价格
      this.clearingForm.forEach((item) => {
        //item.name === "微信" && (item.paymentAmount = this.memberCardPrice);//memberCardPrice是开卡价格
        item.name === "微信" && (item.paymentAmount = this.cashByPersonalCard);//cashByPersonalCard返回了现付价格
      });
    },
    /** ***************************************************** 挂单 ***************************************************** **/
    // 订单合计
    totalOrderPrice(orderGroup) {
      console.log("订单合计", orderGroup);
      return orderGroup.reduce((previousValue, currentValue) => {
        return this.accuracyCheck(previousValue, currentValue.price);
      }, 0);
    },
    // 删除订单
    cancellationOfOrder(id) {
      this.$alert("确定删除订单", "删除订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const param = {
            id,
            status: 400,
          };
          const { data } = await this.API.paperless.cancellationOfOrder(param);
          if (data) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            // 刷新挂单数据
            this.$emit("getTheListOfOrderingData", { dataTime: this.checkOrdersByDate }); // 刷新挂单数据
            // 清除一下会员信息
            this.$emit("research");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 更新代付款单状态
    updateTag(item) {
      // 当前所选的挂单列表
      console.log("挂单字段：", Object.keys(item));
      console.log("memberName =", item.memberName);
      if (item.sign) {
        this.currentlyTheOrderIsSelected = this.currentlyTheOrderIsSelected.filter((orderItem) => orderItem.id !== item.id);
      } else {
        this.currentlyTheOrderIsSelected.push(item);
      }
      this.$emit("updateTag", item.id);
    },
    // 合并订单
    async consolidateOrders() {
      let param = null;
      param = this.currentlyTheOrderIsSelected.map((item) => item.id);
      console.log(param);
      await this.API.paperless.mergeBillingInformation(param);
      this.currentlyTheOrderIsSelected = []; // 清除合并后的数据
      this.$emit("getTheListOfOrderingData", { dataTime: this.checkOrdersByDate }); // 刷新挂单数据
    },
    // 取单
    takeTheOrder(item, odd) {
      console.log(item, odd, "取单");
      console.log('整条挂单 item:', item);
  console.log('torderPpItems 里的 employees:', item.torderPpItems.map(i => i.employees));
   console.log('整条挂单employeeMap :', item.employeeMap);

      // 数据处理
      // item.employeeMap 员工数据列表 添加到employeeList
      // item.torderPpItems 订单数据列表
      let param = {
        query_type: "like",
        on_sale_status: "0",
        pinyin: "0",
      };
      let orderDetaList = this.API.paperless.getGoodPackageList(param);
      let productList = this.API.paperless.getTenantProductList(param);
      Promise.all([orderDetaList, productList]).then(async (resAll) => {
        let productDataSet = [...resAll[0].data, ...resAll[1].data];
        // 订单信息集合 torderPpItems
        let orderList = item.torderPpItems.map((orderItem) => {
          let { itemId, orderId, orderNo, employees, discountedAmount, discountedPrice, amount } = orderItem;
          let singleOrder = productDataSet.filter((producItem) => itemId === producItem.id)[0];
          console.log('employees :', item.employeeMap);
          singleOrder.orderId = orderId; // 待付款id
          singleOrder.orderNo = orderNo; // 待付款单号
          singleOrder.employees = employees; // 员工数据
          singleOrder.ppItemId = orderItem.id;
          singleOrder.discountedAmount = orderItem.discountedAmount;
          singleOrder.discountedPrice = orderItem.discountedPrice;
          singleOrder.total = orderItem.discountedPrice;
          singleOrder.amount = amount;

          singleOrder.handBrand = odd || orderNo[orderNo.length - 3] + orderNo[orderNo.length - 2] + orderNo[orderNo.length - 1] + ":orderNO"; // 手牌号
          return this.deepCopy(singleOrder); // 返回订单数据
        });
        // console.log('employeeMap', item)
        console.log("取单传递回去给页面的orderList", orderList);
        // // 添加员工信息
        // orderList.forEach((orderItem) => {
        //   if (orderItem.employees) {
        //     let empList = orderItem.employees.split(";").map((empItem) => {
        //       let currentOrderEmployeeData = empItem.split("&nbsp").filter((item) => !!item);
        //       // 读取员工工号
        //       let employeeNo = currentOrderEmployeeData[0];
        //       // 读取指定非指定
        //       let isAppoint = false; // 默认非指定

        //       if (currentOrderEmployeeData.length === 4) isAppoint = true;
        //       else if (currentOrderEmployeeData[2] === "(指定)") isAppoint = true;

        //       // 读取员工职位
        //       let position = null; // 默认为null
        //       if (currentOrderEmployeeData[2] !== "(指定)") position = currentOrderEmployeeData[2] || null;

        //       // console.log('取单时解析数据', currentOrderEmployeeData)
        //       // console.log('取单时-工号', employeeNo)
        //       // console.log('取单时--指定非指定', isAppoint)
        //       // console.log('取单时----职位', position)
        //       return item.employeeMap.filter((employeesItem) => {
        //         if (employeesItem.employeeNo === employeeNo && employeesItem.workAppointType === position) {
        //           employeesItem.appoint = isAppoint ? 1 : 0;
        //           this.$set(employeesItem, "workTypeName", position);
        //           return employeesItem;
        //         }
        //       })[0];
        //     });
        //     console.log("整理的员工数据", empList);
        //     orderItem.employeeList = [...empList]; // 员工数据
        //   } else orderItem.employeeList = []; // 员工数据初始化
        // });

        orderList.forEach((orderItem) => {
  // 从 employeeMap 拿这个品项的最新员工
  const matched = (item.employeeMap || []).filter(emp => emp.itemId === orderItem.ppItemId);

  // 从 employees 字符串里构建 【职位 -> 是否指定】 映射
  const positionAppointMap = {};
  if (orderItem.employees) {
    orderItem.employees.split(";").forEach(seg => {
      const d = seg.split("&nbsp").filter(Boolean);
      // 包含 "(指定)" 就是指定
      const isAppoint = d.indexOf("(指定)") !== -1 ? 1 : 0;
      // 职位 = 排除 工号(d[0])、姓名(d[1])、"(指定)" 后剩下的那一段
      const pos = d.find((x, i) => i >= 2 && x !== "(指定)");
      if (pos) positionAppointMap[pos] = isAppoint;
    });
  }

  orderItem.employeeList = matched.map(emp => {
    const copy = this.deepCopy(emp);
    const pos = emp.workAppointType || emp.workTypeName || null;
    copy.workTypeName = pos;
    // appoint 优先从字符串里按职位拿
    copy.appoint = positionAppointMap[pos] !== undefined
      ? positionAppointMap[pos]
      : (emp.appoint || 0);
    return copy;
  });
});
        // console.log('订单列表', orderList)
        // 判断有无会员信息
        if (item.memberId) {
          const { data: memberInfo } = await this.API.paperless.getInformationAccordingToTheMemberId(item.memberId);
          this.$emit("updateOrderData", { orderList, memberInfo, memberCardId: item.memberCardId || undefined });
          this.handleClose();
          return;
        }
        this.$emit("updateOrderData", { orderList });
        this.handleClose();
      });
    },
    // 手牌查询单
    handCheckList(key, takeTheOrder) {
      if (key === "") return this.$emit("getTheListOfOrderingData", { dataTime: this.checkOrdersByDate });
      this.$emit("getTheListOfOrderingData", { dataTime: this.checkOrdersByDate, key, takeTheOrder: takeTheOrder });
    },
    // 开启更新手牌号
    async updateTheHandNumber(item) {
      this.$nextTick(() => {
        this.theHandNumberPopsUp = true;
        this.updateTheCorrespondingDataOfTheHand = item; // 存储要更新手牌号的订单
      });

      // 获取已占用手牌号信息
      const { data } = await this.API.paperless.theNumberOfTheCurrentlyOccupiedHandObtained();
      this.occupied = data;
    },
    // 修改手牌号
    async changeHand(key) {
      if (key === "") return;
      if (this.occupied.indexOf(key) !== -1) return this.$message.warning("手牌号已被占用");
      let param = {
        handBrand: key,
        id: this.updateTheCorrespondingDataOfTheHand.id,
      };
      const { data } = await this.API.paperless.cancellationOfOrder(param);
      if (data) {
        this.$emit("getTheListOfOrderingData", { dataTime: this.checkOrdersByDate }); // 更新订单数据
        this.$nextTick(() => {
          this.$message.success("手牌号添加成功");
          this.theHandNumberPopsUp = false;
          this.updateTheCorrespondingDataOfTheHand = null; // 存储要更新手牌号的订单
        });
      }
    },
    // 根据员工id查询订单
    inquireOrdersAccordingToStaff(id) {
      if (id === this.idOfTheCurrentlySelectedEmployee) this.idOfTheCurrentlySelectedEmployee = "";
      else this.idOfTheCurrentlySelectedEmployee = id;
    },
    // 开启时间筛选
    openTimeFilter() {
      this.dateFilteringPopsUp = true;
    },
    // 开启监听订单支付状态
    enableOrderPaymentStatus() {
      this.paymentTimer = setInterval(async () => {
        const { data } = await this.API.paperless.monitorTheCompletionOfPaymentOrders(this.paymentOrderId);
        this.payState = data.status; // 更新支付状态
        if (data.status === 300) {
          console.log("语音支付", data);
          receivingAudio(data.amount, data.payMode == "WECHAT" ? 1 : 2);
          this.$message.success("支付成功");
          // 修改支付状态为成功
          this.globalPaymentStatus = "1"; // 全局支付状态
          // 判断当前订单是否可进行结算
          this.whetherItIsPayableOrNot &&
            this.$confirm("支付成功、是否立即结算订单", "支付完成", {
              confirmButtonText: "立即结算",
              cancelButtonText: "暂不结算",
              type: "success",
            }).then(async () => {
              // 调用结算代码
              this.type === 3 && (await this.tallyOrder()); // 订单结算
              this.type === 4 && (await this.openSexCard()); // 开卡结算
              this.type === 2 && (await this.confirmRecharge()); // 充值结算
            });

          // 关闭支付窗口
          if (this.innerDrawer) this.innerDrawerHandleClose();
          else this.closeTheScanCodePaymentWindow();
        }

        // 判断订单是否超时
        if (data.status === 400) {
          this.$message.success("订单超时");
          clearInterval(this.paymentTimer);

          // 关闭支付窗口
          if (this.innerDrawer) this.innerDrawerHandleClose();
          else this.closeTheScanCodePaymentWindow();
        }
      }, 2000);
    },
    // 关闭手牌号
    closeTheHandNumber() {
      this.addOdd = "";
      this.theHandNumberPopsUp = false;
    },
    // 监听扫码枪
    monitorScannerGunCheckList(keys) {
      console.log("挂单列表", keys);
      let key = keys[keys.length - 3] + keys[keys.length - 2] + keys[keys.length - 1];
      this.odd = key;
      if (this.type !== 1) return;
      this.handCheckList(key, true);
    },
    // 自动取单
    automaticOrderCollection() {
      console.log("立即取单");
      this.takeTheOrder(this.pendingOrderList[0], this.pendingOrderList[0].handBrand);
    },
    /** ***************************************************** 轮牌 ***************************************************** **/
    // 未分配业绩
    isInputShow() {
      if (this.performance > 0) {
        this.isInput = true;
      }
    },
    isInputAddTo() {
      let len = this.DepartmentalList.length;
      let sum = this.isDepartmentalPerformance.reduce((sum, item) => sum + parseInt(item.achievement), 0);
      let i = this.isDepartmentalPerformance.filter((element) => element.unAchievement !== 0);
      console.log("sum", sum);
      for (let i = 0; i < len; i++) {
        this.DepartmentalList[i].achievement = Number(this.DepartmentalList[i].achievement) + Number(this.isDepartmentalPerformance[i].achievement);
      }
      // this.DepartmentalList[len - 1].unAchievement = this.isDepartmentalPerformance[len - 1].unAchievement - sum;
      this.DepartmentalList[len - 1].unAchievement = this.performance - sum;
      if (this.performance - sum > 0) {
        this.DepartmentalList[len - 1].unAchievement = this.performance - sum;
      } else {
        this.DepartmentalList[len - 1].unAchievement = 0;
      }

      this.performance -= sum;
      // console.log("this.performance", this.performance);
      this.isDepartmentalPerformance.forEach((item) => {
        item.achievement = 0;
      });
      this.isInput = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// 重复流水单号开始
.repatInput {
  width: 130px;
  height: 32px;
  line-height: 32px;
  position: absolute;
  right: -140px;
  color: red;
  border: 1px solid red;
  text-align: center;
  background-color: #fff;
  border-radius: 3px;
}

.repatInputafter {
  position: absolute;
  left: -11px;
  top: 49%;
  width: 12px;
  height: 12px;
  background-color: #fff;
  border-top: 1px solid transparent;
  border-left: 1px solid red;
  border-right: 1px solid transparent;
  border-bottom: 1px solid red;
  -webkit-transform: rotate(45deg) translateY(-50%);
  transform: rotate(45deg) translateY(-50%);
}

.isShowx {
  display: none;
}

// 重复流水单号结束
.el-loading-spinner {
  >i.el-icon-loading {
    font-size: 28px !important;
  }

  >p.el-loading-text {
    font-size: 28px !important;
  }
}

// 业绩
.achievements {
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 28px;
  padding-left: 20px;

  .unassigned {
    margin-bottom: 5px;
  }

  /deep/ .el-input .el-input__inner {
    padding: 0 10px;
    font-size: 15px;
  }

  .assigned {
    display: flex;
    align-items: center;

    .div-Posting {
      position: relative;
      height: 28px;
      line-height: 24px;
      cursor: pointer;
    }
  }

  span {
    margin-right: 2px;
    font-size: 15px;
    font-weight: bold;
  }

  u {
    font-size: 15px;
    font-weight: bold;
  }

  &:last-child {
    margin: 0;
  }
}

// 部门弹窗
.inputShow {
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  // height: 400px;
  .line_between {
    width: 1px;
    height: 200px;
    background-color: #ccc;
  }
}
.content-card-item {
  button {
    padding: 6px 16px;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #67c23a;
    color: #fff;

    // 当 isShow 为 true 时（显示状态）
    &.show {
      background: #ee4806;

      &:hover {
        background: #c90909;
      }
    }

    &:not(.show) {
      background: #0beb29;

      &:hover {
        background: #0dd81e;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/paperless/components/orderPending.vue